/*! Board International SA */
webpackJsonp([8],{

/***/ "./Content/background.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "83e39217dcf4ac11bb7e12c5f5937e97.svg";

/***/ }),

/***/ "./Content/boardLogo.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "241c3619e96312cee5265ef174f56ddf.svg";

/***/ }),

/***/ "./Content/icons/sets/admin-icons.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "829fc49e40437a9d52569a72aea10ebd.svg";

/***/ }),

/***/ "./Content/icons/sets/board-icons.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2e2bf7d2962c0a54b12327928a009c70.svg";

/***/ }),

/***/ "./Content/icons/sets/cloud-icons.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4cdcde8a6fcb89a1fbc3385d875ec1b1.svg";

/***/ }),

/***/ "./Content/icons/sets/content-icons.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "05ba5b31b7ce6d92f6eab1914999bbdb.svg";

/***/ }),

/***/ "./app/anonymous-app.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildAnonymousAppModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_core_module__ = __webpack_require__("./app/core/core.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_app_common__ = __webpack_require__("./app/common/app.common.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_theme_config__ = __webpack_require__("./app/app-theme.config.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__require_reset_password_require_reset_password_module__ = __webpack_require__("./app/require-reset-password/require-reset-password.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__register_register_module__ = __webpack_require__("./app/register/register.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__change_password_change_password_module__ = __webpack_require__("./app/change-password/change-password.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__complete_profile_complete_profile_module__ = __webpack_require__("./app/complete-profile/complete-profile.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reset_password_reset_password_module__ = __webpack_require__("./app/reset-password/reset-password.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__email_confirmed_email_confirmed_module__ = __webpack_require__("./app/email-confirmed/email-confirmed.module.ts");










var configLocationProvider = function configLocationProvider($locationProvider) {
    $locationProvider.hashPrefix("");
};
configLocationProvider.$inject = ["$locationProvider"];
var buildAnonymousAppModule = function buildAnonymousAppModule(adminUserManager) {
    __WEBPACK_IMPORTED_MODULE_1__core_core_module__["a" /* default */].constant('USERNAME_CLAIM_TYPE', 'preferred_username');
    return __WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.anonymous", [__WEBPACK_IMPORTED_MODULE_1__core_core_module__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__common_app_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__require_reset_password_require_reset_password_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__register_register_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__change_password_change_password_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__complete_profile_complete_profile_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__reset_password_reset_password_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__email_confirmed_email_confirmed_module__["a" /* default */]]).constant("BoardWebAdminUserManager", adminUserManager).config(configLocationProvider).config(__WEBPACK_IMPORTED_MODULE_3__app_theme_config__["b" /* configTheme */]).config(__WEBPACK_IMPORTED_MODULE_3__app_theme_config__["a" /* configIcons */]).name;
};

/***/ }),

/***/ "./app/app-shell.route.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APP_SHELL_STATE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = configureAppShell;
var APP_SHELL_STATE = "app_shell_state";
function configureAppShell($stateProvider) {
    $stateProvider.state(APP_SHELL_STATE, {
        abstract: true,
        views: {
            "": {
                template: "<div layout=\"column\" layout-fill>\n                    <brd-header></brd-header>\n                    <section layout=\"row\" flex >\n                        <brd-sidenav></brd-sidenav>\n                        <md-content flex class=\"b-padding16\">\n                            <ui-view name=\"content\"></ui-view>\n                        </md-content>\n                    </section>\n                </div>"
            }
        }
    });
}
configureAppShell.$inject = ["$stateProvider"];

/***/ }),

/***/ "./app/app-theme.config.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = configTheme;
/* harmony export (immutable) */ __webpack_exports__["a"] = configIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Content_icons_sets_board_icons_svg__ = __webpack_require__("./Content/icons/sets/board-icons.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Content_icons_sets_board_icons_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Content_icons_sets_board_icons_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Content_icons_sets_content_icons_svg__ = __webpack_require__("./Content/icons/sets/content-icons.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Content_icons_sets_content_icons_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Content_icons_sets_content_icons_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Content_icons_sets_cloud_icons_svg__ = __webpack_require__("./Content/icons/sets/cloud-icons.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Content_icons_sets_cloud_icons_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Content_icons_sets_cloud_icons_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Content_icons_sets_admin_icons_svg__ = __webpack_require__("./Content/icons/sets/admin-icons.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Content_icons_sets_admin_icons_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Content_icons_sets_admin_icons_svg__);




function configTheme($mdThemingProvider) {
    //debugger;
    //$mdThemingProvider.theme('default')
    //    .primaryPalette('pink')
    //    .accentPalette('orange');
    $mdThemingProvider.alwaysWatchTheme(false);
    var customPrimary = {
        '50': "#a4ccea",
        '100': "#8fc1e6",
        '200': "#7ab5e1",
        '300': "#66a9dc",
        '400': "#519ed8",
        '500': "#3c92d3",
        '600': "#2d86c8",
        '700': "#2978b3",
        '800': "#246a9f",
        '900': "#1f5c8a",
        'A100': "#b9d8ef",
        'A200': "#cee3f4",
        'A400': "#e2eff9",
        'A700': "#1a4e75"
    };
    $mdThemingProvider.definePalette("customPrimary", customPrimary);
    var customAccent = {
        '50': "#fbcf9a",
        '100': "#fbc381",
        '200': "#fab769",
        '300': "#f9ab50",
        '400': "#f8a038",
        '500': "#f7941f",
        '600': "#f48809",
        '700': "#db7a08",
        '800': "#c26d07",
        '900': "#aa5f06",
        'A100': "#fcdbb3",
        'A200': "#fde6cb",
        'A400': "#fef2e4",
        'A700': "#915105"
    };
    $mdThemingProvider.definePalette("customAccent", customAccent);
    var customWarn = {
        '50': "#f6b5af",
        '100': "#f3a098",
        '200': "#f08b81",
        '300': "#ed766b",
        '400': "#eb6154",
        '500': "#e84c3d",
        '600': "#e53726",
        '700': "#d82a1a",
        '800': "#c22617",
        '900': "#ab2114",
        'A100': "#f8cac6",
        'A200': "#fbdfdd",
        'A400': "#fef4f3",
        'A700': "#941d12"
    };
    $mdThemingProvider.definePalette("customWarn", customWarn);
    var customBackground = {
        '50': '#ffffff',
        '100': '#ffffff',
        '200': '#ffffff',
        '300': '#ffffff',
        '400': '#ffffff',
        '500': '#ffffff',
        '600': '#f2f2f2',
        '700': '#e6e6e6',
        '800': '#d9d9d9',
        '900': '#cccccc',
        'A100': '#ffffff',
        'A200': '#ffffff',
        'A400': '#ffffff',
        'A700': '#bfbfbf'
    };
    $mdThemingProvider.definePalette("customBackground", customBackground);
    $mdThemingProvider.theme("default").primaryPalette("customPrimary").accentPalette("customAccent").warnPalette("customWarn");
    //.backgroundPalette("customBackground");
    // $mdThemingProvider.definePalette("warnToastPrimaryPalette", $mdThemingProvider.extendPalette("red", { "500": "3c92d3" }));
    $mdThemingProvider.setDefaultTheme("default");
}
configTheme.$inject = ["$mdThemingProvider"];
function configIcons($mdIconProvider) {
    $mdIconProvider.iconSet("content", __webpack_require__("./Content/icons/sets/content-icons.svg"), 24).iconSet("board", __webpack_require__("./Content/icons/sets/board-icons.svg"), 24).iconSet("admin", __webpack_require__("./Content/icons/sets/admin-icons.svg"), 24).iconSet("board-cloud", __webpack_require__("./Content/icons/sets/cloud-icons.svg"), 24);
}
configIcons.$inject = ["$mdIconProvider"];

/***/ }),

/***/ "./app/app.config.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configRoute;
function configRoute($stateProvider, $urlRouterProvider, $locationProvider) {
    $urlRouterProvider.otherwise("/dashboard");
    $locationProvider.hashPrefix("");
}
configRoute.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider"];

/***/ }),

/***/ "./app/app.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/app.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/app.less", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/app.less");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/authorized-app.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildAuthorizedAppModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_core_authInterceptor__ = __webpack_require__("./app/core/core.authInterceptor.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_module__ = __webpack_require__("./app/dashboard/dashboard.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_config__ = __webpack_require__("./app/app.config.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_core_module__ = __webpack_require__("./app/core/core.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_app_common__ = __webpack_require__("./app/common/app.common.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__manage_manage_module__ = __webpack_require__("./app/manage/manage.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__change_password_change_password_module__ = __webpack_require__("./app/change-password/change-password.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logs_logs_module__ = __webpack_require__("./app/logs/logs.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__beng_logs_beng_logs_module__ = __webpack_require__("./app/beng-logs/beng-logs.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_users_module__ = __webpack_require__("./app/users/users.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__scheduler_scheduler_module__ = __webpack_require__("./app/scheduler/scheduler.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__backup_and_restore_backup_and_restore_module__ = __webpack_require__("./app/backup-and-restore/backup-and-restore.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__instance_settings_instance_settings_module__ = __webpack_require__("./app/instance-settings/instance-settings.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_storage_shared_storage_module__ = __webpack_require__("./app/shared-storage/shared-storage.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_direct_data_direct_module__ = __webpack_require__("./app/data-direct/data-direct.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__capsule_capsule_module__ = __webpack_require__("./app/capsule/capsule.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__app_theme_config__ = __webpack_require__("./app/app-theme.config.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__app_shell_route__ = __webpack_require__("./app/app-shell.route.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__hierarchy_modal_hierarchyModal_module__ = __webpack_require__("./app/hierarchy-modal/hierarchyModal.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__hierarchy_nav_hierarchySideNav_module__ = __webpack_require__("./app/hierarchy-nav/hierarchySideNav.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__hierarchy_grid_hierarchy_module__ = __webpack_require__("./app/hierarchy-grid/hierarchy.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__capsule_manager_guide_capsuleManagerGuide_module__ = __webpack_require__("./app/capsule-manager-guide/capsuleManagerGuide.module.ts");























var buildAuthorizedAppModule = function buildAuthorizedAppModule(adminUserManager, adminUser, webUserManager, boardWebEndpoint, user, idpEndpoint) {
    __WEBPACK_IMPORTED_MODULE_4__core_core_module__["a" /* default */].constant("BoardWebAdminUserManager", adminUserManager);
    __WEBPACK_IMPORTED_MODULE_4__core_core_module__["a" /* default */].constant("BoardWebUserManager", webUserManager);
    __WEBPACK_IMPORTED_MODULE_4__core_core_module__["a" /* default */].constant("WEB_ENDPOINT", boardWebEndpoint);
    __WEBPACK_IMPORTED_MODULE_4__core_core_module__["a" /* default */].constant("BoardWebAdminUser", adminUser);
    __WEBPACK_IMPORTED_MODULE_4__core_core_module__["a" /* default */].constant("BoardWebUser", user);
    __WEBPACK_IMPORTED_MODULE_4__core_core_module__["a" /* default */].constant("IDP_ENDPOINT", idpEndpoint);
    __WEBPACK_IMPORTED_MODULE_4__core_core_module__["a" /* default */].constant('USERNAME_CLAIM_TYPE', idpEndpoint ? 'name' : 'preferred_username');
    return __WEBPACK_IMPORTED_MODULE_1_angular__["module"]("board.web.admin", [__WEBPACK_IMPORTED_MODULE_4__core_core_module__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__common_app_common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__manage_manage_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__logs_logs_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__beng_logs_beng_logs_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__users_users_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__scheduler_scheduler_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__hierarchy_modal_hierarchyModal_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__hierarchy_nav_hierarchySideNav_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__capsule_manager_guide_capsuleManagerGuide_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__hierarchy_grid_hierarchy_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__backup_and_restore_backup_and_restore_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__change_password_change_password_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__instance_settings_instance_settings_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__shared_storage_shared_storage_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__data_direct_data_direct_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__capsule_capsule_module__["a" /* default */]]).config(["$httpProvider", function ($httpProvider) {
        $httpProvider.interceptors.push(__WEBPACK_IMPORTED_MODULE_0__core_core_authInterceptor__["a" /* AuthInterceptor */].factory());
    }]).config(__WEBPACK_IMPORTED_MODULE_18__app_shell_route__["b" /* configureAppShell */]).config(__WEBPACK_IMPORTED_MODULE_3__app_config__["a" /* configRoute */]).config(__WEBPACK_IMPORTED_MODULE_17__app_theme_config__["b" /* configTheme */]).config(__WEBPACK_IMPORTED_MODULE_17__app_theme_config__["a" /* configIcons */]).name;
};

/***/ }),

/***/ "./app/backup-and-restore/backup-and-restore.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backup_and_restore_router__ = __webpack_require__("./app/backup-and-restore/backup-and-restore.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_core_module__ = __webpack_require__("./app/core/core.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_app_common__ = __webpack_require__("./app/common/app.common.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__backup_and_restore_service__ = __webpack_require__("./app/backup-and-restore/backup-and-restore.service.ts");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.backupAndRestore", [__WEBPACK_IMPORTED_MODULE_2__core_core_module__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__common_app_common__["a" /* default */]]).config(__WEBPACK_IMPORTED_MODULE_1__backup_and_restore_router__["b" /* configRoute */]).service(__WEBPACK_IMPORTED_MODULE_4__backup_and_restore_service__["a" /* BACKUP_AND_RESTORE_SERVICE */], __WEBPACK_IMPORTED_MODULE_4__backup_and_restore_service__["b" /* BackupAndRestoreService */]).name);

/***/ }),

/***/ "./app/backup-and-restore/backup-and-restore.router.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BACKUP_AND_RESTORE_STATE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = configRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shell_route__ = __webpack_require__("./app/app-shell.route.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_header_service__ = __webpack_require__("./app/core/header.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_lazy_route_helper__ = __webpack_require__("./app/core/lazy-route.helper.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_auth_service__ = __webpack_require__("./app/core/auth.service.ts");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




var BACKUP_AND_RESTORE_STATE = "backupAndRestorestate";
function configRoute($stateProvider) {
    var _this = this;

    $stateProvider.state(BACKUP_AND_RESTORE_STATE, {
        parent: __WEBPACK_IMPORTED_MODULE_0__app_shell_route__["a" /* APP_SHELL_STATE */],
        url: "/backup-and-restore",
        views: {
            content: {
                component: "backupAndRestoreComponent",
                bindings: {
                    boardWebUser: "boardWebUser"
                }
            }
        },
        lazyLoad: function lazyLoad(transition, state) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var moduleExports;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "./app/backup-and-restore/backup-and-restore.component.ts"));

                            case 2:
                                moduleExports = _context.sent;

                                Object(__WEBPACK_IMPORTED_MODULE_2__core_lazy_route_helper__["a" /* registerComponentFromTransition */])(transition, "backupAndRestoreComponent", moduleExports.backupAndRestoreComponentOptions);
                                return _context.abrupt('return', moduleExports);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        },
        onEnter: [__WEBPACK_IMPORTED_MODULE_1__core_header_service__["a" /* HEADER_SERVICE */], function (headerService) {
            headerService.headerTitle = "Backup and restore";
        }],
        resolve: {
            boardWebUser: __WEBPACK_IMPORTED_MODULE_3__core_auth_service__["c" /* boardWebLogin */]
        }
    });
}
configRoute.$inject = ["$stateProvider"];

/***/ }),

/***/ "./app/backup-and-restore/backup-and-restore.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BACKUP_AND_RESTORE_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BackupAndRestoreService; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BACKUP_AND_RESTORE_SERVICE = "backupAndRestoreService";
var BackupAndRestoreService = function () {
    function BackupAndRestoreService($mdToast, $q, $http, boardWebEndpoint) {
        _classCallCheck(this, BackupAndRestoreService);

        this.$mdToast = $mdToast;
        this.$q = $q;
        this.$http = $http;
        this.boardWebEndpoint = boardWebEndpoint;
        this.workInProgress = false;
        this.workInProgressMsg = "";
    }

    _createClass(BackupAndRestoreService, [{
        key: "availableDatabases",
        value: function availableDatabases() {
            return this.$http.get(this.boardWebEndpoint + "/admin/database/availableDatabases").then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "createBackup",
        value: function createBackup(databaseName) {
            var _this = this;

            return this.$http.get(this.boardWebEndpoint + "/admin/database/backup", { params: { databaseName: databaseName } }).then(function (response) {
                _this.workInProgress = false;
                _this.$mdToast.show(_this.$mdToast.simple().textContent("Backup successfully created!").position("top right"));
                return response.data;
            });
        }
    }, {
        key: "databaseRestoreList",
        value: function databaseRestoreList() {
            var _this2 = this;

            return this.$http.get(this.boardWebEndpoint + "/admin/database/databaseRestoreList").then(function (response) {
                return response.data;
            }, function (reason) {
                return _this2.$q.reject(reason);
            });
        }
    }, {
        key: "restoreBackup",
        value: function restoreBackup(restorePoint) {
            var _this3 = this;

            return this.$http.get(this.boardWebEndpoint + "/admin/database/restoreBackup", { params: { restorePoint: restorePoint } }).then(function (response) {
                _this3.workInProgress = false;
                _this3.$mdToast.show(_this3.$mdToast.simple().textContent("Backup successfully restored!").position("top right"));
                return response.data;
            });
        }
    }]);

    return BackupAndRestoreService;
}();
BackupAndRestoreService.$inject = ["$mdToast", "$q", "$http", "WEB_ENDPOINT"];

/***/ }),

/***/ "./app/beng-logs/beng-log-config-dialog.controller.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BENGLOG_DIALOG_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BengLogDialogService; });
/* unused harmony export BengLogConfigDialogController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_notification_service__ = __webpack_require__("./app/core/notification.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__beng_logs_service__ = __webpack_require__("./app/beng-logs/beng-logs.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__("./node_modules/file-saver/FileSaver.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__beng_logs_less__ = __webpack_require__("./app/beng-logs/beng-logs.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__beng_logs_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__beng_logs_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__beng_log_password_dialog_controller__ = __webpack_require__("./app/beng-logs/beng-log-password-dialog.controller.ts");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var BENGLOG_DIALOG_SERVICE = "bengLogDialogService";
var BengLogDialogService = function () {
    function BengLogDialogService($q, $timeout, $mdDialog) {
        _classCallCheck(this, BengLogDialogService);

        this.$q = $q;
        this.$timeout = $timeout;
        this.$mdDialog = $mdDialog;
    }

    _createClass(BengLogDialogService, [{
        key: "showConfigDialog",
        value: function showConfigDialog(boardWebUser, configurations) {
            if (__WEBPACK_IMPORTED_MODULE_0_angular__["isUndefined"](boardWebUser) || __WEBPACK_IMPORTED_MODULE_0_angular__["isUndefined"](configurations)) {
                return this.$q.reject();
            }
            return this.$mdDialog.show({
                controller: BengLogConfigDialogController,
                controllerAs: "$ctrl",
                template: __webpack_require__("./app/beng-logs/beng-log-config-dialog.html"),
                focusOnOpen: true,
                clickOutsideToClose: false,
                escapeToClose: true,
                bindToController: true,
                fullscreen: true,
                locals: { "boardWebUser": boardWebUser, "configurations": configurations }
            });
        }
    }]);

    return BengLogDialogService;
}();
BengLogDialogService.$inject = ["$q", "$timeout", "$mdDialog"];
var BengLogConfigDialogController = function () {
    function BengLogConfigDialogController($q, $timeout, $mdDialog, bengLogsService, notification, passwordDialogService) {
        var _this = this;

        _classCallCheck(this, BengLogConfigDialogController);

        this.$q = $q;
        this.$timeout = $timeout;
        this.$mdDialog = $mdDialog;
        this.bengLogsService = bengLogsService;
        this.notification = notification;
        this.passwordDialogService = passwordDialogService;
        this.enableLogEncryptionKey = "Enable Log Encryption";
        this.logsAreEncrypted = Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["some"])(this.configurations, function (c) {
            return c.key === _this.enableLogEncryptionKey && c.enabled;
        });
        this.applyDisabled = true;
    }

    _createClass(BengLogConfigDialogController, [{
        key: "configChanged",
        value: function configChanged(mode) {
            var _this2 = this;

            this.applyDisabled = false;
            if (mode.key !== this.enableLogEncryptionKey) {
                return;
            }
            if (mode.enabled) {
                this.passwordDialogService.showSetPasswordDialog(this.boardWebUser).then(function (args) {
                    _this2.bengLogsService.enableEncryption(args).then(function () {
                        _this2.setEncryptionMode(true);
                    }, function (response) {
                        _this2.encryptionFails(response.data.message);
                        _this2.setEncryptionMode(false);
                    });
                }, function (message) {
                    _this2.encryptionFails(message);
                    _this2.setEncryptionMode(false);
                });
            } else {
                this.passwordDialogService.showRemovePasswordDialog(this.boardWebUser).then(function (args) {
                    _this2.bengLogsService.disableEncryption(args).then(function () {
                        _this2.setEncryptionMode(false);
                    }, function (response) {
                        _this2.encryptionFails(response.data.message);
                        _this2.setEncryptionMode(true);
                    });
                }, function (message) {
                    _this2.encryptionFails(message);
                    _this2.setEncryptionMode(true);
                });
            }
        }
    }, {
        key: "changeEncryptionPassword",
        value: function changeEncryptionPassword() {
            var _this3 = this;

            this.passwordDialogService.showChangePasswordDialog(this.boardWebUser).then(function (args) {
                _this3.bengLogsService.updateEncryptionPassword(args).then(function () {
                    _this3.notification.show("Password updated!");
                }, function (response) {
                    _this3.encryptionFails(response.data.message);
                });
            }, function (message) {
                return _this3.encryptionFails(message);
            });
        }
    }, {
        key: "encryptionFails",
        value: function encryptionFails(errorMessage) {
            if (errorMessage.length > 0) {
                this.notification.error(errorMessage);
            }
        }
    }, {
        key: "setEncryptionMode",
        value: function setEncryptionMode(enabled) {
            var _this4 = this;

            var mode = Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["find"])(this.configurations, function (c) {
                return c.key === _this4.enableLogEncryptionKey;
            });
            if (mode) {
                mode.enabled = enabled;
            }
            this.logsAreEncrypted = enabled;
        }
    }, {
        key: "downloadDecrypter",
        value: function downloadDecrypter() {
            this.bengLogsService.downloadDecrypter().then(function (binary) {
                __WEBPACK_IMPORTED_MODULE_4_file_saver__["saveAs"](binary, "Decrypter.exe");
            });
        }
    }, {
        key: "applyChanges",
        value: function applyChanges() {
            var _this5 = this;

            this.bengLogsService.setConfigurations(this.configurations).then(function () {
                _this5.notification.show("Changes has been saved!");
                _this5.$mdDialog.hide();
            }, function (response) {
                _this5.notification.error(response.data.message);
            });
        }
    }, {
        key: "cancel",
        value: function cancel() {
            this.$mdDialog.cancel();
        }
    }]);

    return BengLogConfigDialogController;
}();
BengLogConfigDialogController.$inject = ["$q", "$timeout", "$mdDialog", __WEBPACK_IMPORTED_MODULE_2__beng_logs_service__["a" /* BENG_LOGS_SERVICE */], __WEBPACK_IMPORTED_MODULE_1__core_notification_service__["a" /* NOTIFICATION_SERVICE */], __WEBPACK_IMPORTED_MODULE_6__beng_log_password_dialog_controller__["a" /* BENGLOG_PASSWORD_DIALOG_SERVICE */]];

/***/ }),

/***/ "./app/beng-logs/beng-log-config-dialog.html":
/***/ (function(module, exports) {

module.exports = "<div class=brd-log-dialog-container layout=column> <div layout=row ng-repeat=\"config in ::$ctrl.configurations\"> <md-checkbox ng-model=config.enabled class=\"log-mode md-primary\" ng-change=$ctrl.configChanged(config)> {{ ::config.key }} </md-checkbox> <div flex></div> <md-button ng-if=\"config.key === $ctrl.enableLogEncryptionKey\" class=\"b-framed change-password\" ng-click=$ctrl.changeEncryptionPassword() ng-disabled=!$ctrl.logsAreEncrypted> Change Password </md-button> </div> <div layout=row layout-align=\"start center\" class=actions> <md-button class=b-framed ng-click=$ctrl.downloadDecrypter()>Download Decrypter</md-button> <div flex></div> <md-button class=b-warn ng-click=$ctrl.cancel()>Cancel</md-button> <md-button class=b-primary ng-disabled=$ctrl.applyDisabled ng-click=$ctrl.applyChanges()>Apply</md-button> </div> </div> ";

/***/ }),

/***/ "./app/beng-logs/beng-log-password-dialog.controller.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BENGLOG_PASSWORD_DIALOG_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BengLogPasswordDialogService; });
/* unused harmony export BengLogPasswordDialogController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__beng_logs_less__ = __webpack_require__("./app/beng-logs/beng-logs.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__beng_logs_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__beng_logs_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var BENGLOG_PASSWORD_DIALOG_SERVICE = "bengLogPasswordDialogService";
var BengLogPasswordDialogService = function () {
    function BengLogPasswordDialogService($q, $mdDialog) {
        _classCallCheck(this, BengLogPasswordDialogService);

        this.$q = $q;
        this.$mdDialog = $mdDialog;
    }

    _createClass(BengLogPasswordDialogService, [{
        key: "showSetPasswordDialog",
        value: function showSetPasswordDialog(boardWebUser) {
            return this.showConfigDialog(boardWebUser, "Enable encryption", "New password", "Confirm password", function (firstPassword, secondPassword) {
                return { valid: firstPassword === secondPassword, errorMessage: "Password does not match the confirm password." };
            });
        }
    }, {
        key: "showRemovePasswordDialog",
        value: function showRemovePasswordDialog(boardWebUser) {
            return this.showConfigDialog(boardWebUser, "Disable encryption", "Password", "", function (firstPassword, secondPassword) {
                return { valid: true, errorMessage: "" };
            });
        }
    }, {
        key: "showChangePasswordDialog",
        value: function showChangePasswordDialog(boardWebUser) {
            return this.showConfigDialog(boardWebUser, "Change password", "Old Password", "New Password", function (firstPassword, secondPassword) {
                return { valid: true, errorMessage: "" };
            });
        }
    }, {
        key: "showConfigDialog",
        value: function showConfigDialog(boardWebUser, title, firstPasswordKey, secondPasswordKey, validation) {
            if (__WEBPACK_IMPORTED_MODULE_0_angular__["isUndefined"](boardWebUser)) {
                return this.$q.reject();
            }
            return this.$mdDialog.show({
                controller: BengLogPasswordDialogController,
                controllerAs: "$ctrl",
                template: __webpack_require__("./app/beng-logs/beng-log-password-dialog.html"),
                focusOnOpen: true,
                clickOutsideToClose: false,
                escapeToClose: false,
                bindToController: true,
                fullscreen: true,
                multiple: true,
                locals: {
                    "title": title,
                    "boardWebUser": boardWebUser,
                    "firstPasswordKey": firstPasswordKey,
                    "secondPasswordKey": secondPasswordKey,
                    "validation": validation
                }
            });
        }
    }]);

    return BengLogPasswordDialogService;
}();
BengLogPasswordDialogService.$inject = ["$q", "$mdDialog"];
var BengLogPasswordDialogController = function () {
    function BengLogPasswordDialogController($mdDialog) {
        _classCallCheck(this, BengLogPasswordDialogController);

        this.$mdDialog = $mdDialog;
        this.firstPasswordEnabled = this.firstPasswordKey !== undefined && this.firstPasswordKey.length > 0;
        this.secondPasswordEnabled = this.secondPasswordKey !== undefined && this.secondPasswordKey.length > 0;
        this.applyDisabled = true;
    }

    _createClass(BengLogPasswordDialogController, [{
        key: "valueChanged",
        value: function valueChanged() {
            var firstPasswordHasInvalidValue = this.firstPasswordEnabled && (this.firstPassword === undefined || this.firstPassword.length === 0);
            var secondPasswordHasValidValue = this.secondPasswordEnabled && (this.secondPassword === undefined || this.secondPassword.length === 0);
            this.applyDisabled = firstPasswordHasInvalidValue || secondPasswordHasValidValue;
        }
    }, {
        key: "applyChanges",
        value: function applyChanges() {
            var result = this.validation(this.firstPassword, this.secondPassword);
            if (!result.valid) {
                return this.$mdDialog.cancel(result.errorMessage);
            }
            var args = {
                firstPassword: this.firstPassword,
                secondPassword: this.secondPassword
            };
            return this.$mdDialog.hide(args);
        }
    }, {
        key: "cancel",
        value: function cancel() {
            this.$mdDialog.cancel("");
        }
    }]);

    return BengLogPasswordDialogController;
}();
BengLogPasswordDialogController.$inject = ["$mdDialog"];

/***/ }),

/***/ "./app/beng-logs/beng-log-password-dialog.html":
/***/ (function(module, exports) {

module.exports = "<div class=brd-log-password-container layout=column> <h1 class=title>{{ ::$ctrl.title }}</h1> <form layout=column class=form> <input type=text name=email value={{::$ctrl.boardWebUser.profile.sub}} autocomplete=\"username email\" style=display:none> <md-input-container ng-if=::$ctrl.firstPasswordEnabled> <label>{{ ::$ctrl.firstPasswordKey }}</label> <input type=password autocomplete=current-password name=\"first password\" ng-model=$ctrl.firstPassword required ng-model-options=\"{ debounce: 300 }\" ng-change=$ctrl.valueChanged() /> </md-input-container> <md-input-container ng-if=::$ctrl.secondPasswordEnabled> <label>{{ ::$ctrl.secondPasswordKey }}</label> <input type=password autocomplete=current-password name=\"second password\" ng-model=$ctrl.secondPassword required ng-model-options=\"{ debounce: 300 }\" ng-change=$ctrl.valueChanged() /> </md-input-container> </form> <div layout=row layout-align=\"end center\" class=actions> <md-button class=b-warn ng-click=$ctrl.cancel()>Cancel</md-button> <md-button class=b-primary ng-disabled=$ctrl.applyDisabled ng-click=$ctrl.applyChanges()>Apply</md-button> </div> </div>";

/***/ }),

/***/ "./app/beng-logs/beng-logs.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/beng-logs/beng-logs.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/beng-logs/beng-logs.less", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/beng-logs/beng-logs.less");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/beng-logs/beng-logs.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__beng_logs_service__ = __webpack_require__("./app/beng-logs/beng-logs.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__beng_log_config_dialog_controller__ = __webpack_require__("./app/beng-logs/beng-log-config-dialog.controller.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__beng_log_password_dialog_controller__ = __webpack_require__("./app/beng-logs/beng-log-password-dialog.controller.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__beng_logs_router__ = __webpack_require__("./app/beng-logs/beng-logs.router.ts");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.bengLogs", []).service(__WEBPACK_IMPORTED_MODULE_1__beng_logs_service__["a" /* BENG_LOGS_SERVICE */], __WEBPACK_IMPORTED_MODULE_1__beng_logs_service__["b" /* BEngLogsService */]).service(__WEBPACK_IMPORTED_MODULE_2__beng_log_config_dialog_controller__["a" /* BENGLOG_DIALOG_SERVICE */], __WEBPACK_IMPORTED_MODULE_2__beng_log_config_dialog_controller__["b" /* BengLogDialogService */]).service(__WEBPACK_IMPORTED_MODULE_3__beng_log_password_dialog_controller__["a" /* BENGLOG_PASSWORD_DIALOG_SERVICE */], __WEBPACK_IMPORTED_MODULE_3__beng_log_password_dialog_controller__["b" /* BengLogPasswordDialogService */]).config(__WEBPACK_IMPORTED_MODULE_4__beng_logs_router__["b" /* configRoute */]).name);

/***/ }),

/***/ "./app/beng-logs/beng-logs.router.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BENGLOGS_STATE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = configRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shell_route__ = __webpack_require__("./app/app-shell.route.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__beng_logs_service__ = __webpack_require__("./app/beng-logs/beng-logs.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_lazy_route_helper__ = __webpack_require__("./app/core/lazy-route.helper.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_header_service__ = __webpack_require__("./app/core/header.service.ts");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




var BENGLOGS_STATE = "bengLogsState";
function configRoute($stateProvider) {
    var _this = this;

    $stateProvider.state(BENGLOGS_STATE, {
        parent: __WEBPACK_IMPORTED_MODULE_0__app_shell_route__["a" /* APP_SHELL_STATE */],
        url: "/bengLogs",
        views: {
            content: {
                component: "bengLogsComponent",
                bindings: {
                    logs: "logs"
                }
            }
        },
        onEnter: [__WEBPACK_IMPORTED_MODULE_3__core_header_service__["a" /* HEADER_SERVICE */], function (headerService) {
            headerService.headerTitle = "Board Logs";
        }],
        lazyLoad: function lazyLoad(transition, state) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var moduleExport;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "./app/beng-logs/beng-logs.component.ts"));

                            case 2:
                                moduleExport = _context.sent;

                                Object(__WEBPACK_IMPORTED_MODULE_2__core_lazy_route_helper__["a" /* registerComponentFromTransition */])(transition, "bengLogsComponent", moduleExport.bengLogsComponentOptions);
                                return _context.abrupt('return', moduleExport);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        },
        resolve: {
            logs: [__WEBPACK_IMPORTED_MODULE_1__beng_logs_service__["a" /* BENG_LOGS_SERVICE */], function (bengLogsService) {
                return bengLogsService.logs();
            }]
        }
    });
}
configRoute.$inject = ["$stateProvider"];

/***/ }),

/***/ "./app/beng-logs/beng-logs.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BENG_LOGS_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BEngLogsService; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BENG_LOGS_SERVICE = "bengLogsService";
var BEngLogsService = function () {
    function BEngLogsService($q, $http, boardWebEndpoint) {
        _classCallCheck(this, BEngLogsService);

        this.$q = $q;
        this.$http = $http;
        this.boardWebEndpoint = boardWebEndpoint;
    }

    _createClass(BEngLogsService, [{
        key: "logs",
        value: function logs() {
            return this.$http.get("api/BEngLog/get").then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "downloadAll",
        value: function downloadAll() {
            return this.$http.get("api/BEngLog/downloadall", {
                responseType: "arraybuffer",
                cache: false
            }).then(function (response) {
                return new Blob([response.data], { type: "application/zip" });
            });
        }
    }, {
        key: "download",
        value: function download(files) {
            var _this = this;

            return this.$http.post("api/BEngLog/download", files /*this.purgeFileModel(files)*/, {
                responseType: "arraybuffer",
                cache: false
            }).then(function (response) {
                var result = { blob: null, error: "" };
                if (response.status !== 200) {
                    result.error = response.statusText;
                    return _this.$q.reject(result);
                }
                result.blob = new Blob([response.data], { type: "application/zip" });
                return _this.$q.resolve(result);
            }, function (reason) {
                return _this.$q.reject(reason.statusText);
            });
        }
    }, {
        key: "clearAll",
        value: function clearAll() {
            return this.$http.get("api/BEngLog/deleteall");
        }
    }, {
        key: "clear",
        value: function clear(files) {
            var _this2 = this;

            return this.$http.post("api/BEngLog/delete", files /*this.purgeFileModel(files)*/).then(function (response) {
                return _this2.$q.resolve(response.data);
            }, function (reason) {
                return _this2.$q.reject(reason.data);
            });
        }
    }, {
        key: "getConfigurations",
        value: function getConfigurations() {
            return this.$http.get(this.boardWebEndpoint + "/admin/log/getConfigurations").then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "setConfigurations",
        value: function setConfigurations(modes) {
            return this.$http.post(this.boardWebEndpoint + "/admin/log/setConfigurations", modes);
        }
    }, {
        key: "enableEncryption",
        value: function enableEncryption(args) {
            return this.$http.post(this.boardWebEndpoint + "/admin/log/enableEncryption", args);
        }
    }, {
        key: "disableEncryption",
        value: function disableEncryption(args) {
            return this.$http.post(this.boardWebEndpoint + "/admin/log/disableEncryption", args);
        }
    }, {
        key: "updateEncryptionPassword",
        value: function updateEncryptionPassword(args) {
            return this.$http.post(this.boardWebEndpoint + "/admin/log/updateEncryptionPassword", args);
        }
    }, {
        key: "downloadDecrypter",
        value: function downloadDecrypter() {
            return this.$http.get("api/BEngLog/Decrypter", {
                responseType: "arraybuffer",
                cache: false
            }).then(function (response) {
                return new Blob([response.data], { type: "application/zip" });
            });
        }
    }]);

    return BEngLogsService;
}();
BEngLogsService.$inject = ["$q", "$http", "WEB_ENDPOINT"];

/***/ }),

/***/ "./app/capsule-manager-guide/capsuleManagerGuide.component.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CAPSULE_MANAGER_GUIDE_COMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Description; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return capsuleManagerGuideComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__capsuleManagerGuide_less__ = __webpack_require__("./app/capsule-manager-guide/capsuleManagerGuide.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__capsuleManagerGuide_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__capsuleManagerGuide_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__capsule_capsule_service__ = __webpack_require__("./app/capsule/capsule.service.ts");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var CAPSULE_MANAGER_GUIDE_COMPONENT = "capsuleManagerGuideComponent";
var Description = function Description(title, description) {
    _classCallCheck(this, Description);

    this.title = title;
    this.description = description;
};

var CapsuleManagerGuideController = function () {
    function CapsuleManagerGuideController(capsuleService, $scope) {
        _classCallCheck(this, CapsuleManagerGuideController);

        this.capsuleService = capsuleService;
        this.$scope = $scope;
        this.currentIndex = 0;
        var _self_ = this;
        this.capsuleService.isShowHideGuide.subscribe(function (value) {
            $scope.$evalAsync(function () {
                return _self_.isVisible = value;
            });
        });
    }

    _createClass(CapsuleManagerGuideController, [{
        key: "showHideGuide",
        value: function showHideGuide() {
            this.capsuleService.showHideGuide();
        }
    }, {
        key: "next",
        value: function next() {
            if (this.currentIndex + 1 < this.descriptions.length) {
                this.currentIndex++;
            } else {
                this.skip();
                this.currentIndex = 0;
            }
        }
    }, {
        key: "isMultiplePages",
        value: function isMultiplePages() {
            return this.descriptions && this.descriptions.length > 1 ? true : false;
        }
    }, {
        key: "skip",
        value: function skip() {
            this.capsuleService.showHideGuide();
        }
    }]);

    return CapsuleManagerGuideController;
}();

CapsuleManagerGuideController.$inject = [__WEBPACK_IMPORTED_MODULE_1__capsule_capsule_service__["a" /* CAPSULE_SERVICE */], "$scope"];
var capsuleManagerGuideComponent = {
    controller: CapsuleManagerGuideController,
    template: __webpack_require__("./app/capsule-manager-guide/capsuleManagerGuide.html"),
    bindings: {
        descriptions: "="
    }
};

/***/ }),

/***/ "./app/capsule-manager-guide/capsuleManagerGuide.html":
/***/ (function(module, exports) {

module.exports = "<div id=guideModalContainer ng-if=$ctrl.isVisible> <div id=guideModal layout=column layout-align=\"center center\"> <md-card> <md-card-title> <md-card-title-text> <span style=text-align:left class=md-headline>{{$ctrl.descriptions[$ctrl.currentIndex].title}}</span> </md-card-title-text> </md-card-title> <md-card-content> <p style=text-align:justify;white-space:pre-line>{{$ctrl.descriptions[$ctrl.currentIndex].description}}</p> </md-card-content> <md-card-actions layout=row layout-align=\"end center\"> <md-button ng-if=$ctrl.isMultiplePages() ng-click=$ctrl.skip()>Skip</md-button> <md-button ng-if=$ctrl.isMultiplePages() ng-click=$ctrl.next()>Next</md-button> <md-button ng-if=!$ctrl.isMultiplePages() ng-click=$ctrl.next()>Ok</md-button> </md-card-actions> </md-card> </div> </div> <md-button ng-click=$ctrl.showHideGuide() id=questionBtn class=md-fab> <b>?</b> </md-button>";

/***/ }),

/***/ "./app/capsule-manager-guide/capsuleManagerGuide.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/capsule-manager-guide/capsuleManagerGuide.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/capsule-manager-guide/capsuleManagerGuide.less", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/capsule-manager-guide/capsuleManagerGuide.less");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/capsule-manager-guide/capsuleManagerGuide.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__capsuleManagerGuide_component__ = __webpack_require__("./app/capsule-manager-guide/capsuleManagerGuide.component.ts");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.capsuleManagerGuide", []).component(__WEBPACK_IMPORTED_MODULE_1__capsuleManagerGuide_component__["a" /* CAPSULE_MANAGER_GUIDE_COMPONENT */], __WEBPACK_IMPORTED_MODULE_1__capsuleManagerGuide_component__["c" /* capsuleManagerGuideComponent */]).name);

/***/ }),

/***/ "./app/capsule/capsule.component.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAPSULE_COMPONENT", function() { return CAPSULE_COMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "capsuleComponent", function() { return capsuleComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__capsule_less__ = __webpack_require__("./app/capsule/capsule.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__capsule_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__capsule_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__capsule_service__ = __webpack_require__("./app/capsule/capsule.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__capsule_manager_guide_capsuleManagerGuide_component__ = __webpack_require__("./app/capsule-manager-guide/capsuleManagerGuide.component.ts");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var CAPSULE_COMPONENT = "capsuleComponent";

var CapsuleController = function CapsuleController(capsuleService) {
    var _this = this;

    _classCallCheck(this, CapsuleController);

    this.capsuleService = capsuleService;
    this.capsuleService.$initializeCapsule();
    this.capsuleService.isShowHideGuide.subscribe(function (value) {
        _this.isShowHideGuide = value;
    });
    this.capsuleService.isShowHideModal.subscribe(function (value) {
        _this.isShowHideModal = value;
    });
    this.capsuleService.isLockScreen.subscribe(function (value) {
        _this.isLockScreen = value;
    });
    this.capsuleService.isDataAvailable.subscribe(function (value) {
        _this.isDataAvailable = value;
    });
    this.capsuleService.isDownloadProgress.subscribe(function (value) {
        _this.isDownloadProgress = value;
    });
    this.descriptions = [];
    // tslint:disable-next-line:max-line-length
    this.descriptions.push(new __WEBPACK_IMPORTED_MODULE_2__capsule_manager_guide_capsuleManagerGuide_component__["b" /* Description */]("Capsules Organizer", "Manage your Capsules: upload new Capsules, create copies, move to different folder, download, rename or delete Capsules in your Cloud Instance"));
    // tslint:disable-next-line:max-line-length
    this.descriptions.push(new __WEBPACK_IMPORTED_MODULE_2__capsule_manager_guide_capsuleManagerGuide_component__["b" /* Description */]("Actions", "Upload: Upload singles Capsules or .zip folders for multiple Capsules uploads. \n \n " +
    // tslint:disable-next-line:max-line-length
    "Create folder: Create new folders under your path and organize Capsules as desired. \n \n " +
    // tslint:disable-next-line:max-line-length
    "Download: Download single Capsules or entire folders to localhost.  \n \n " + "Move: Move Single Capsules or folders.  \n \n " + "Copy: Create a copy of Capsules or folders.  \n \n " + "Rename: Rename Capsules or folders.  \n \n "));
};

CapsuleController.$inject = [__WEBPACK_IMPORTED_MODULE_1__capsule_service__["a" /* CAPSULE_SERVICE */]];
var capsuleComponent = {
    controller: CapsuleController,
    template: __webpack_require__("./app/capsule/capsule.html")
};

/***/ }),

/***/ "./app/capsule/capsule.html":
/***/ (function(module, exports) {

module.exports = "<md-progress-linear id=progressLinear ng-disabled=!$ctrl.isDownloadProgress md-mode=query></md-progress-linear> <div id=progressContainer ng-if=!$ctrl.isDataAvailable> <md-progress-circular md-mode=indeterminate md-diameter=100 ng-disabled=$ctrl.isDataAvailable> </md-progress-circular> </div> <div id=hierarchyOverlay ng-if=$ctrl.isLockScreen></div> <hierarchy-modal-component ng-if=$ctrl.isShowHideModal></hierarchy-modal-component> <div layout=column layout-sm=column layout-fill layout-xs=column flex=auto style=height:100%> <div layout=row layout-align=\"center center\"> <hierarchy-controllers-component></hierarchy-controllers-component> <div flex></div> <capsule-manager-guide-component descriptions=$ctrl.descriptions></capsule-manager-guide-component> </div> <md-divider style=border-top-color:#6a6a6a;border-top-width:2px></md-divider> <div flex></div> <div layout=row style=height:100%> <hierarchy-sidenav-component id=hierarchySidenav></hierarchy-sidenav-component> <hierarchy-grid-component id=hierarchyGrid></hierarchy-grid-component> </div> </div>";

/***/ }),

/***/ "./app/capsule/capsule.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/capsule/capsule.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/capsule/capsule.less", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/capsule/capsule.less");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/capsule/capsule.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_controllers_hierarchyControllers_module__ = __webpack_require__("./app/hierarchy-controllers/hierarchyControllers.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hierarchy_grid_hierarchy_module__ = __webpack_require__("./app/hierarchy-grid/hierarchy.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hierarchy_modal_hierarchyModal_module__ = __webpack_require__("./app/hierarchy-modal/hierarchyModal.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hierarchy_nav_hierarchySideNav_module__ = __webpack_require__("./app/hierarchy-nav/hierarchySideNav.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__capsule_router__ = __webpack_require__("./app/capsule/capsule.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__capsule_service__ = __webpack_require__("./app/capsule/capsule.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__capsule_manager_guide_capsuleManagerGuide_module__ = __webpack_require__("./app/capsule-manager-guide/capsuleManagerGuide.module.ts");








/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.capsule", [__WEBPACK_IMPORTED_MODULE_2__hierarchy_grid_hierarchy_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__hierarchy_nav_hierarchySideNav_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__hierarchy_controllers_hierarchyControllers_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__hierarchy_modal_hierarchyModal_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__capsule_manager_guide_capsuleManagerGuide_module__["a" /* default */]]).service(__WEBPACK_IMPORTED_MODULE_6__capsule_service__["a" /* CAPSULE_SERVICE */], __WEBPACK_IMPORTED_MODULE_6__capsule_service__["b" /* CapsuleService */]).config(__WEBPACK_IMPORTED_MODULE_5__capsule_router__["b" /* configRoute */]).name);

/***/ }),

/***/ "./app/capsule/capsule.router.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CAPSULE_STATE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = configRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_lazy_route_helper__ = __webpack_require__("./app/core/lazy-route.helper.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shell_route__ = __webpack_require__("./app/app-shell.route.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_header_service__ = __webpack_require__("./app/core/header.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__capsule_component__ = __webpack_require__("./app/capsule/capsule.component.ts");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




var CAPSULE_STATE = "capsuleState";
function configRoute($stateProvider, $urlRouterProvider) {
    var _this = this;

    $stateProvider.state(CAPSULE_STATE, {
        parent: __WEBPACK_IMPORTED_MODULE_1__app_shell_route__["a" /* APP_SHELL_STATE */],
        url: "/capsule",
        views: {
            content: {
                component: __WEBPACK_IMPORTED_MODULE_3__capsule_component__["CAPSULE_COMPONENT"]
            }
        },
        lazyLoad: function lazyLoad(transition, state) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var moduleExports;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./app/capsule/capsule.component.ts"));

                            case 2:
                                moduleExports = _context.sent;

                                Object(__WEBPACK_IMPORTED_MODULE_0__core_lazy_route_helper__["a" /* registerComponentFromTransition */])(transition, __WEBPACK_IMPORTED_MODULE_3__capsule_component__["CAPSULE_COMPONENT"], moduleExports.capsuleComponent);
                                return _context.abrupt("return", moduleExports);

                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        },
        onEnter: [__WEBPACK_IMPORTED_MODULE_2__core_header_service__["a" /* HEADER_SERVICE */], function (headerService) {
            headerService.headerTitle = "Capsule Manager";
        }]
    });
}
configRoute.$inject = ["$stateProvider", "$urlRouterProvider"];

/***/ }),

/***/ "./app/capsule/capsule.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CAPSULE_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CapsuleService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__("./node_modules/rxjs/Rx.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__("./node_modules/file-saver/FileSaver.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils_constants__ = __webpack_require__("./app/common/utils/constants.ts");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var CAPSULE_SERVICE = "CapsuleService";
var CapsuleService = function () {
    function CapsuleService($http, $mdToast) {
        _classCallCheck(this, CapsuleService);

        this.$http = $http;
        this.$mdToast = $mdToast;
        this.isDataAvailable = new __WEBPACK_IMPORTED_MODULE_0_rxjs__["BehaviorSubject"](false);
        this.isLockScreen = new __WEBPACK_IMPORTED_MODULE_0_rxjs__["BehaviorSubject"](true);
        this.isDownloadProgress = new __WEBPACK_IMPORTED_MODULE_0_rxjs__["BehaviorSubject"](false);
        this.isShowHideGuide = new __WEBPACK_IMPORTED_MODULE_0_rxjs__["BehaviorSubject"](false);
        this.isShowHideModal = new __WEBPACK_IMPORTED_MODULE_0_rxjs__["BehaviorSubject"](false);
        this.existingCapsule = new __WEBPACK_IMPORTED_MODULE_0_rxjs__["Subject"]();
    }

    _createClass(CapsuleService, [{
        key: "showToast",
        value: function showToast(message) {
            this.$mdToast.show(this.$mdToast.simple().textContent(message).position("top right"));
        }
    }, {
        key: "lookupCapsuleByPath",
        value: function lookupCapsuleByPath(searchingPath, searchingPlace) {
            if (searchingPath === searchingPlace.relativePath) {
                return searchingPlace;
            } else if (searchingPlace.subFolders) {
                var searchingElement = null;
                for (var i = 0; searchingElement == null && i < searchingPlace.subFolders.length; ++i) {
                    searchingElement = this.lookupCapsuleByPath(searchingPath, searchingPlace.subFolders[i]);
                }
                return searchingElement;
            } else {
                return null;
            }
        }
    }, {
        key: "$initializeCapsule",
        value: function $initializeCapsule() {
            var _this = this;

            this.startingAsyncOperation();
            __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].fromPromise(this.$http.get("api/capsule/GetCapsuleFolders")).map(function (response) {
                _this.existingCapsule.next(response.data);
                _this.isDataAvailable.next(true);
                _this.isLockScreen.next(false);
            }).subscribe(function (succ) {
                _this.stoppingAsyncOperation();
            }, function (err) {
                _this.stoppingAsyncOperation();
            });
        }
    }, {
        key: "$getExistingCapsule",
        value: function $getExistingCapsule() {
            return this.existingCapsule.asObservable();
        }
    }, {
        key: "$upload",
        value: function $upload(capsuleFolder, file, override) {
            var _this2 = this;

            this.startingAsyncOperation();
            return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].fromPromise(this.$http({
                method: "POST",
                url: "api/capsule/upload",
                headers: { "Content-Type": undefined },
                data: { capsuleFolder: capsuleFolder, file: file },
                transformRequest: function transformRequest(data) {
                    var formData = new FormData();
                    formData.append("path", data.capsuleFolder.relativePath);
                    formData.append("file", file);
                    formData.append("override", JSON.stringify(override));
                    return formData;
                }
            })).map(function (response) {
                _this2.$initializeCapsule();
                return response.status;
            });
        }
    }, {
        key: "$move",
        value: function $move(sourceCapsule, destinationPath, override) {
            var _this3 = this;

            this.startingAsyncOperation();
            return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].fromPromise(this.$http({
                method: "POST",
                url: "api/capsule/move",
                headers: { "Content-Type": undefined },
                data: { sourceCapsule: sourceCapsule, destinationPath: destinationPath, override: override },
                transformRequest: function transformRequest(data) {
                    var formData = new FormData();
                    formData.append("sourceCapsule", JSON.stringify(sourceCapsule));
                    formData.append("destinationPath", destinationPath);
                    formData.append("override", JSON.stringify(override));
                    return formData;
                }
            })).map(function (response) {
                _this3.$initializeCapsule();
                return response.status;
            });
        }
    }, {
        key: "showHideGuide",
        value: function showHideGuide() {
            this.isShowHideGuide.next(!this.isShowHideGuide.getValue());
            this.isLockScreen.next(this.isShowHideGuide.getValue());
        }
    }, {
        key: "showHideModal",
        value: function showHideModal() {
            this.isShowHideModal.next(!this.isShowHideModal.getValue());
        }
    }, {
        key: "$createFolder",
        value: function $createFolder(destinationPath, folderName) {
            var _this4 = this;

            this.startingAsyncOperation();
            return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].fromPromise(this.$http({
                method: "POST",
                url: "api/capsule/createFolder",
                headers: { "Content-Type": undefined },
                data: { destinationPath: destinationPath, folderName: folderName },
                transformRequest: function transformRequest(data) {
                    var formData = new FormData();
                    formData.append("destinationPath", data.destinationPath);
                    formData.append("folderName", data.folderName);
                    return formData;
                }
            })).map(function (response) {
                _this4.$initializeCapsule();
                return response.status;
            });
        }
    }, {
        key: "$duplicate",
        value: function $duplicate(sourceCapsuleFolder, destinationPath, override) {
            var _this5 = this;

            this.startingAsyncOperation();
            return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].fromPromise(this.$http({
                method: "POST",
                url: "api/capsule/duplicate",
                headers: { "Content-Type": undefined },
                data: { sourceCapsuleFolder: sourceCapsuleFolder, destinationPath: destinationPath, override: override },
                transformRequest: function transformRequest(data) {
                    var formData = new FormData();
                    formData.append("sourceCapsule", JSON.stringify(sourceCapsuleFolder));
                    formData.append("destinationPath", destinationPath);
                    formData.append("override", JSON.stringify(override));
                    return formData;
                }
            })).map(function (response) {
                _this5.$initializeCapsule();
                return response.status;
            });
        }
    }, {
        key: "$rename",
        value: function $rename(renamingFolder, newName) {
            var _this6 = this;

            this.startingAsyncOperation();
            return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].fromPromise(this.$http({
                method: "POST",
                data: { renamingFolder: renamingFolder, newName: newName },
                url: "api/capsule/rename",
                headers: { "Content-Type": undefined },
                transformRequest: function transformRequest(data) {
                    var formData = new FormData();
                    formData.append("renamingFolder", JSON.stringify(renamingFolder));
                    formData.append("newName", newName);
                    return formData;
                }
            })).map(function (response) {
                _this6.$initializeCapsule();
                return response.status;
            });
        }
    }, {
        key: "$download",
        value: function $download(capsuleFolder, filename) {
            var _this7 = this;

            this.isDownloadProgress.next(true);
            __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].fromPromise(this.$http.post("api/capsule/download", JSON.stringify(capsuleFolder), { responseType: "arraybuffer", cache: false })).map(function (response) {
                var result = { blob: null, error: "" };
                if (response.status === 200) {
                    result.blob = new Blob([response.data], { type: "application/zip" });
                    return result;
                }
            }).subscribe(function (res) {
                _this7.showToast(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].DOWNLOAD_COMPLETED);
                __WEBPACK_IMPORTED_MODULE_1_file_saver__["saveAs"](res.blob, filename + __WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].ZIP_FORMAT);
                _this7.isDownloadProgress.next(false);
            }, function (err) {
                _this7.showToast(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].DOWNLOAD_ABORTED);
                _this7.isDownloadProgress.next(false);
            });
        }
    }, {
        key: "$delete",
        value: function $delete(deletionFolder) {
            var _this8 = this;

            this.startingAsyncOperation();
            return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].fromPromise(this.$http({
                method: "POST",
                data: JSON.stringify(deletionFolder),
                url: "api/capsule/delete"
            })).map(function (response) {
                _this8.$initializeCapsule();
                return response.status;
            });
        }
    }, {
        key: "startingAsyncOperation",
        value: function startingAsyncOperation() {
            this.isDataAvailable.next(false);
            this.isLockScreen.next(true);
        }
    }, {
        key: "stoppingAsyncOperation",
        value: function stoppingAsyncOperation() {
            this.isDataAvailable.next(true);
            this.isLockScreen.next(false);
        }
    }]);

    return CapsuleService;
}();
CapsuleService.$inject = ["$http", "$mdToast"];

/***/ }),

/***/ "./app/capsule/capsuleFolder.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CAPSULE_FILE */
/* unused harmony export CAPSULE_FOLDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CapsuleFolder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CapsuleFile; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CAPSULE_FILE = "CapsuleFile";
var CAPSULE_FOLDER = "CapsuleFolder";
var CapsuleFolder = function CapsuleFolder(name, relativePath) {
    _classCallCheck(this, CapsuleFolder);

    this.name = name;
    this.relativePath = relativePath;
    this.size = 0;
    this.modifiedDate = null;
    this.files = [];
    this.subFolders = [];
};
var CapsuleFile = function CapsuleFile(filename, extension) {
    _classCallCheck(this, CapsuleFile);

    this.name = filename;
    this.extension = extension;
    this.size = 0;
    this.modifiedDate = null;
};

/***/ }),

/***/ "./app/change-password/change-password.component.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE_PASSWORD_COMPONENT", function() { return CHANGE_PASSWORD_COMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changePasswordComponentOptions", function() { return changePasswordComponentOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__change_password_controller__ = __webpack_require__("./app/change-password/change-password.controller.ts");

var CHANGE_PASSWORD_COMPONENT = "changePasswordComponent";
var changePasswordComponentOptions = {
    controller: __WEBPACK_IMPORTED_MODULE_0__change_password_controller__["a" /* ChangePasswordController */],
    template: __webpack_require__("./app/change-password/change-password.html"),
    bindings: {
        email: "<"
    }
};

/***/ }),

/***/ "./app/change-password/change-password.controller.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChangePasswordController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__change_password_service__ = __webpack_require__("./app/change-password/change-password.service.ts");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var ChangePasswordController = function () {
    function ChangePasswordController($mdToast, changePasswordService) {
        _classCallCheck(this, ChangePasswordController);

        this.$mdToast = $mdToast;
        this.changePasswordService = changePasswordService;
    }

    _createClass(ChangePasswordController, [{
        key: "submit",
        value: function submit() {
            return this.changePasswordService.changePassword(this.oldPassword, this.newPassword, this.newPasswordConfirm);
        }
    }]);

    return ChangePasswordController;
}();
ChangePasswordController.$inject = ["$mdToast", __WEBPACK_IMPORTED_MODULE_0__change_password_service__["a" /* CHANGE_PASSWORD_SERVICE */]];

/***/ }),

/***/ "./app/change-password/change-password.html":
/***/ (function(module, exports) {

module.exports = "<div layout=column style=height:100%> <brd-header></brd-header> <section layout=column flex layout-align=\"center center\"> <md-content md-whiteframe=2 layout=column layout-align=\"center center\" layout-padding layout-margin class=brd-reset-passw-container> <brd-form on-submit=$ctrl.submit() form-invalid=$ctrl.form.$invalid ng-form=$ctrl.form class=brd-change-password-container> <brd-form-title>Your password is expired, please set a new password!</brd-form-title> <brd-form-inputs> <md-input-container> <label>Old Password</label> <input type=password ng-model=$ctrl.oldPassword name=oldPassword required autofocus/> <div ng-messages=$ctrl.form.oldPassword.$error ng-show=\"$ctrl.form.oldPassword.$invalid && $ctrl.form.oldPassword.$touched\"> <div ng-message=required>This field is required</div> </div> </md-input-container> <md-input-container> <label>New password</label> <input type=password ng-model=$ctrl.newPassword name=newPassword minlength=6 required/> <div ng-messages=$ctrl.form.newPassword.$error ng-show=\"$ctrl.form.newPassword.$invalid && $ctrl.form.newPassword.$touched\"> <div ng-message=required>This field is required</div> <div ng-message=minlength>Passwords must be at least 8 characters</div> </div> </md-input-container> <md-input-container> <label>Confirm Password</label> <input type=password ng-model=$ctrl.newPasswordConfirm name=confirmPassword minlength=6 required/> <div ng-messages=$ctrl.form.confirmPassword.$error ng-show=\"$ctrl.form.confirmPassword.$invalid && $ctrl.form.confirmPassword.$touched\"> <div ng-message=required>This field is required</div> <div ng-message=minlength>Passwords must be at least 8 characters</div> </div> </md-input-container> </brd-form-inputs> </brd-form> </md-content> </section> </div> ";

/***/ }),

/***/ "./app/change-password/change-password.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__change_password_service__ = __webpack_require__("./app/change-password/change-password.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__change_password_router__ = __webpack_require__("./app/change-password/change-password.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_brd_form_brd_form_module__ = __webpack_require__("./app/common/brd-form/brd-form.module.ts");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.changePassword", [__WEBPACK_IMPORTED_MODULE_3__common_brd_form_brd_form_module__["a" /* default */]]).service(__WEBPACK_IMPORTED_MODULE_1__change_password_service__["a" /* CHANGE_PASSWORD_SERVICE */], __WEBPACK_IMPORTED_MODULE_1__change_password_service__["b" /* ChangePasswordService */]).config(__WEBPACK_IMPORTED_MODULE_2__change_password_router__["a" /* configRoute */]).name);

/***/ }),

/***/ "./app/change-password/change-password.router.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__change_password_component__ = __webpack_require__("./app/change-password/change-password.component.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_lazy_route_helper__ = __webpack_require__("./app/core/lazy-route.helper.ts");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


function configRoute($stateProvider, $urlRouterProvider) {
    var _this = this;

    $stateProvider.state("changePassword", {
        url: "/change-password?email",
        resolve: {
            email: ["$transition$", function (transition) {
                return transition.params();
            }]
        },
        component: __WEBPACK_IMPORTED_MODULE_0__change_password_component__["CHANGE_PASSWORD_COMPONENT"],
        bindings: {
            email: "email"
        },
        lazyLoad: function lazyLoad(transition, state) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var moduleExports;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./app/change-password/change-password.component.ts"));

                            case 2:
                                moduleExports = _context.sent;

                                Object(__WEBPACK_IMPORTED_MODULE_1__core_lazy_route_helper__["a" /* registerComponentFromTransition */])(transition, __WEBPACK_IMPORTED_MODULE_0__change_password_component__["CHANGE_PASSWORD_COMPONENT"], moduleExports.changePasswordComponentOptions);
                                return _context.abrupt("return", moduleExports);

                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        }
    });
}
configRoute.$inject = ["$stateProvider", "$urlRouterProvider"];

/***/ }),

/***/ "./app/change-password/change-password.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_PASSWORD_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ChangePasswordService; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CHANGE_PASSWORD_SERVICE = "changePasswordService";
var ChangePasswordService = function () {
    function ChangePasswordService($q, $http, userManager) {
        _classCallCheck(this, ChangePasswordService);

        this.$q = $q;
        this.$http = $http;
        this.userManager = userManager;
    }

    _createClass(ChangePasswordService, [{
        key: "changePassword",
        value: function changePassword(oldPassword, newPassword, confirmNewPassword) {
            var _this = this;

            if (oldPassword == newPassword) {
                return this.$q.reject("New password must be different from old password");
            }
            if (newPassword != confirmNewPassword) {
                return this.$q.reject("Passwords doesn't match");
            }
            return this.$http.get("identity/ChangePassword", {
                params: {
                    oldPassword: oldPassword,
                    newPassword: newPassword
                }
            }).then(function () {
                _this.userManager.signinRedirect();
            }, function (reason) {
                return _this.$q.reject(reason.data.message);
            });
        }
    }]);

    return ChangePasswordService;
}();
ChangePasswordService.$inject = ["$q", "$http", "BoardWebAdminUserManager"];

/***/ }),

/***/ "./app/common/app.common.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filters_filters_module__ = __webpack_require__("./app/common/filters/filters.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__brd_form_brd_form_module__ = __webpack_require__("./app/common/brd-form/brd-form.module.ts");



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.common", [__WEBPACK_IMPORTED_MODULE_1__filters_filters_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__brd_form_brd_form_module__["a" /* default */]]).name);

/***/ }),

/***/ "./app/common/brd-form/brd-form.component.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BRD_FORM_COMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return brdFormComponentOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__brd_form_less__ = __webpack_require__("./app/common/brd-form/brd-form.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__brd_form_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__brd_form_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var BRD_FORM_COMPONENT = "brdForm";

var BrdFormComponentController = function () {
    function BrdFormComponentController() {
        _classCallCheck(this, BrdFormComponentController);
    }

    _createClass(BrdFormComponentController, [{
        key: "submit",
        value: function submit() {
            var _this = this;

            this.error = null;
            this.wait = true;
            this.onSubmit().then(null, function (messageError) {
                _this.error = messageError || "An error occurred";
            }).finally(function () {
                _this.wait = false;
            });
        }
    }]);

    return BrdFormComponentController;
}();

var brdFormComponentOptions = {
    transclude: {
        title: "brdFormTitle",
        inputs: "brdFormInputs"
    },
    bindings: {
        onSubmit: "&",
        formInvalid: "<"
    },
    controller: BrdFormComponentController,
    template: __webpack_require__("./app/common/brd-form/brd-form.html")
};

/***/ }),

/***/ "./app/common/brd-form/brd-form.html":
/***/ (function(module, exports) {

module.exports = "<div layout-padding flex layout=column class=brd-form-container layout-align=\"space-around center\"> <div layout=column layout-align=\"space-around center\" layout-padding> <h2 class=brd-form-title-container ng-transclude=title></h2> <div class=brd-form-inputs-container ng-transclude=inputs layout=column layout-align=\"center stretch\"></div> <md-button ng-disabled=$ctrl.formInvalid ng-click=$ctrl.submit()>Submit</md-button> <md-progress-linear ng-style=\"{ 'visibility' : $ctrl.wait ? 'visible' : 'hidden' }\"></md-progress-linear> <div class=brd-form-error-message-container ng-style=\"{ 'visibility' : $ctrl.error && !$ctrl.wait ? 'visible' : 'hidden' }\" layout layout-align=\"center center\"> <div>{{ $ctrl.error }}</div> </div> </div> </div>";

/***/ }),

/***/ "./app/common/brd-form/brd-form.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/common/brd-form/brd-form.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/common/brd-form/brd-form.less", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/common/brd-form/brd-form.less");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/common/brd-form/brd-form.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__brd_form_component__ = __webpack_require__("./app/common/brd-form/brd-form.component.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_angular__["module"]("board.web.admin.brdForm", []).component(__WEBPACK_IMPORTED_MODULE_0__brd_form_component__["a" /* BRD_FORM_COMPONENT */], __WEBPACK_IMPORTED_MODULE_0__brd_form_component__["b" /* brdFormComponentOptions */]).name);

/***/ }),

/***/ "./app/common/filters/error-level.filter.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERROR_LEVEL_DESCRIPTION_FILTER; });
/* harmony export (immutable) */ __webpack_exports__["b"] = errorLevelDescriptionFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typings_board_Diagnostics__ = __webpack_require__("./typings/board/Diagnostics.ts");

var ERROR_LEVEL_DESCRIPTION_FILTER = "errorLevelDescription";
function errorLevelDescriptionFilter() {
    return function (input) {
        switch (input) {
            case __WEBPACK_IMPORTED_MODULE_0__typings_board_Diagnostics__["a" /* EventLogEntryType */].Error:
                return "Error";
            case __WEBPACK_IMPORTED_MODULE_0__typings_board_Diagnostics__["a" /* EventLogEntryType */].FailureAudit:
                return "Failure Audit";
            case __WEBPACK_IMPORTED_MODULE_0__typings_board_Diagnostics__["a" /* EventLogEntryType */].Information:
                return "Information";
            case __WEBPACK_IMPORTED_MODULE_0__typings_board_Diagnostics__["a" /* EventLogEntryType */].SuccessAudit:
                return "Success Audit";
            case __WEBPACK_IMPORTED_MODULE_0__typings_board_Diagnostics__["a" /* EventLogEntryType */].Warning:
                return "Warning";
        }
    };
}

/***/ }),

/***/ "./app/common/filters/filters.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_status_filter__ = __webpack_require__("./app/common/filters/service-status.filter.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_level_filter__ = __webpack_require__("./app/common/filters/error-level.filter.ts");



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.filters", []).filter("serviceStatusDescription", __WEBPACK_IMPORTED_MODULE_1__service_status_filter__["a" /* serviceStatusFilter */]).filter(__WEBPACK_IMPORTED_MODULE_2__error_level_filter__["a" /* ERROR_LEVEL_DESCRIPTION_FILTER */], __WEBPACK_IMPORTED_MODULE_2__error_level_filter__["b" /* errorLevelDescriptionFilter */]).name);

/***/ }),

/***/ "./app/common/filters/service-status.filter.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = serviceStatusFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typings_board_ServiceProcess__ = __webpack_require__("./typings/board/ServiceProcess.ts");

function serviceStatusFilter() {
    return function (input) {
        switch (input) {
            case __WEBPACK_IMPORTED_MODULE_0__typings_board_ServiceProcess__["a" /* ServiceControllerStatus */].ContinuePending:
                return "Continue pending";
            case __WEBPACK_IMPORTED_MODULE_0__typings_board_ServiceProcess__["a" /* ServiceControllerStatus */].Paused:
                return "Paused";
            case __WEBPACK_IMPORTED_MODULE_0__typings_board_ServiceProcess__["a" /* ServiceControllerStatus */].PausePending:
                return "Pause pending";
            case __WEBPACK_IMPORTED_MODULE_0__typings_board_ServiceProcess__["a" /* ServiceControllerStatus */].Running:
                return "Running";
            case __WEBPACK_IMPORTED_MODULE_0__typings_board_ServiceProcess__["a" /* ServiceControllerStatus */].StartPending:
                return "Start pending";
            case __WEBPACK_IMPORTED_MODULE_0__typings_board_ServiceProcess__["a" /* ServiceControllerStatus */].Stopped:
                return "Stopped";
            case __WEBPACK_IMPORTED_MODULE_0__typings_board_ServiceProcess__["a" /* ServiceControllerStatus */].StopPending:
                return "Stop pending";
        }
    };
}

/***/ }),

/***/ "./app/common/utils/constants.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CONSTANT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Constant; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CONSTANT = "Constant";
var Constant = function Constant() {
  _classCallCheck(this, Constant);
};
Constant.DELETION_CONFERMATION_MESSAGE = "Are you sure you want to delete the selected files/folders/?";
Constant.DOWNLOAD_NAME_TITLE = "How would you name your download?";
Constant.RENAME_NAME_TITLE = "How would you rename your file/folder?";
Constant.CREATE_FOLDER_TITLE = "How would you name your new folder?";
Constant.TOAST_SELECT_BEFORE_ACTION = "You should select something before";
Constant.TOAST_ERROR_RENAME = "You should select one file/folder to rename";
Constant.DATE_FORMAT = "DDMMYYYY";
Constant.ZIP_FORMAT = ".zip";
Constant.YES = "Yes";
Constant.NO = "No";
Constant.DOWNLOAD = "Download";
Constant.RENAME = "Rename";
Constant.CANCEL = "Cancel";
Constant.OK = "Ok";
Constant.CAPSULE = "Capsule";
Constant.NEW_FOLDER = "New capsule folder ";
Constant.SUCCESS = "Success";
Constant.$SUCCESS = "";
Constant.DOWNLOAD_ABORTED = "Download aborted";
Constant.RENAMING_ABORTED = "Renaming aborted";
Constant.DOWNLOAD_COMPLETED = "Download completed";
Constant.DOWNLOAD_STARTED = "Download started";
Constant.FOLDER_CREATION_ABORTED = "Folder creation aborted";
Constant.DELETION_ABORTED = "Deletion aborted";

/***/ }),

/***/ "./app/complete-profile/complete-profile.component.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPLETE_PROFILE_COMPONENT", function() { return COMPLETE_PROFILE_COMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "completeProfileComponentOptions", function() { return completeProfileComponentOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__complete_profile_controller__ = __webpack_require__("./app/complete-profile/complete-profile.controller.ts");

var COMPLETE_PROFILE_COMPONENT = "completeProfileComponent";
var completeProfileComponentOptions = {
    controller: __WEBPACK_IMPORTED_MODULE_0__complete_profile_controller__["a" /* CompleteProfileController */],
    template: __webpack_require__("./app/complete-profile/complete-profile.html")
};

/***/ }),

/***/ "./app/complete-profile/complete-profile.controller.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompleteProfileController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__complete_profile_less__ = __webpack_require__("./app/complete-profile/complete-profile.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__complete_profile_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__complete_profile_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var CompleteProfileController = function () {
    function CompleteProfileController(completeProfileService) {
        _classCallCheck(this, CompleteProfileController);

        this.completeProfileService = completeProfileService;
    }

    _createClass(CompleteProfileController, [{
        key: "submit",
        value: function submit() {
            return this.completeProfileService.setEmail(this.email, this.confirmEmail);
        }
    }]);

    return CompleteProfileController;
}();
CompleteProfileController.$inject = ["completeProfileService"];

/***/ }),

/***/ "./app/complete-profile/complete-profile.html":
/***/ (function(module, exports) {

module.exports = "<div layout=column style=height:100%> <brd-header></brd-header> <section layout=column flex layout-align=\"center center\"> <md-content md-whiteframe=2 layout=column layout-align=\"center center\" layout-padding layout-margin class=brd-complete-profile-container> <brd-form on-submit=$ctrl.submit() form-invalid=$ctrl.completeProfileForm.$invalid ng-form=$ctrl.completeProfileForm> <brd-form-title>You need to complete your profile, please set your email!</brd-form-title> <brd-form-inputs layout=column layout-align=\"center center\"> <md-input-container> <label>Email</label> <input type=email name=email ng-model=$ctrl.email required autofocus/> <div ng-messages=$ctrl.completeProfileForm.email.$error ng-show=\"$ctrl.completeProfileForm.email.$invalid && $ctrl.completeProfileForm.email.$touched\"> <div ng-message=email>Not a valid email</div> <div ng-message=required>This field is required</div> </div> </md-input-container> <md-input-container> <label>Confirm email</label> <input type=email name=confirmEmail ng-model=$ctrl.confirmEmail required/> <div ng-messages=$ctrl.completeProfileForm.confirmEmail.$error ng-show=\"$ctrl.completeProfileForm.confirmEmail.$invalid && $ctrl.completeProfileForm.confirmEmail.$touched\"> <div ng-message=email>Not a valid email</div> <div ng-message=required>This field is required</div> </div> </md-input-container> </brd-form-inputs> </brd-form> </md-content> </section> </div>";

/***/ }),

/***/ "./app/complete-profile/complete-profile.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/complete-profile/complete-profile.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/complete-profile/complete-profile.less", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/complete-profile/complete-profile.less");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/complete-profile/complete-profile.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__complete_profile_service__ = __webpack_require__("./app/complete-profile/complete-profile.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_brd_form_brd_form_module__ = __webpack_require__("./app/common/brd-form/brd-form.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__complete_profile_router__ = __webpack_require__("./app/complete-profile/complete-profile.router.ts");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.completeProfile", [__WEBPACK_IMPORTED_MODULE_2__common_brd_form_brd_form_module__["a" /* default */]]).service(__WEBPACK_IMPORTED_MODULE_1__complete_profile_service__["a" /* COMPLETE_PROFILE_SERVICE */], __WEBPACK_IMPORTED_MODULE_1__complete_profile_service__["b" /* CompleteProfileService */]).config(__WEBPACK_IMPORTED_MODULE_3__complete_profile_router__["a" /* configRoute */]).name);

/***/ }),

/***/ "./app/complete-profile/complete-profile.router.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__complete_profile_component__ = __webpack_require__("./app/complete-profile/complete-profile.component.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_lazy_route_helper__ = __webpack_require__("./app/core/lazy-route.helper.ts");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


function configRoute($stateProvider, $urlRouterProvider) {
    var _this = this;

    $stateProvider.state("completeProfile", {
        url: "/complete-profile",
        component: __WEBPACK_IMPORTED_MODULE_0__complete_profile_component__["COMPLETE_PROFILE_COMPONENT"],
        lazyLoad: function lazyLoad(transition, state) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var moduleExports;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./app/complete-profile/complete-profile.component.ts"));

                            case 2:
                                moduleExports = _context.sent;

                                Object(__WEBPACK_IMPORTED_MODULE_1__core_lazy_route_helper__["a" /* registerComponentFromTransition */])(transition, __WEBPACK_IMPORTED_MODULE_0__complete_profile_component__["COMPLETE_PROFILE_COMPONENT"], moduleExports.completeProfileComponentOptions);
                                return _context.abrupt("return", moduleExports);

                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        }
    });
}
configRoute.$inject = ["$stateProvider", "$urlRouterProvider"];

/***/ }),

/***/ "./app/complete-profile/complete-profile.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPLETE_PROFILE_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CompleteProfileService; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var COMPLETE_PROFILE_SERVICE = "completeProfileService";
var CompleteProfileService = function () {
    function CompleteProfileService($q, $http, userManager) {
        _classCallCheck(this, CompleteProfileService);

        this.$q = $q;
        this.$http = $http;
        this.userManager = userManager;
    }

    _createClass(CompleteProfileService, [{
        key: "setEmail",
        value: function setEmail(email, confirmEmail) {
            var _this = this;

            if (email != confirmEmail) {
                return this.$q.reject("Confirm email doesn't match");
            }
            return this.$http.get("identity/SetEmail", { params: { email: email } }).then(function () {
                _this.userManager.signinRedirect();
            }, function (reason) {
                return _this.$q.reject(reason.data.message);
            });
        }
    }]);

    return CompleteProfileService;
}();
CompleteProfileService.$inject = ["$q", "$http", "BoardWebAdminUserManager"];

/***/ }),

/***/ "./app/core/auth.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AuthService; });
/* harmony export (immutable) */ __webpack_exports__["c"] = boardWebLogin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__token_service__ = __webpack_require__("./app/core/token.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var AUTH_SERVICE = "authService";
var AuthService = function () {
    function AuthService($window) {
        _classCallCheck(this, AuthService);

        this.storage = $window.sessionStorage;
    }

    _createClass(AuthService, [{
        key: "getAccessToken",
        value: function getAccessToken() {
            return this.storage.getItem(this.TOKEN_KEY);
        }
    }, {
        key: "signout",
        value: function signout() {
            this.storage.removeItem(this.TOKEN_KEY);
        }
    }, {
        key: "getLoggedIn",
        value: function getLoggedIn() {
            return __WEBPACK_IMPORTED_MODULE_1_angular__["isDefined"](this.getAccessToken());
        }
    }, {
        key: "TOKEN_KEY",
        get: function get() {
            return "accessToken";
        }
    }]);

    return AuthService;
}();
AuthService.$inject = ["$window"];
function boardWebLogin(userManager, tokenService) {
    return userManager.getUser().then(function (user) {
        if (user != null && !user.expired) {
            return user;
        }
        return userManager.signinPopup().then(function (user) {
            tokenService.boardWebAccessToken = user.access_token;
            return user;
        });
    });
}
boardWebLogin.$inject = ["BoardWebUserManager", __WEBPACK_IMPORTED_MODULE_0__token_service__["a" /* TOKEN_SERVICE */]];

/***/ }),

/***/ "./app/core/core.authInterceptor.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthInterceptor; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuthInterceptor = function () {
    function AuthInterceptor($q, $window, $injector, userManager, webUserManager, boardWebEndpoint) {
        var _this = this;

        _classCallCheck(this, AuthInterceptor);

        this.$q = $q;
        this.$window = $window;
        this.$injector = $injector;
        this.userManager = userManager;
        this.webUserManager = webUserManager;
        this.boardWebEndpoint = boardWebEndpoint;
        this.request = function (config) {
            var isAdminEndpoint = config.url.indexOf("api") === 0;
            var isWebEndpoint = config.url.indexOf(boardWebEndpoint) !== -1;
            if (!isAdminEndpoint && !isWebEndpoint) {
                return config;
            }
            config.headers = config.headers || {};
            var tokenService = $injector.get("tokenService");
            config.headers["Authorization"] = "Bearer " + (isWebEndpoint ? tokenService.boardWebAccessToken : tokenService.boardWebAdminAccessToken);
            return config;
        };
        this.responseError = function (rejection) {
            // redirect to login page if unauthorized
            // console.log("AuthResponseError: ", rejection);
            if (rejection.status === 401) {
                var deferred = $q.defer();
                _this.userManager.signinSilent().then(deferred.resolve, deferred.reject);
                return deferred.promise.then(function () {
                    return $injector.get("$http")(rejection.config);
                });
            }
            if (rejection.status === 420 || rejection.status === 419) {
                var _deferred = $q.defer();
                _this.webUserManager.removeUser();
                _this.webUserManager.signinPopup().then(_deferred.resolve, _deferred.reject);
                return _deferred.promise.then(function () {
                    return $injector.get("$http")(rejection.config);
                });
            }
            return $q.reject(rejection);
        };
    }

    _createClass(AuthInterceptor, null, [{
        key: "factory",
        value: function factory() {
            var factoryFn = function factoryFn($q, $window, $injector, userManager, webUserManager, boardWebEndpoint) {
                return new AuthInterceptor($q, $window, $injector, userManager, webUserManager, boardWebEndpoint);
            };
            factoryFn.$inject = ["$q", "$window", "$injector", "BoardWebAdminUserManager", "BoardWebUserManager", "WEB_ENDPOINT"];
            return factoryFn;
        }
    }]);

    return AuthInterceptor;
}();
AuthInterceptor.$inject = ["$q", "$window", "$injector", "BoardWebAdminUserManager", "BoardWebUserManager", "WEB_ENDPOINT"];

/***/ }),

/***/ "./app/core/core.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazy_compiler_service__ = __webpack_require__("./app/core/lazy-compiler.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uirouter_angularjs__ = __webpack_require__("./node_modules/@uirouter/angularjs/release/ui-router-angularjs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uirouter_angularjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__uirouter_angularjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__token_service__ = __webpack_require__("./app/core/token.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__header_service__ = __webpack_require__("./app/core/header.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_service__ = __webpack_require__("./app/core/auth.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_layout_module__ = __webpack_require__("./app/layout/layout.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angular_material_angular_material_css__ = __webpack_require__("./node_modules/angular-material/angular-material.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angular_material_angular_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_angular_material_angular_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__notification_service__ = __webpack_require__("./app/core/notification.service.ts");









/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5_angular__["module"]("board.web.admin.core", [__WEBPACK_IMPORTED_MODULE_1__uirouter_angularjs___default.a, __webpack_require__("./node_modules/angular-material/index.js"), __webpack_require__("./node_modules/ngclipboard/dist/ngclipboard.js"), __WEBPACK_IMPORTED_MODULE_6__layout_layout_module__["a" /* default */]]).service(__WEBPACK_IMPORTED_MODULE_4__auth_service__["a" /* AUTH_SERVICE */], __WEBPACK_IMPORTED_MODULE_4__auth_service__["b" /* AuthService */]).service(__WEBPACK_IMPORTED_MODULE_2__token_service__["a" /* TOKEN_SERVICE */], __WEBPACK_IMPORTED_MODULE_2__token_service__["b" /* TokenService */]).service(__WEBPACK_IMPORTED_MODULE_3__header_service__["a" /* HEADER_SERVICE */], __WEBPACK_IMPORTED_MODULE_3__header_service__["b" /* HeaderService */]).service(__WEBPACK_IMPORTED_MODULE_8__notification_service__["a" /* NOTIFICATION_SERVICE */], __WEBPACK_IMPORTED_MODULE_8__notification_service__["b" /* NotificationService */]).config(["$compileProvider", "$provide", function ($compileProvider, $provide) {
    $provide.constant("$compileProvider", $compileProvider);
}]).service(__WEBPACK_IMPORTED_MODULE_0__lazy_compiler_service__["a" /* LAZY_COMPILER_SERVICE */], __WEBPACK_IMPORTED_MODULE_0__lazy_compiler_service__["b" /* LazyCompilerService */]));

/***/ }),

/***/ "./app/core/header.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HEADER_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HeaderService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instance_settings_instance_settings_service__ = __webpack_require__("./app/instance-settings/instance-settings.service.ts");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var HEADER_SERVICE = "headerService";
var HeaderService = function () {
    function HeaderService($http, instanceSettingService) {
        _classCallCheck(this, HeaderService);

        this.$http = $http;
        this.instanceSettingService = instanceSettingService;
        this.internalHeaderTitle = "";
    }

    _createClass(HeaderService, [{
        key: "getSettings",
        value: function getSettings() {
            return this.instanceSettingService.getSettings().then(function (response) {
                return response;
            });
        }
    }, {
        key: "headerTitle",
        get: function get() {
            return this.internalHeaderTitle;
        },
        set: function set(value) {
            this.internalHeaderTitle = value;
        }
    }]);

    return HeaderService;
}();
HeaderService.$inject = ["$http", __WEBPACK_IMPORTED_MODULE_0__instance_settings_instance_settings_service__["a" /* INSTANCE_SETTINGS_SERVICE */]];

/***/ }),

/***/ "./app/core/lazy-compiler.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LAZY_COMPILER_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LazyCompilerService; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LAZY_COMPILER_SERVICE = "lazyCompilerService";
var LazyCompilerService = function () {
    function LazyCompilerService($compileProvider) {
        _classCallCheck(this, LazyCompilerService);

        this.$compileProvider = $compileProvider;
    }

    _createClass(LazyCompilerService, [{
        key: "registerComponent",
        value: function registerComponent(name, options) {
            this.$compileProvider.component(name, options);
        }
    }]);

    return LazyCompilerService;
}();
LazyCompilerService.$inject = ["$compileProvider"];

/***/ }),

/***/ "./app/core/lazy-route.helper.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerComponentFromTransition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazy_compiler_service__ = __webpack_require__("./app/core/lazy-compiler.service.ts");

function registerComponentFromTransition(transition, name, options) {
    var lazyCompilerService = transition.injector().get(__WEBPACK_IMPORTED_MODULE_0__lazy_compiler_service__["a" /* LAZY_COMPILER_SERVICE */]);
    if (lazyCompilerService == null) {
        throw new Error("Unable to get lazy compiler");
    }
    lazyCompilerService.registerComponent(name, options);
}

/***/ }),

/***/ "./app/core/notification.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NOTIFICATION_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NotificationService; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NOTIFICATION_SERVICE = "notificationService";
var NotificationService = function () {
    function NotificationService($mdToast) {
        _classCallCheck(this, NotificationService);

        this.$mdToast = $mdToast;
    }

    _createClass(NotificationService, [{
        key: "show",
        value: function show(text) {
            return this.$mdToast.show(this.$mdToast.simple().position("top right").textContent(text));
        }
    }, {
        key: "error",
        value: function error(errorMessage) {
            this.$mdToast.show({
                template: "<md-toast class=\"md-toast\"><div class=\"md-toast-content\" style=\"background-color: red; box-shadow: 0\">" + errorMessage + "</div></md-toast>",
                position: "top right",
                hideDelay: 5000
            });
        }
    }]);

    return NotificationService;
}();
NotificationService.$inject = ["$mdToast"];

/***/ }),

/***/ "./app/core/token.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOKEN_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TokenService; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TOKEN_SERVICE = "tokenService";
var TokenService = function TokenService(adminUserManager, webUserManager, adminUser, webUser, idpEndpoint) {
    var _this = this;

    _classCallCheck(this, TokenService);

    this.adminUserManager = adminUserManager;
    this.webUserManager = webUserManager;
    this.boardWebAdminUserLoaded = function (user) {
        _this.boardWebAdminAccessToken = user.access_token;
        //console.log(`new token web admin - ${user.access_token}`);
    };
    this.boardWebUserLoaded = function (user) {
        _this.boardWebAdminAccessToken = user.access_token;
        //console.log(`new token web - ${user.access_token}`);
    };
    adminUserManager.events.removeUserLoaded(this.boardWebAdminUserLoaded);
    adminUserManager.events.addUserLoaded(this.boardWebAdminUserLoaded);
    if (idpEndpoint) {
        adminUserManager.events.addUserSignedOut(function () {
            adminUserManager.removeUser().then(function () {
                adminUserManager.signinRedirect({ state: location.toString() });
            });
        });
    }
    webUserManager.events.removeUserLoaded(this.boardWebUserLoaded);
    webUserManager.events.addUserLoaded(this.boardWebUserLoaded);
    this.boardWebAdminAccessToken = adminUser.access_token;
    if (webUser !== null) {
        this.boardWebAccessToken = webUser.access_token;
    }
};
TokenService.$inject = ["BoardWebAdminUserManager", "BoardWebUserManager", "BoardWebAdminUser", "BoardWebUser", "IDP_ENDPOINT"];

/***/ }),

/***/ "./app/dashboard/dashboard-create-user-dialog.controller.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DASHBOARD_DIALOG_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DashboardDialogService; });
/* unused harmony export CreateUserResponse */
/* unused harmony export CreateUserDialogController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__users_users_service__ = __webpack_require__("./app/users/users.service.ts");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var DASHBOARD_DIALOG_SERVICE = "dashboardDialogService";
var DashboardDialogService = function () {
    function DashboardDialogService($q, $timeout, $mdDialog) {
        _classCallCheck(this, DashboardDialogService);

        this.$q = $q;
        this.$timeout = $timeout;
        this.$mdDialog = $mdDialog;
    }

    _createClass(DashboardDialogService, [{
        key: "createUserDialog",
        value: function createUserDialog(settings) {
            var _this = this;

            if (__WEBPACK_IMPORTED_MODULE_0_angular__["isUndefined"](settings) || settings.initialized) {
                return this.$q.reject();
            }
            return this.$mdDialog.show({
                controller: CreateUserDialogController,
                controllerAs: "$ctrl",
                template: __webpack_require__("./app/dashboard/dashboard-create-user-dialog.html"),
                focusOnOpen: true,
                clickOutsideToClose: true,
                escapeToClose: true,
                bindToController: true,
                fullscreen: true,
                locals: { "settings": settings }
            }).then(function (response) {
                return _this.$q.resolve(response);
            }, function () {
                return _this.$q.reject();
            });
        }
    }]);

    return DashboardDialogService;
}();
DashboardDialogService.$inject = ["$q", "$timeout", "$mdDialog"];
var CreateUserResponse = function CreateUserResponse() {
    _classCallCheck(this, CreateUserResponse);
};
var CreateUserDialogController = function () {
    function CreateUserDialogController($q, $timeout, $mdDialog, usersService) {
        _classCallCheck(this, CreateUserDialogController);

        this.$q = $q;
        this.$timeout = $timeout;
        this.$mdDialog = $mdDialog;
        this.usersService = usersService;
        this.username = "Administrator";
    }

    _createClass(CreateUserDialogController, [{
        key: "createFirstUser",
        value: function createFirstUser(password, confirm) {
            var _this2 = this;

            this.confirmPasswordErrorMsg = undefined;
            if (password !== confirm) {
                this.confirmPasswordErrorMsg = this.notMatchMsg;
                return this.$q.reject();
            }
            if (password.length < 8) {
                this.confirmPasswordErrorMsg = this.charactersLong;
                return this.$q.reject();
            }
            this.wait = true;
            return this.usersService.createFirstUser(password).then(function () {
                _this2.settings.initialized = true;
                return _this2.$q.resolve();
            }, function (reason) {
                _this2.confirmPasswordErrorMsg = reason.data.message !== "" ? reason.data.message : _this2.existsOrNotRunning;
                return _this2.$q.reject(reason);
            }).finally(function () {
                _this2.wait = false;
            });
        }
    }, {
        key: "onCancel",
        value: function onCancel() {
            this.$mdDialog.cancel();
        }
    }, {
        key: "onCreate",
        value: function onCreate() {
            var _this3 = this;

            this.createFirstUser(this.password, this.confirmPassword).then(function () {
                _this3.$mdDialog.hide({});
            });
        }
    }, {
        key: "settingInitialized",
        get: function get() {
            return __WEBPACK_IMPORTED_MODULE_0_angular__["isDefined"](this.settings) && __WEBPACK_IMPORTED_MODULE_0_angular__["isDefined"](this.settings.initialized) ? this.settings.initialized : false;
        }
    }, {
        key: "titleLabel",
        get: function get() {
            return "Create first BOARD user";
        }
    }, {
        key: "usernameLabel",
        get: function get() {
            return "Username";
        }
    }, {
        key: "passwordLabel",
        get: function get() {
            return "Password";
        }
    }, {
        key: "confirmPasswordLabel",
        get: function get() {
            return "Confirm password";
        }
    }, {
        key: "createButtonLabel",
        get: function get() {
            return "Create";
        }
    }, {
        key: "cancelButtonLabel",
        get: function get() {
            return "Cancel";
        }
    }, {
        key: "notMatchMsg",
        get: function get() {
            return "Passwords doesn't match";
        }
    }, {
        key: "charactersLong",
        get: function get() {
            return "Password must be at least 8 characters long";
        }
    }, {
        key: "existsOrNotRunning",
        get: function get() {
            return "Administrator already exists or server not running";
        }
    }]);

    return CreateUserDialogController;
}();
CreateUserDialogController.$inject = ["$q", "$timeout", "$mdDialog", __WEBPACK_IMPORTED_MODULE_1__users_users_service__["a" /* USERS_SERVICE */]];

/***/ }),

/***/ "./app/dashboard/dashboard-create-user-dialog.html":
/***/ (function(module, exports) {

module.exports = " <div class=brd-first-user-dialog> <div class=brd-first-user-title>{{$ctrl.titleLabel}}</div> <md-content layout=column layout-align=\"space-around center\" layout-padding layout-margin aria-label=\"First User Dialog\"> <div ng-form=$ctrl.form> <div layout=column layout-align=\"center stretch\" flex> <md-input-container> <label>{{$ctrl.usernameLabel}}</label> <input type=text disabled=disabled required value={{$ctrl.username}} /> </md-input-container> <md-input-container> <label>{{$ctrl.passwordLabel}}</label> <input type=password name=password minlength=8 md-autofocus required ng-model=$ctrl.password /> </md-input-container> <md-input-container> <label>{{$ctrl.confirmPasswordLabel}}</label> <input type=password name=confirmPassword minlength=8 required ng-model=$ctrl.confirmPassword /> </md-input-container> <div style=color:red ng-if=$ctrl.confirmPasswordErrorMsg layout=row layout-align=\"stretch stretch\"> <div>{{ $ctrl.confirmPasswordErrorMsg }}</div> </div> </div> <div layout layout-align=\"center center\"> <md-button ng-disabled=\"$ctrl.form.$invalid || $ctrl.wait\" ng-click=$ctrl.onCreate() class=md-primary>{{$ctrl.createButtonLabel}}</md-button> <md-button ng-disabled=$ctrl.wait ng-click=$ctrl.onCancel() class=md-primary>{{$ctrl.cancelButtonLabel}}</md-button> </div> <md-progress-linear class=md-primary md-mode=indeterminate md-diameter=35 ng-disabled=!$ctrl.wait></md-progress-linear> </div> </md-content> </div> ";

/***/ }),

/***/ "./app/dashboard/dashboard.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_kendo_ui_js_kendo_angular__ = __webpack_require__("./node_modules/@progress/kendo-ui/js/kendo.angular.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_kendo_ui_js_kendo_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__progress_kendo_ui_js_kendo_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_core__ = __webpack_require__("./node_modules/@progress/kendo-ui/js/kendo.core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_ui_js_kendo_data__ = __webpack_require__("./node_modules/@progress/kendo-ui/js/kendo.data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_ui_js_kendo_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_ui_js_kendo_data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_kendo_ui_js_kendo_data_signalr__ = __webpack_require__("./node_modules/@progress/kendo-ui/js/kendo.data.signalr.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_kendo_ui_js_kendo_data_signalr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__progress_kendo_ui_js_kendo_data_signalr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_ui_js_kendo_dataviz_core__ = __webpack_require__("./node_modules/@progress/kendo-ui/js/kendo.dataviz.core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_ui_js_kendo_dataviz_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_ui_js_kendo_dataviz_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__progress_kendo_ui_js_kendo_dataviz_chart__ = __webpack_require__("./node_modules/@progress/kendo-ui/js/kendo.dataviz.chart.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__progress_kendo_ui_js_kendo_dataviz_chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__progress_kendo_ui_js_kendo_dataviz_chart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dashboard_service__ = __webpack_require__("./app/dashboard/dashboard.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dashboard_router__ = __webpack_require__("./app/dashboard/dashboard.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dashboard_create_user_dialog_controller__ = __webpack_require__("./app/dashboard/dashboard-create-user-dialog.controller.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__core_core_module__ = __webpack_require__("./app/core/core.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__monitor_monitor_module__ = __webpack_require__("./app/monitor/monitor.module.ts");






// import "@progress/kendo-ui/css/web/kendo.common.less";
// import "@progress/kendo-ui/css/web/kendo.materialblack.less";






/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_angular__["module"]("board.web.admin.dashboard", [__WEBPACK_IMPORTED_MODULE_10__core_core_module__["a" /* default */].name, "kendo.directives", __WEBPACK_IMPORTED_MODULE_11__monitor_monitor_module__["a" /* default */]]).service(__WEBPACK_IMPORTED_MODULE_7__dashboard_service__["a" /* DASHBOARD_SERVICE */], __WEBPACK_IMPORTED_MODULE_7__dashboard_service__["b" /* DashboardService */]).service(__WEBPACK_IMPORTED_MODULE_9__dashboard_create_user_dialog_controller__["a" /* DASHBOARD_DIALOG_SERVICE */], __WEBPACK_IMPORTED_MODULE_9__dashboard_create_user_dialog_controller__["b" /* DashboardDialogService */]).config(__WEBPACK_IMPORTED_MODULE_8__dashboard_router__["b" /* configRoute */]).name);

/***/ }),

/***/ "./app/dashboard/dashboard.router.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DASHBOARD_STATE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = configRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shell_route__ = __webpack_require__("./app/app-shell.route.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_service__ = __webpack_require__("./app/dashboard/dashboard.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__manage_manage_service__ = __webpack_require__("./app/manage/manage.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__monitor_monitor_service__ = __webpack_require__("./app/monitor/monitor.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_header_service__ = __webpack_require__("./app/core/header.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_lazy_route_helper__ = __webpack_require__("./app/core/lazy-route.helper.ts");






var DASHBOARD_STATE = "dashboard";
function configRoute($stateProvider, $urlRouterProvider) {
    $stateProvider.state(DASHBOARD_STATE, {
        parent: __WEBPACK_IMPORTED_MODULE_0__app_shell_route__["a" /* APP_SHELL_STATE */],
        url: "/dashboard",
        views: {
            content: {
                component: "dashboardComponent",
                bindings: {
                    series: "series",
                    services: "services",
                    processorId: "processorId",
                    machineName: "machineName",
                    settings: "settings"
                }
            }
        },
        lazyLoad: function lazyLoad(transition, state) {
            return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "./app/dashboard/dashboard.component.ts")).then(function (moduleExports) {
                Object(__WEBPACK_IMPORTED_MODULE_5__core_lazy_route_helper__["a" /* registerComponentFromTransition */])(transition, "dashboardComponent", moduleExports.dashboardComponent);
                return moduleExports;
            });
        },
        onExit: [__WEBPACK_IMPORTED_MODULE_3__monitor_monitor_service__["a" /* MONITOR_SERVICE */], function (monitorService) {
            return monitorService.start.then(function () {
                monitorService.hub.server.stopChartsTimer();
                monitorService.hub.server.stopStatusTimer();
            });
        }],
        onEnter: [__WEBPACK_IMPORTED_MODULE_4__core_header_service__["a" /* HEADER_SERVICE */], function (headerService) {
            headerService.headerTitle = "System Health Dashboard";
        }],
        resolve: {
            series: [__WEBPACK_IMPORTED_MODULE_1__dashboard_service__["a" /* DASHBOARD_SERVICE */], function (dashboardService) {
                return dashboardService.servicesToWatch();
            }],
            services: [__WEBPACK_IMPORTED_MODULE_2__manage_manage_service__["a" /* MANAGE_SERVICE */], function (manageService) {
                return manageService.servicesToWatch();
            }],
            startTimer: [__WEBPACK_IMPORTED_MODULE_3__monitor_monitor_service__["a" /* MONITOR_SERVICE */], function (monitorService) {
                return monitorService.start.then(function () {
                    monitorService.hub.server.startChartsTimer();
                    monitorService.hub.server.startStatusTimer();
                });
            }],
            processorId: [__WEBPACK_IMPORTED_MODULE_1__dashboard_service__["a" /* DASHBOARD_SERVICE */], function (dashboardService) {
                return dashboardService.processorId().then(function (response) {
                    return response;
                });
            }],
            machineName: [__WEBPACK_IMPORTED_MODULE_1__dashboard_service__["a" /* DASHBOARD_SERVICE */], function (dashboardService) {
                return dashboardService.machineName().then(function (response) {
                    return response;
                });
            }],
            settings: [__WEBPACK_IMPORTED_MODULE_1__dashboard_service__["a" /* DASHBOARD_SERVICE */], function (dashboardService) {
                return dashboardService.instanceSettings().then(function (response) {
                    return response;
                });
            }]
        }
    });
}
configRoute.$inject = ["$stateProvider", "$urlRouterProvider"];

/***/ }),

/***/ "./app/dashboard/dashboard.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DASHBOARD_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DashboardService; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DASHBOARD_SERVICE = "dashboardService";
var DashboardService = function () {
    function DashboardService($http) {
        _classCallCheck(this, DashboardService);

        this.$http = $http;
    }

    _createClass(DashboardService, [{
        key: "servicesToWatch",
        value: function servicesToWatch() {
            return this.$http.get("api/dashboard/ServicesToWatch").then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "processorId",
        value: function processorId() {
            return this.$http.get("api/dashboard/ProcessorId").then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "machineName",
        value: function machineName() {
            return this.$http.get("api/dashboard/MachineId").then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "instanceSettings",
        value: function instanceSettings() {
            return this.$http.get("api/dashboard/InstanceSettings").then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "getDashboardData",
        value: function getDashboardData() {
            return this.$http.get("api/dashboard/GetDashboardData").then(function (response) {
                return response.data;
            });
        }
    }]);

    return DashboardService;
}();
DashboardService.$inject = ["$http"];

/***/ }),

/***/ "./app/data-direct/data-direct.component.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATA_DIRECT_COMPONENT", function() { return DATA_DIRECT_COMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dataDirectComponentOptions", function() { return dataDirectComponentOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_direct_less__ = __webpack_require__("./app/data-direct/data-direct.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_direct_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_direct_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_direct_service__ = __webpack_require__("./app/data-direct/data-direct.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__capsule_manager_guide_capsuleManagerGuide_component__ = __webpack_require__("./app/capsule-manager-guide/capsuleManagerGuide.component.ts");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var DATA_DIRECT_COMPONENT = "dataDirectComponent";

var DataDirectComponentController = function () {
    function DataDirectComponentController($mdToast, dataDirectService, $mdDialog) {
        _classCallCheck(this, DataDirectComponentController);

        this.$mdToast = $mdToast;
        this.dataDirectService = dataDirectService;
        this.$mdDialog = $mdDialog;
        this.showPassword = true;
        this.descriptions = [];
        // tslint:disable-next-line:max-line-length
        this.descriptions.push(new __WEBPACK_IMPORTED_MODULE_2__capsule_manager_guide_capsuleManagerGuide_component__["b" /* Description */]("Data pipeline", "Configure connections to your data sources, on premise or cloud. Access to data pipeline portal, add new data sources if needed."));
    }
    //Labels


    _createClass(DataDirectComponentController, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "$onChanges",
        value: function $onChanges(onChangesObj) {}
    }, {
        key: "showCopyMsg",
        value: function showCopyMsg() {
            this.$mdToast.show(this.$mdToast.simple().textContent("Copied to clipboard!").position("top right"));
        }
    }, {
        key: "showPassOnClick",
        value: function showPassOnClick() {
            this.showPassword = !this.showPassword;
        }
    }, {
        key: "commitNewConfiguration",
        value: function commitNewConfiguration() {
            var _this = this;

            this.dataDirectService.createODBCConfiguration(this.newConfigurationName, this.newDataSourceName).then(function (response) {
                _this.newConfigurationName = "";
                _this.dataDirectService.getExistingConfigurations().then(function (response) {
                    _this.existingConfigurations = response;
                }, function (reason) {});
            }, function (reason) {});
        }
    }, {
        key: "addConfOnClick",
        value: function addConfOnClick() {
            var _this2 = this;

            this.$mdDialog.show({
                controller: CreateConnectionController,
                controllerAs: "$ctrl",
                template: __webpack_require__("./app/data-direct/update-connection.html")
            }).then(function (answer) {
                _this2.dataDirectService.createODBCConfiguration(answer.connectionName, answer.dataSourceName).then(function (response) {
                    _this2.newConfigurationName = "";
                    _this2.dataDirectService.getExistingConfigurations().then(function (response) {
                        _this2.existingConfigurations = response;
                    }, function (reason) {});
                }, function (reason) {});
            }, function () {});
        }
    }, {
        key: "showPasswordSecurity",
        value: function showPasswordSecurity() {
            this.$mdDialog.show({
                controller: SecurityNoticeController,
                controllerAs: "$ctrl",
                template: __webpack_require__("./app/data-direct/security-alert.html")
            });
        }
    }, {
        key: "deleteODBCConfiguration",
        value: function deleteODBCConfiguration(name) {
            var _this3 = this;

            this.dataDirectService.deleteODBCConfiguration(name).then(function (response) {
                _this3.dataDirectService.getExistingConfigurations().then(function (response) {
                    _this3.existingConfigurations = response;
                });
            });
        }
    }, {
        key: "showUpdateConfigurationDialogue",
        value: function showUpdateConfigurationDialogue(oldConnectionName, oldDataSourceName) {
            var _this4 = this;

            this.$mdDialog.show({
                controller: EditConnectionController,
                controllerAs: "$ctrl",
                template: __webpack_require__("./app/data-direct/update-connection.html"),
                locals: { oldConnectionName: oldConnectionName, oldDataSourceName: oldDataSourceName }
            }).then(function (answer) {
                _this4.dataDirectService.updateODBCConfiguration(answer.oldConnectionName, answer.newConnectionName, answer.newDataSourceName).then(function (response) {
                    _this4.newConfigurationName = "";
                    _this4.dataDirectService.getExistingConfigurations().then(function (response) {
                        _this4.existingConfigurations = response;
                    }, function (reason) {});
                }, function (reason) {});
            }, function (reason) {});
        }
    }, {
        key: "titleLabel",
        get: function get() {
            return "BOARD Cloud Data Pipeline";
        }
    }, {
        key: "subTitleLabel",
        get: function get() {
            return "Configure connections to your data sources on-premises or in cloud";
        }
    }, {
        key: "connectionHint",
        get: function get() {
            return "These connections can be used on any BOARD instance (Production, Sandbox, ...)";
        }
    }, {
        key: "firstStep",
        get: function get() {
            return "To activate the BOARD Cloud Data Pipeline service you have to access the portal and change the first password.";
        }
    }, {
        key: "secondStepText",
        get: function get() {
            return "     ";
        }
    }, {
        key: "secondStepLink",
        get: function get() {
            return "OPC (On-Premise Connector)";
        }
    }, {
        key: "thirdStep",
        get: function get() {
            return "Add a new Data Source here:";
        }
    }, {
        key: "dataPipelineAccess",
        get: function get() {
            return "Cloud Data Pipeline Portal";
        }
    }, {
        key: "footer1",
        get: function get() {
            return "The above alias will be available on ";
        }
    }, {
        key: "footer2",
        get: function get() {
            return "instance only";
        }
    }, {
        key: "footer3",
        get: function get() {
            return "User and password of the BOARD Data Reader login settings are the same credential of the Cloud Data Pipeline Portal";
        }
    }, {
        key: "oDBCLabel",
        get: function get() {
            return "";
        }
    }, {
        key: "oDBCSubLabel",
        get: function get() {
            return "In order to use a data source in a BOARD SQL Data Reader you must define an alias.";
        }
    }, {
        key: "serverLinkLabel",
        get: function get() {
            return "Configure a Data Source Connection";
        }
    }, {
        key: "userLabel",
        get: function get() {
            return "User:";
        }
    }, {
        key: "passLabel",
        get: function get() {
            return "First password:";
        }
    }, {
        key: "onPremiseLinkLabel",
        get: function get() {
            return "To connect to an on-premise data source, download the On-Premise Connector here.";
        }
    }, {
        key: "getStartedLinkLabel",
        get: function get() {
            return "Download Data Pipeline guide";
        }
    }, {
        key: "addConfLabel",
        get: function get() {
            return "Add new";
        }
    }, {
        key: "newConfLabel",
        get: function get() {
            return "Data Source name";
        }
    }, {
        key: "oDBCNameLabel",
        get: function get() {
            return "BOARD Connection Source name";
        }
    }, {
        key: "dataSourceLabel",
        get: function get() {
            return "Data Pipeline Data Source name";
        }
    }, {
        key: "dataDirectLink",
        get: function get() {
            return this.settings.dataDirectLoginLink;
        }
    }, {
        key: "username",
        get: function get() {
            return this.settings.dataDirectUsername;
        }
    }, {
        key: "password",
        get: function get() {
            return this.settings.dataDirectPassword;
        }
    }, {
        key: "onPremiseLink",
        get: function get() {
            return this.settings.onPremiseLink;
        }
    }, {
        key: "getStartedLink",
        get: function get() {
            return this.settings.getStartedLink;
        }
    }, {
        key: "instanceName",
        get: function get() {
            return this.settings.hostname;
        }
    }, {
        key: "instanceNameLink",
        get: function get() {
            return this.settings.hostnameLink;
        }
    }, {
        key: "instanceType",
        get: function get() {
            return this.settings.instanceType;
        }
        //Disabled

    }, {
        key: "enabledOnPremiseLink",
        get: function get() {
            return this.settings && this.settings.onPremiseLink && this.settings.onPremiseLink !== "";
        }
    }, {
        key: "enabledGetStartedLink",
        get: function get() {
            return this.settings && this.settings.getStartedLink && this.settings.getStartedLink !== "";
        }
    }]);

    return DataDirectComponentController;
}();

DataDirectComponentController.$inject = ["$mdToast", __WEBPACK_IMPORTED_MODULE_1__data_direct_service__["a" /* DATA_DIRECT_SERVICE */], "$mdDialog"];

var SecurityNoticeController = function () {
    function SecurityNoticeController($mdDialog) {
        _classCallCheck(this, SecurityNoticeController);

        this.$mdDialog = $mdDialog;
    }

    _createClass(SecurityNoticeController, [{
        key: "close",
        value: function close() {
            this.$mdDialog.cancel();
        }
    }, {
        key: "securityAlertTitle",
        get: function get() {
            return "For security reasons the password must respect the following policies:";
        }
    }, {
        key: "securityList",
        get: function get() {
            return ["be at least eight characters long,", "contain a combination of upper- and lower-case letters,", "contain numbers", "contain punctuation marks and other special characters"];
        }
    }]);

    return SecurityNoticeController;
}();

SecurityNoticeController.$inject = ["$mdDialog"];

var CreateConnectionController = function () {
    function CreateConnectionController($mdDialog) {
        _classCallCheck(this, CreateConnectionController);

        this.$mdDialog = $mdDialog;
    }

    _createClass(CreateConnectionController, [{
        key: "cancel",
        value: function cancel() {
            this.$mdDialog.cancel();
        }
    }, {
        key: "save",
        value: function save() {
            this.$mdDialog.hide({
                connectionName: this.newConnectionName,
                dataSourceName: this.newDataSourceName
            });
        }
    }, {
        key: "oDBCNameLabel",
        get: function get() {
            return "BOARD";
        }
    }, {
        key: "dataSourceLabel",
        get: function get() {
            return "Data Pipeline";
        }
    }]);

    return CreateConnectionController;
}();

CreateConnectionController.$inject = ["$mdDialog"];

var EditConnectionController = function () {
    function EditConnectionController($mdDialog, oldConnectionName, oldDataSourceName) {
        _classCallCheck(this, EditConnectionController);

        this.$mdDialog = $mdDialog;
        this.oldConnectionName = oldConnectionName;
        this.oldDataSourceName = oldDataSourceName;
        this.newConnectionName = oldConnectionName;
        this.newDataSourceName = oldDataSourceName;
    }

    _createClass(EditConnectionController, [{
        key: "cancel",
        value: function cancel() {
            this.$mdDialog.cancel();
        }
    }, {
        key: "save",
        value: function save() {
            this.$mdDialog.hide({
                oldConnectionName: this.oldConnectionName,
                newConnectionName: this.newConnectionName,
                newDataSourceName: this.newDataSourceName
            });
        }
    }, {
        key: "oDBCNameLabel",
        get: function get() {
            return "BOARD";
        }
    }, {
        key: "dataSourceLabel",
        get: function get() {
            return "Data Pipeline";
        }
    }]);

    return EditConnectionController;
}();

EditConnectionController.$inject = ["$mdDialog", "oldConnectionName", "oldDataSourceName"];
var dataDirectComponentOptions = {
    controller: DataDirectComponentController,
    template: __webpack_require__("./app/data-direct/data-direct.html"),
    bindings: {
        settings: "<",
        machineName: "<",
        existingConfigurations: "<"
    }
};

/***/ }),

/***/ "./app/data-direct/data-direct.html":
/***/ (function(module, exports) {

module.exports = "<div layout=row layout-align=\"start center\"> <div flex></div> <capsule-manager-guide-component descriptions=$ctrl.descriptions></capsule-manager-guide-component> </div> <md-divider style=border-top-color:#6a6a6a;border-top-width:2px></md-divider> <md-container layout=column layout-align=\"space-around stretch\" layout-padding class=brd-dd-container> <h2 class=b-display-4>{{$ctrl.titleLabel}}</h2> <div layout-margin> <div>{{$ctrl.subTitleLabel}}</div> <span>1) </span> <md-button class=b-framed-on-dark ng-href={{$ctrl.dataDirectLink}} target=_blank> <md-tooltip md-direction=right></md-tooltip> {{$ctrl.dataPipelineAccess}} </md-button> <div layout-margin layout-align=\"start center\" flex=40> <div layout=row layout-align=\"start center\"> </div> <div class=user-container> <div>At the first login, use the following credentials:</div> <br/> <div> <div layout=row layout-align=\"start center\"> <div>{{$ctrl.userLabel}}</div> <div class=uname-container id=clipusername>{{$ctrl.username}}</div> </div> <div layout=row layout-align=\"start center\"> <div>{{$ctrl.passLabel}}</div> <input class=brd-dd-input-passw type=\"{{ $ctrl.showPassword ? 'password' : 'text' }}\" id=clippass ng-model=$ctrl.password> <md-button class=b-framed-on-dark ng-click=$ctrl.showPassOnClick()> <md-tooltip md-direction=right>Show or hide password</md-tooltip> SHOW </md-button> <md-button ng-click=$ctrl.showPasswordSecurity()> <md-tooltip md-direction=right>Show password policies</md-tooltip> NOTE </md-button> </div> </div> </div> </div> <div> 2) For on-premises data sources, download the <a href={{$ctrl.onPremiseLink}}>OPC (On-Premise Connector)</a> and install it on a computer in the same network of the data source. </div> <div class=configuration-note flex=40> <ul> <li>Note: you must access the Data Pipeline Portal and change the first password before downloading the OPC Connector</li> </ul> </div> </div> <md-divider class=md-divider flex></md-divider> <h2 class=b-display-4>BOARD Data Sources on <span class=brd-ita>{{$ctrl.instanceName}}</span></h2> <div layout-margin> <div>{{$ctrl.oDBCSubLabel}}</div> <div layout=row flex> <div layout=column flex=40 layout-align=\"center stretch\"> <div class=configuration-table> <div class=configuration-table-header layout=row layout-align=\"start center\"> <div flex=30 layout-padding>Connection alias</div> <div flex=30 layout-padding>Data Pipeline name</div> <div flex layout=row layout-align=\"center center\">Actions</div> </div> <div class=configuration-item layout=row layout-align=\"start center\" ng-repeat=\"item in $ctrl.existingConfigurations\"> <div flex=30 layout-padding>{{item.odbcName}}</div> <div flex=30 layout-padding>{{item.dataSourceName}}</div> <div flex layout=row layout-align=\"center center\"> <md-button class=b-framed-on-dark ng-click=\"$ctrl.showUpdateConfigurationDialogue(item.odbcName, item.dataSourceName)\"> edit</md-button> <md-button class=md-warn ng-click=$ctrl.deleteODBCConfiguration(item.odbcName)>delete</md-button> </div> </div> </div> <div layout=row> <div layout=column layout-align=\"center center\"> <md-button class=b-framed-on-dark ng-click=$ctrl.addConfOnClick()>{{$ctrl.addConfLabel}}</md-button> </div> </div> <div class=configuration-note> <ul> <li>{{$ctrl.footer1}} <span>{{$ctrl.instanceName}}</span> {{$ctrl.footer2}}</li> <li>{{$ctrl.footer3}}</li> </ul> </div> </div> </div> </div> </md-container> ";

/***/ }),

/***/ "./app/data-direct/data-direct.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/data-direct/data-direct.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/data-direct/data-direct.less", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/data-direct/data-direct.less");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/data-direct/data-direct.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_direct_router__ = __webpack_require__("./app/data-direct/data-direct.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_direct_service__ = __webpack_require__("./app/data-direct/data-direct.service.ts");



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.datadirect", []).service(__WEBPACK_IMPORTED_MODULE_2__data_direct_service__["a" /* DATA_DIRECT_SERVICE */], __WEBPACK_IMPORTED_MODULE_2__data_direct_service__["b" /* DataDirectService */]).config(__WEBPACK_IMPORTED_MODULE_1__data_direct_router__["b" /* configRoute */]).name);

/***/ }),

/***/ "./app/data-direct/data-direct.router.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATA_DIRECT_STATE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = configRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_direct_service__ = __webpack_require__("./app/data-direct/data-direct.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_header_service__ = __webpack_require__("./app/core/header.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shell_route__ = __webpack_require__("./app/app-shell.route.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_lazy_route_helper__ = __webpack_require__("./app/core/lazy-route.helper.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_direct_component__ = __webpack_require__("./app/data-direct/data-direct.component.ts");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





var DATA_DIRECT_STATE = "dataDirectState";
function configRoute($stateProvider, $urlRouterProvider) {
    var _this = this;

    $stateProvider.state(DATA_DIRECT_STATE, {
        parent: __WEBPACK_IMPORTED_MODULE_2__app_shell_route__["a" /* APP_SHELL_STATE */],
        url: "/datadirect",
        views: {
            content: {
                component: __WEBPACK_IMPORTED_MODULE_4__data_direct_component__["DATA_DIRECT_COMPONENT"],
                bindings: {
                    settings: "settings",
                    machineName: "machineName",
                    existingConfigurations: "existingConfigurations"
                }
            }
        },
        lazyLoad: function lazyLoad(transition, state) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var moduleExports;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./app/data-direct/data-direct.component.ts"));

                            case 2:
                                moduleExports = _context.sent;

                                Object(__WEBPACK_IMPORTED_MODULE_3__core_lazy_route_helper__["a" /* registerComponentFromTransition */])(transition, __WEBPACK_IMPORTED_MODULE_4__data_direct_component__["DATA_DIRECT_COMPONENT"], moduleExports.dataDirectComponentOptions);
                                return _context.abrupt('return', moduleExports);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        },
        resolve: {
            settings: [__WEBPACK_IMPORTED_MODULE_0__data_direct_service__["a" /* DATA_DIRECT_SERVICE */], function (dataDirectService) {
                return dataDirectService.getSettings();
            }],
            existingConfigurations: [__WEBPACK_IMPORTED_MODULE_0__data_direct_service__["a" /* DATA_DIRECT_SERVICE */], function (dataDirectService) {
                return dataDirectService.getExistingConfigurations();
            }],
            machineName: [__WEBPACK_IMPORTED_MODULE_0__data_direct_service__["a" /* DATA_DIRECT_SERVICE */], function (dataDirectService) {
                return dataDirectService.machineName().then(function (response) {
                    return response;
                });
            }]
        },
        onEnter: [__WEBPACK_IMPORTED_MODULE_1__core_header_service__["a" /* HEADER_SERVICE */], function (headerService) {
            headerService.headerTitle = "Data Pipeline";
        }]
    });
}
configRoute.$inject = ["$stateProvider", "$urlRouterProvider"];

/***/ }),

/***/ "./app/data-direct/data-direct.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATA_DIRECT_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DataDirectService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instance_settings_instance_settings_service__ = __webpack_require__("./app/instance-settings/instance-settings.service.ts");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var DATA_DIRECT_SERVICE = "dataDirectService";
var DataDirectService = function () {
    function DataDirectService($http, instanceSettingService) {
        _classCallCheck(this, DataDirectService);

        this.$http = $http;
        this.instanceSettingService = instanceSettingService;
    }

    _createClass(DataDirectService, [{
        key: "getSettings",
        value: function getSettings() {
            return this.instanceSettingService.getSettings().then(function (response) {
                return response;
            });
        }
    }, {
        key: "dataDirectPassword",
        value: function dataDirectPassword(username, currentPassword, newPassword) {
            return this.instanceSettingService.dataDirectPassword(username, currentPassword, newPassword).then(function (response) {
                return response;
            });
        }
    }, {
        key: "createODBCConfiguration",
        value: function createODBCConfiguration(odbcName, dataSourceName) {
            return this.$http.get("api/ODBC/CreateODBCConfiguration", { params: { odbcName: odbcName, dataSourceName: dataSourceName } });
        }
    }, {
        key: "deleteODBCConfiguration",
        value: function deleteODBCConfiguration(name) {
            return this.$http.get("api/ODBC/DeleteODBCConfiguration", { params: { name: name } });
        }
    }, {
        key: "machineName",
        value: function machineName() {
            return this.$http.get("api/dashboard/MachineId").then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "getExistingConfigurations",
        value: function getExistingConfigurations() {
            return this.$http.get("api/ODBC/GetExistingConfigurations").then(function (response) {
                return response.data;
            }, function (error) {
                return [];
            });
        }
    }, {
        key: "updateODBCConfiguration",
        value: function updateODBCConfiguration(oldName, newName, dataSourceName) {
            return this.$http.get("api/ODBC/EditODBCConfiguration", {
                params: {
                    oldName: oldName,
                    newName: newName,
                    dataSourceName: dataSourceName
                }
            }).then(function (response) {
                return response.data;
            }, function (reason) {
                return reason;
            });
        }
    }]);

    return DataDirectService;
}();
DataDirectService.$inject = ["$http", __WEBPACK_IMPORTED_MODULE_0__instance_settings_instance_settings_service__["a" /* INSTANCE_SETTINGS_SERVICE */]];

/***/ }),

/***/ "./app/data-direct/security-alert.html":
/***/ (function(module, exports) {

module.exports = " <md-dialog> <md-dialog-content> <div flex layout=column layout-padding layout-align=start> <h3>{{$ctrl.securityAlertTitle}}</h3> <div class=configuration-item layout=row layout-align=\"start center\" ng-repeat=\"item in $ctrl.securityList\"> <ul> <li>{{item}}</li> </ul> </div> </div> <md-dialog-actions> <md-button class=b-primary ng-click=$ctrl.close()>Got it!</md-button> </md-dialog-actions> </md-dialog-content> </md-dialog>";

/***/ }),

/***/ "./app/data-direct/update-connection.html":
/***/ (function(module, exports) {

module.exports = "<md-dialog> <md-dialog-content> <form name=update> <div layout=column layout-align=\"center stretch\" layout-padding> <label>{{$ctrl.oDBCNameLabel}}</label> <md-input-container flex> <label>Connection name</label> <input type=text ng-model=$ctrl.newConnectionName md-maxlength=32 required/> </md-input-container> <label>{{$ctrl.dataSourceLabel}}</label> <md-input-container flex> <label>Data source name</label> <input type=text ng-model=$ctrl.newDataSourceName required/> </md-input-container> </div> <md-dialog-actions> <md-button ng-click=$ctrl.cancel() class=b-warn>Close</md-button> <md-button ng-disabled=update.$invalid class=b-primary ng-click=$ctrl.save()>Save</md-button> </md-dialog-actions> </form> </md-dialog-content> </md-dialog> ";

/***/ }),

/***/ "./app/email-confirmed/email-confirmed.component.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EMAIL_CONFIRMED_COMPONENT", function() { return EMAIL_CONFIRMED_COMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "emailConfirmedComponentOptions", function() { return emailConfirmedComponentOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__email_confirmed_controller__ = __webpack_require__("./app/email-confirmed/email-confirmed.controller.ts");

var EMAIL_CONFIRMED_COMPONENT = "emailConfirmedComponent";
var emailConfirmedComponentOptions = {
    controller: __WEBPACK_IMPORTED_MODULE_0__email_confirmed_controller__["a" /* EmailConfirmedController */],
    template: __webpack_require__("./app/email-confirmed/email-confirmed.html"),
    bindings: {
        userIdAndToken: "<"
    }
};

/***/ }),

/***/ "./app/email-confirmed/email-confirmed.controller.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmailConfirmedController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__email_confirmed_service__ = __webpack_require__("./app/email-confirmed/email-confirmed.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__email_confirmed_less__ = __webpack_require__("./app/email-confirmed/email-confirmed.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__email_confirmed_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__email_confirmed_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var EmailConfirmedController = function () {
    function EmailConfirmedController($mdToast, $state, $window, emailConfirmService, userManager) {
        _classCallCheck(this, EmailConfirmedController);

        this.$mdToast = $mdToast;
        this.$state = $state;
        this.$window = $window;
        this.emailConfirmService = emailConfirmService;
        this.userManager = userManager;
    }
    //Labels


    _createClass(EmailConfirmedController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.loading = true;
            this.emailConfirmService.confirmEmail(this.userIdAndToken.userId, this.userIdAndToken.confirmationToken).then(function (response) {
                _this.urlResponse = response;
            }).finally(function () {
                _this.loading = false;
            });
        }
    }, {
        key: 'gotoLogin',
        value: function gotoLogin() {
            this.userManager.signinRedirect();
        }
    }, {
        key: 'mainLabel',
        get: function get() {
            return "Registration confirmed";
        }
    }, {
        key: 'description',
        get: function get() {
            return "You can now sign-in!";
        }
    }, {
        key: 'gotoLoginButtonLabel',
        get: function get() {
            return "Go to sign-in page";
        }
    }]);

    return EmailConfirmedController;
}();
EmailConfirmedController.$inject = ["$mdToast", "$state", "$window", __WEBPACK_IMPORTED_MODULE_0__email_confirmed_service__["a" /* EMAIL_CONFIRMED_SERVICE */], "BoardWebAdminUserManager"];

/***/ }),

/***/ "./app/email-confirmed/email-confirmed.html":
/***/ (function(module, exports) {

module.exports = " <div layout=column style=height:100%> <brd-header></brd-header> <section layout=column flex layout-align=\"center center\"> <md-content md-whiteframe=2 layout=column layout-align=\"center center\" layout-padding layout-margin class=brd-emailconfirmed-container> <div ng-if=$ctrl.loading layout=column layout-align=\"center center\"> <md-progress-circular md-mode=indeterminate md-diameter=100></md-progress-circular> </div> <div ng-if=!$ctrl.loading layout=column layout-align=\"center center\"> <h2 layout layout-align=\"center center\">{{$ctrl.mainLabel}}</h2> <h4 layout layout-align=\"center center\">{{$ctrl.description}}</h4> <md-button ng-click=$ctrl.gotoLogin()>{{$ctrl.gotoLoginButtonLabel}}</md-button> </div> </md-content> </section> </div> ";

/***/ }),

/***/ "./app/email-confirmed/email-confirmed.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/email-confirmed/email-confirmed.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/email-confirmed/email-confirmed.less", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/email-confirmed/email-confirmed.less");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/email-confirmed/email-confirmed.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__email_confirmed_service__ = __webpack_require__("./app/email-confirmed/email-confirmed.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__email_confirmed_router__ = __webpack_require__("./app/email-confirmed/email-confirmed.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__uirouter_angularjs__ = __webpack_require__("./node_modules/@uirouter/angularjs/release/ui-router-angularjs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__uirouter_angularjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__uirouter_angularjs__);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_angular__["module"]("board.web.admin.emailconfirmed", [__WEBPACK_IMPORTED_MODULE_3__uirouter_angularjs___default.a]).service(__WEBPACK_IMPORTED_MODULE_0__email_confirmed_service__["a" /* EMAIL_CONFIRMED_SERVICE */], __WEBPACK_IMPORTED_MODULE_0__email_confirmed_service__["b" /* EmailConfirmedService */]).config(__WEBPACK_IMPORTED_MODULE_2__email_confirmed_router__["a" /* configRoute */]).name);

/***/ }),

/***/ "./app/email-confirmed/email-confirmed.router.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EMAIL_CONFIRMED_STATE */
/* harmony export (immutable) */ __webpack_exports__["a"] = configRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_lazy_route_helper__ = __webpack_require__("./app/core/lazy-route.helper.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__email_confirmed_component__ = __webpack_require__("./app/email-confirmed/email-confirmed.component.ts");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


var EMAIL_CONFIRMED_STATE = "emailConfirmedState";
function configRoute($stateProvider, $urlRouterProvider) {
    var _this = this;

    $stateProvider.state(EMAIL_CONFIRMED_STATE, {
        url: "/emailconfirmed?userId&confirmationToken",
        resolve: {
            "userIdAndToken": ["$transition$", function (transition) {
                return transition.params();
            }]
        },
        component: __WEBPACK_IMPORTED_MODULE_1__email_confirmed_component__["EMAIL_CONFIRMED_COMPONENT"],
        bindings: {
            userIdAndToken: "userIdAndToken"
        },
        lazyLoad: function lazyLoad(transition, state) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var moduleExports;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./app/email-confirmed/email-confirmed.component.ts"));

                            case 2:
                                moduleExports = _context.sent;

                                Object(__WEBPACK_IMPORTED_MODULE_0__core_lazy_route_helper__["a" /* registerComponentFromTransition */])(transition, __WEBPACK_IMPORTED_MODULE_1__email_confirmed_component__["EMAIL_CONFIRMED_COMPONENT"], moduleExports.emailConfirmedComponentOptions);
                                return _context.abrupt("return", moduleExports);

                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        }
    });
}
configRoute.$inject = ["$stateProvider", "$urlRouterProvider"];

/***/ }),

/***/ "./app/email-confirmed/email-confirmed.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EMAIL_CONFIRMED_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EmailConfirmedService; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EMAIL_CONFIRMED_SERVICE = "emailConfirmedService";
var EmailConfirmedService = function () {
    function EmailConfirmedService($http, $q, $window, userManager) {
        _classCallCheck(this, EmailConfirmedService);

        this.$http = $http;
        this.$q = $q;
        this.$window = $window;
        this.userManager = userManager;
    }

    _createClass(EmailConfirmedService, [{
        key: "confirmEmail",
        value: function confirmEmail(userId, confirmationToken) {
            return this.$http.get("api/register/ConfirmEmail", {
                params: {
                    confirmationToken: confirmationToken,
                    userId: userId
                }
            }).then(function (response) {
                return response.data;
            });
        }
    }]);

    return EmailConfirmedService;
}();
EmailConfirmedService.$inject = ["$http", "$q", "$window", "BoardWebAdminUserManager"];

/***/ }),

/***/ "./app/hierarchy-controllers/hierarchyControllers.component.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIERARCHY_CONTROLLERS_COMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hierarchyControllersComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchyControllers_less__ = __webpack_require__("./app/hierarchy-controllers/hierarchyControllers.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchyControllers_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__hierarchyControllers_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("./node_modules/moment/moment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils_constants__ = __webpack_require__("./app/common/utils/constants.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hierarchy_service_hierarchy_service__ = __webpack_require__("./app/hierarchy-service/hierarchy.service.ts");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var HIERARCHY_CONTROLLERS_COMPONENT = "hierarchyControllersComponent";

var HierarchyControllersCtrl = function () {
    function HierarchyControllersCtrl(hierarchyService, $mdDialog, $mdToast, $scope) {
        _classCallCheck(this, HierarchyControllersCtrl);

        this.hierarchyService = hierarchyService;
        this.$mdDialog = $mdDialog;
        this.$mdToast = $mdToast;
        this.$scope = $scope;
        this.downloadBtnLbl = "Download selected";
        this.uploadBtnLbl = "Upload";
        this.moveBtnLbl = "Move selected";
        this.createFolderLbl = "Create Folder";
        this.deleteBtnLbl = "Delete selected";
        this.duplicateBtnLbl = "Copy selected";
        this.renameBtnLbl = "Rename selected";
        this.input = document.getElementById("#fileInput");
        var _self_ = this;
        this.hierarchyService.rowSelected.subscribe(function (value) {
            $scope.$evalAsync(function () {
                return _self_.isRowSelected = value;
            });
        });
        this.initializeUploadButtonSettings();
    }

    _createClass(HierarchyControllersCtrl, [{
        key: "operationCompleted",
        value: function operationCompleted(message) {
            this.hierarchyService.showToast(message === "" ? __WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].SUCCESS : message);
            this.hierarchyService.resetSelectedRows();
            this.hierarchyService.stoppingAsyncOperation();
        }
    }, {
        key: "move",
        value: function move() {
            if (!this.isRowSelected) {
                this.hierarchyService.showToast(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].TOAST_SELECT_BEFORE_ACTION);
            } else {
                this.hierarchyService.showMoveModal();
            }
        }
    }, {
        key: "download",
        value: function download() {
            if (!this.isRowSelected) {
                this.hierarchyService.showToast(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].TOAST_SELECT_BEFORE_ACTION);
            } else {
                var _self_ = this;
                var askFilename = this.$mdDialog.prompt().title(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].DOWNLOAD_NAME_TITLE).initialValue(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].CAPSULE + __WEBPACK_IMPORTED_MODULE_1_moment__().format(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].DATE_FORMAT)).required(true).ok(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].DOWNLOAD).cancel(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].CANCEL);
                this.$mdDialog.show(askFilename).then(function (fileName) {
                    _self_.hierarchyService.showToast(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].DOWNLOAD_STARTED);
                    _self_.hierarchyService.$downloadCapsule(fileName);
                }, function (fileName) {
                    _self_.hierarchyService.showToast(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].DOWNLOAD_ABORTED);
                });
            }
        }
    }, {
        key: "createFolder",
        value: function createFolder() {
            var _self_ = this;
            var askFolderName = this.$mdDialog.prompt().title(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].CREATE_FOLDER_TITLE).initialValue(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].NEW_FOLDER + __WEBPACK_IMPORTED_MODULE_1_moment__().format(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].DATE_FORMAT)).required(true).ok(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].OK).cancel(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].CANCEL);
            this.$mdDialog.show(askFolderName).then(function (folderName) {
                _self_.hierarchyService.$createFolder(_self_.hierarchyService.lastSelectedFolder.relativePath, folderName).subscribe(function (result) {
                    return _self_.operationCompleted(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].$SUCCESS);
                }, function (error) {
                    return _self_.operationCompleted(error.data.message);
                });
            }, function () {
                this.hierarchyService.showToast(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].FOLDER_CREATION_ABORTED);
            });
        }
    }, {
        key: "duplicate",
        value: function duplicate() {
            if (!this.isRowSelected) {
                this.hierarchyService.showToast(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].TOAST_SELECT_BEFORE_ACTION);
            } else {
                this.hierarchyService.showDuplicateModal();
            }
        }
    }, {
        key: "rename",
        value: function rename() {
            if (this.isRowSelected !== 1) {
                this.hierarchyService.showToast(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].TOAST_ERROR_RENAME);
            } else {
                var _self_ = this;
                var askFilename = this.$mdDialog.prompt().title(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].RENAME_NAME_TITLE).required(true).ok(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].RENAME).cancel(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].CANCEL);
                this.$mdDialog.show(askFilename).then(function (newName) {
                    _self_.hierarchyService.$rename(newName).subscribe(function (result) {
                        _self_.operationCompleted(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].$SUCCESS);
                    }, function (error) {
                        _self_.operationCompleted(error.data.message);
                    });
                }, function (fileName) {
                    _self_.hierarchyService.showToast(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].RENAMING_ABORTED);
                });
            }
        }
    }, {
        key: "delete",
        value: function _delete() {
            if (!this.isRowSelected) {
                this.hierarchyService.showToast(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].TOAST_SELECT_BEFORE_ACTION);
            } else {
                var _self_ = this;
                var askForDeletion = this.$mdDialog.confirm().title(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].DELETION_CONFERMATION_MESSAGE).ok(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].YES).cancel(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].NO);
                this.$mdDialog.show(askForDeletion).then(function () {
                    _self_.hierarchyService.$delete().subscribe(function (result) {
                        return _self_.operationCompleted(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].$SUCCESS);
                    }, function (error) {
                        return _self_.operationCompleted(error);
                    });
                }, function () {
                    this.hierarchyService.showToast(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].DELETION_ABORTED);
                });
            }
        }
    }, {
        key: "initializeUploadButtonSettings",
        value: function initializeUploadButtonSettings() {
            var _self_ = this;
            document.getElementById("fileInput").addEventListener("change", function (evt) {
                if (evt.target.files.length > 0) {
                    _self_.hierarchyService.$uploadCapsule(evt.target.files[0]).subscribe(function (result) {
                        $("#fileInput").prop("value", "");
                        _self_.operationCompleted(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].$SUCCESS);
                    }, function (error) {
                        if (error.status === 409) {
                            var ask = _self_.$mdDialog.confirm().title("File already exists!").textContent("The file you are trying to upload already exists. Would you like to overwrite it?").ok(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].YES).cancel(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].NO);
                            _self_.$mdDialog.show(ask).then(function () {
                                _self_.hierarchyService.$uploadCapsule(evt.target.files[0], true).subscribe(function (result) {
                                    _self_.operationCompleted(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].$SUCCESS);
                                    $("#fileInput").prop("value", "");
                                }, function (error) {
                                    _self_.operationCompleted(error.data.message);
                                    $("#fileInput").prop("value", "");
                                });
                            }, function () {
                                _self_.hierarchyService.$uploadCapsule(evt.target.files[0], false).subscribe(function (result) {
                                    _self_.operationCompleted(__WEBPACK_IMPORTED_MODULE_2__common_utils_constants__["a" /* Constant */].$SUCCESS);
                                    $("#fileInput").prop("value", "");
                                }, function (error) {
                                    _self_.operationCompleted(error.data.message);
                                    $("#fileInput").prop("value", "");
                                });
                            });
                        } else {
                            _self_.operationCompleted(error.data.message);
                            $("#fileInput").prop("value", "");
                        }
                    });
                }
            });
            $("#fileInput").prop("value", "");
        }
    }, {
        key: "upload",
        value: function upload() {
            $("#fileInput").click();
        }
    }]);

    return HierarchyControllersCtrl;
}();

HierarchyControllersCtrl.$inject = [__WEBPACK_IMPORTED_MODULE_3__hierarchy_service_hierarchy_service__["a" /* HIERARCHY_SERVICE */], "$mdDialog", "$mdToast", "$scope"];
var hierarchyControllersComponent = {
    controller: HierarchyControllersCtrl,
    template: __webpack_require__("./app/hierarchy-controllers/hierarchyControllers.html"),
    bindings: {}
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./app/hierarchy-controllers/hierarchyControllers.html":
/***/ (function(module, exports) {

module.exports = "<md-toolbar style=background-color:#454545> <div layout-align=\"start center\" layout=row layout-xs=column layout-gt-xs=column layout-gt-md=row style=padding-top:.5%> <md-button id=uploadBtn ng-click=$ctrl.upload() class=\"b-framed-on-dark md-button md-ink-ripple\">{{$ctrl.uploadBtnLbl}}</md-button> <md-button ng-if=\"$ctrl.isRowSelected > 0\" id=downloadBtn class=\"b-framed-on-dark md-button md-ink-ripple\" ng-click=$ctrl.download()>{{$ctrl.downloadBtnLbl}}</md-button> <input id=fileInput name=file type=file class=ng-hide accept=zip> <md-button id=createFolder class=\"b-framed-on-dark md-button md-ink-ripple\" ng-click=$ctrl.createFolder()>{{$ctrl.createFolderLbl}}</md-button> <md-button ng-if=\"$ctrl.isRowSelected > 0\" id=delete class=\"b-framed-on-dark md-button md-ink-ripple\" ng-click=$ctrl.delete()>{{$ctrl.deleteBtnLbl}}</md-button> <md-button ng-if=\"$ctrl.isRowSelected > 0\" id=move class=\"b-framed-on-dark md-button md-ink-ripple\" ng-click=$ctrl.move()>{{$ctrl.moveBtnLbl}}</md-button> <md-button ng-if=\"$ctrl.isRowSelected > 0\" id=duplicate class=\"b-framed-on-dark md-button md-ink-ripple\" ng-click=$ctrl.duplicate()>{{$ctrl.duplicateBtnLbl}}</md-button> <md-button ng-if=\"$ctrl.isRowSelected == 1\" id=rename class=\"b-framed-on-dark md-button md-ink-ripple\" ng-click=$ctrl.rename()>{{$ctrl.renameBtnLbl}}</md-button> </div> </md-toolbar>";

/***/ }),

/***/ "./app/hierarchy-controllers/hierarchyControllers.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/hierarchy-controllers/hierarchyControllers.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/hierarchy-controllers/hierarchyControllers.less", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/hierarchy-controllers/hierarchyControllers.less");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/hierarchy-controllers/hierarchyControllers.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_service_hierarchy_service__ = __webpack_require__("./app/hierarchy-service/hierarchy.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hierarchyControllers_component__ = __webpack_require__("./app/hierarchy-controllers/hierarchyControllers.component.ts");



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.hierarchyControllers", []).component(__WEBPACK_IMPORTED_MODULE_2__hierarchyControllers_component__["a" /* HIERARCHY_CONTROLLERS_COMPONENT */], __WEBPACK_IMPORTED_MODULE_2__hierarchyControllers_component__["b" /* hierarchyControllersComponent */]).service(__WEBPACK_IMPORTED_MODULE_1__hierarchy_service_hierarchy_service__["a" /* HIERARCHY_SERVICE */], __WEBPACK_IMPORTED_MODULE_1__hierarchy_service_hierarchy_service__["b" /* HierarchyService */]).name);

/***/ }),

/***/ "./app/hierarchy-grid/hierarchy.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_kendo_ui_js_kendo_angular__ = __webpack_require__("./node_modules/@progress/kendo-ui/js/kendo.angular.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_kendo_ui_js_kendo_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__progress_kendo_ui_js_kendo_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_core__ = __webpack_require__("./node_modules/@progress/kendo-ui/js/kendo.core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_ui_js_kendo_data__ = __webpack_require__("./node_modules/@progress/kendo-ui/js/kendo.data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_ui_js_kendo_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_ui_js_kendo_data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_kendo_ui_js_kendo_grid__ = __webpack_require__("./node_modules/@progress/kendo-ui/js/kendo.grid.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_kendo_ui_js_kendo_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__progress_kendo_ui_js_kendo_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hierarchy_service_hierarchy_service__ = __webpack_require__("./app/hierarchy-service/hierarchy.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hierarchyGrid_component__ = __webpack_require__("./app/hierarchy-grid/hierarchyGrid.component.ts");







/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_angular__["module"]("board.web.admin.hierarchyGrid", ["kendo.directives"]).component(__WEBPACK_IMPORTED_MODULE_6__hierarchyGrid_component__["a" /* HIERARCHY_COMPONENT */], __WEBPACK_IMPORTED_MODULE_6__hierarchyGrid_component__["b" /* hierarchyGridComponent */]).service(__WEBPACK_IMPORTED_MODULE_5__hierarchy_service_hierarchy_service__["a" /* HIERARCHY_SERVICE */], __WEBPACK_IMPORTED_MODULE_5__hierarchy_service_hierarchy_service__["b" /* HierarchyService */]).name);

/***/ }),

/***/ "./app/hierarchy-grid/hierarchyGrid.component.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIERARCHY_COMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hierarchyGridComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchyGrid_less__ = __webpack_require__("./app/hierarchy-grid/hierarchyGrid.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchyGrid_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__hierarchyGrid_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_service_hierarchy_service__ = __webpack_require__("./app/hierarchy-service/hierarchy.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hierarchy_support_KendoGridCapsuleFolder__ = __webpack_require__("./app/hierarchy-support/KendoGridCapsuleFolder.ts");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var HIERARCHY_COMPONENT = "hierarchyGridComponent";

var HierarchyGridCtrl = function () {
    function HierarchyGridCtrl(hierarchyService, $mdToast, $mdDialog) {
        var _this = this;

        _classCallCheck(this, HierarchyGridCtrl);

        this.hierarchyService = hierarchyService;
        this.$mdToast = $mdToast;
        this.$mdDialog = $mdDialog;
        var _self_ = this;
        this.gridOptions = {
            filterable: {
                extra: false,
                operators: {
                    string: {
                        startswith: "Starts with",
                        eq: "Is equal to",
                        neq: "Is not equal to"
                    },
                    number: {
                        eq: "Is equal to",
                        neq: "Is not equal to",
                        gte: "Is greater or equal to",
                        gt: "Is greater than",
                        lte: "Is less than or equal to",
                        lt: "Is less than"
                    }
                }
            },
            columns: [{ selectable: true, width: "25px" }, {
                field: "icon",
                title: " ",
                width: "25px",
                filterable: false,
                sortable: false,
                template: function template(dataItem) {
                    if (dataItem.isFolder) {
                        return "<md-icon class=\"hierachyGridIcon\" md-svg-src=\"admin:folder\"></md-icon>";
                    } else {
                        return "<md-icon class=\"hierachyGridIcon\" md-svg-src=\"admin:file\"></md-icon>";
                    }
                }
            }, {
                field: "fileFolderName",
                template: function template(dataItem) {
                    return "<span ng-non-bindable>" + dataItem.fileFolderName + "</span>";
                },
                title: "File/Folder name",
                width: "75px"
            }, {
                field: "fileFolderSize",
                title: "Size (Kb)",
                width: "50px",
                attributes: { style: "text-align:right" }
            }, { field: "filefolderLastModifiedDate", title: "Last modified date", width: "100px", attributes: { style: "text-align:right" } }],
            resizable: true,
            pageable: true,
            sortable: true,
            scrollable: false,
            change: function change(e) {
                var selectedRows = this.select();
                var selectedDataItems = [];
                for (var i = 0; i < selectedRows.length; i++) {
                    var dataItem = this.dataItem(selectedRows[i]);
                    selectedDataItems.push(dataItem);
                }
                _self_.hierarchyService.updateKendoSelectedData(selectedDataItems);
            }
        };
        this.initiazileDatagrid();
        this.hierarchyService.$getSelectedFolder().subscribe(function (value) {
            if (value != null) {
                _this.selectedFolder = value;
                _this.updateKendoData();
            }
        });
    }

    _createClass(HierarchyGridCtrl, [{
        key: "initiazileDatagrid",
        value: function initiazileDatagrid() {
            this.kendoData = [];
            this.gridDataSource = new kendo.data.DataSource({
                pageSize: 20,
                data: this.kendoData,
                schema: {
                    model: {
                        fields: {
                            fileFolderName: { type: "string" },
                            fileFolderSize: { type: "number" },
                            filefolderLastModifiedDate: { type: "string" }
                        }
                    }
                }
            });
        }
    }, {
        key: "updateKendoData",
        value: function updateKendoData() {
            var _this2 = this;

            var gridUpdated = false;
            this.initiazileDatagrid();
            if (this.selectedFolder.subFolders) {
                this.selectedFolder.subFolders.forEach(function (folder) {
                    _this2.kendoData.push(new __WEBPACK_IMPORTED_MODULE_2__hierarchy_support_KendoGridCapsuleFolder__["a" /* KendoGridCapsuleFolder */](folder.name, "", folder.size, folder.modifiedDate, true));
                });
                gridUpdated = true;
            }
            if (this.selectedFolder.files) {
                this.selectedFolder.files.forEach(function (file) {
                    _this2.kendoData.push(new __WEBPACK_IMPORTED_MODULE_2__hierarchy_support_KendoGridCapsuleFolder__["a" /* KendoGridCapsuleFolder */](file.name, file.extension, file.size, file.modifiedDate, false));
                });
                gridUpdated = true;
            }
            if (gridUpdated) {
                this.gridDataSource.fetch();
            }
        }
    }]);

    return HierarchyGridCtrl;
}();

HierarchyGridCtrl.$inject = [__WEBPACK_IMPORTED_MODULE_1__hierarchy_service_hierarchy_service__["a" /* HIERARCHY_SERVICE */], "$mdToast", "$mdDialog"];
var hierarchyGridComponent = {
    controller: HierarchyGridCtrl,
    template: __webpack_require__("./app/hierarchy-grid/hierarchyGrid.html"),
    bindings: {}
};

/***/ }),

/***/ "./app/hierarchy-grid/hierarchyGrid.html":
/***/ (function(module, exports) {

module.exports = "<div> <kendo-grid class=sysAdminGridK options=$ctrl.gridOptions data-source=$ctrl.gridDataSource rebind=$ctrl.gridDataSource> </kendo-grid> </div> ";

/***/ }),

/***/ "./app/hierarchy-grid/hierarchyGrid.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/hierarchy-grid/hierarchyGrid.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/hierarchy-grid/hierarchyGrid.less", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/hierarchy-grid/hierarchyGrid.less");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/hierarchy-modal/hierachyModal.component.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIERARCHY_MODAL_COMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hierarchyModalComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchyModal_less__ = __webpack_require__("./app/hierarchy-modal/hierarchyModal.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchyModal_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__hierarchyModal_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_service_hierarchy_service__ = __webpack_require__("./app/hierarchy-service/hierarchy.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hierarchy_support_abstractHierarchySidenav__ = __webpack_require__("./app/hierarchy-support/abstractHierarchySidenav.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_constants__ = __webpack_require__("./app/common/utils/constants.ts");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var HIERARCHY_MODAL_COMPONENT = "hierarchyModalComponent";

var HierarchyModalController = function (_AbstractHierarchySid) {
    _inherits(HierarchyModalController, _AbstractHierarchySid);

    function HierarchyModalController(hierarchyService, $mdToast, $mdDialog) {
        _classCallCheck(this, HierarchyModalController);

        var _this = _possibleConstructorReturn(this, (HierarchyModalController.__proto__ || Object.getPrototypeOf(HierarchyModalController)).call(this, hierarchyService, $mdToast, $mdDialog));

        _this.hierarchyService = hierarchyService;
        _this.$mdToast = $mdToast;
        _this.$mdDialog = $mdDialog;
        _this.overridingQuestionDialog = _this.$mdDialog.confirm().title("File already exists!").textContent("The file you are trying to upload already exists. Would you like to overwrite it?").ok(__WEBPACK_IMPORTED_MODULE_3__common_utils_constants__["a" /* Constant */].YES).cancel(__WEBPACK_IMPORTED_MODULE_3__common_utils_constants__["a" /* Constant */].NO);
        _this.selectedCapsuleFolder = null;
        _this.hierarchyService.modalCaller.subscribe(function (res) {
            _this.modalCaller = res;
            _this.exploringData.forEach(function (el) {
                return el.isSelected = false;
            });
            _this.exploringData.forEach(function (el) {
                if (el.parent.relativePath !== "") {
                    el.isVisible = false;
                }
            });
        });
        return _this;
    }

    _createClass(HierarchyModalController, [{
        key: "navigateFolder",
        value: function navigateFolder(selectedCapsule) {
            this.exploringData.forEach(function (el) {
                return el.isSelected = false;
            });
            selectedCapsule.isSelected = true;
            this.selectedCapsuleFolder = selectedCapsule.originCapsule;
            if (selectedCapsule.originCapsule.subFolders) {
                this.expandCollapseFolderCascade(selectedCapsule.originCapsule.relativePath, null);
            }
        }
    }, {
        key: "operationCompleted",
        value: function operationCompleted(message) {
            this.hierarchyService.showToast(message === "" ? __WEBPACK_IMPORTED_MODULE_3__common_utils_constants__["a" /* Constant */].SUCCESS : message);
            this.hierarchyService.stoppingAsyncOperation();
        }
    }, {
        key: "submit",
        value: function submit() {
            if (!this.selectedCapsuleFolder || this.selectedCapsuleFolder.name === "") {
                this.hierarchyService.showToast("Please select a valid destination");
            } else if (this.modalCaller != null) {
                if (this.modalCaller === __WEBPACK_IMPORTED_MODULE_1__hierarchy_service_hierarchy_service__["c" /* ModalCaller */].DUPLICATE) {
                    this.submitDuplicate();
                } else if (this.modalCaller === __WEBPACK_IMPORTED_MODULE_1__hierarchy_service_hierarchy_service__["c" /* ModalCaller */].MOVE) {
                    this.submitMove();
                }
            }
            this.selectedCapsuleFolder = null;
        }
    }, {
        key: "submitMove",
        value: function submitMove() {
            this.hierarchyService.showHideModal();
            var _self_ = this;
            var destinationSelectedPath = this.selectedCapsuleFolder.relativePath;
            this.hierarchyService.$moveCapsule(destinationSelectedPath).subscribe(function (result) {
                return _self_.operationCompleted(__WEBPACK_IMPORTED_MODULE_3__common_utils_constants__["a" /* Constant */].$SUCCESS);
            }, function (err) {
                if (err.status === 409) {
                    _self_.$mdDialog.show(_self_.overridingQuestionDialog).then(function () {
                        _self_.hierarchyService.$moveCapsule(destinationSelectedPath, true).subscribe(function (result) {
                            return _self_.operationCompleted(__WEBPACK_IMPORTED_MODULE_3__common_utils_constants__["a" /* Constant */].$SUCCESS);
                        }, function (error) {
                            return _self_.operationCompleted(error.data.message);
                        });
                    }, function () {
                        _self_.hierarchyService.$moveCapsule(destinationSelectedPath, false).subscribe(function (result) {
                            return _self_.operationCompleted(__WEBPACK_IMPORTED_MODULE_3__common_utils_constants__["a" /* Constant */].$SUCCESS);
                        }, function (error) {
                            return _self_.operationCompleted(error.data.message);
                        });
                    });
                }
            });
        }
    }, {
        key: "abort",
        value: function abort() {
            this.selectedCapsuleFolder = null;
            this.hierarchyService.showHideModal();
        }
    }, {
        key: "submitDuplicate",
        value: function submitDuplicate() {
            var _this2 = this;

            this.hierarchyService.showHideModal();
            var _self_ = this;
            var destinationSelectedPath = this.selectedCapsuleFolder.relativePath;
            this.hierarchyService.$duplicateCapsule(destinationSelectedPath).subscribe(function (result) {
                return _self_.operationCompleted(__WEBPACK_IMPORTED_MODULE_3__common_utils_constants__["a" /* Constant */].$SUCCESS);
            }, function (err) {
                if (err.status === 409) {
                    _self_.$mdDialog.show(_this2.overridingQuestionDialog).then(function () {
                        _self_.hierarchyService.$duplicateCapsule(destinationSelectedPath, true).subscribe(function (result) {
                            return _self_.operationCompleted(__WEBPACK_IMPORTED_MODULE_3__common_utils_constants__["a" /* Constant */].$SUCCESS);
                        }, function (error) {
                            return _self_.operationCompleted(error.data.message);
                        });
                    }, function () {
                        _self_.hierarchyService.$duplicateCapsule(destinationSelectedPath, false).subscribe(function (result) {
                            return _self_.operationCompleted(__WEBPACK_IMPORTED_MODULE_3__common_utils_constants__["a" /* Constant */].$SUCCESS);
                        }, function (error) {
                            return _self_.operationCompleted(error.data.message);
                        });
                    });
                }
            });
        }
    }]);

    return HierarchyModalController;
}(__WEBPACK_IMPORTED_MODULE_2__hierarchy_support_abstractHierarchySidenav__["a" /* AbstractHierarchySidenav */]);

HierarchyModalController.$inject = [__WEBPACK_IMPORTED_MODULE_1__hierarchy_service_hierarchy_service__["a" /* HIERARCHY_SERVICE */], "$mdToast", "$mdDialog"];
var hierarchyModalComponent = {
    controller: HierarchyModalController,
    template: __webpack_require__("./app/hierarchy-modal/hierarchyModal.html"),
    bindings: {}
};

/***/ }),

/***/ "./app/hierarchy-modal/hierarchyModal.html":
/***/ (function(module, exports) {

module.exports = "<div id=hierarchyModal layout=column> <md-toolbar id=capsuleToolbar class=md-accent> <h5 class=md-toolbar-tools> <span>Choose destination</span> </h5> </md-toolbar> <div id=hierarchyModalParent layout=column> <md-sidenav style=max-width:600px class=\"md-sidenav-left cloudAdmin-sidenav\" md-is-locked-open=true layout-fill> <md-list> <md-list-item ng-class=\"{ 'folderSelected' : $ctrl.rootFolder.isSelected > 0}\" ng-click=$ctrl.navigateFolder($ctrl.rootFolder)> <div layout-align=\"start center\"> <md-icon style=color:#fff md-svg-src=admin:folder></md-icon> </div> <div flex layout-fill> <h4 style=text-align:left;padding-left:5%>Navigate to root</h4> </div> </md-list-item> <md-list-item class=\"md-2-line _md-button-wrap ng-scope _md md-clickable\" ng-class=\"{ 'folderSelected' : folder.isSelected > 0}\" ng-repeat=\"folder in $ctrl.exploringData\" ng-if=folder.isVisible ng-click=$ctrl.navigateFolder(folder)> <div layout-align=\"start center\" ng-style=$ctrl.getPadding(folder)> <md-icon style=color:#fff md-svg-src=admin:folder></md-icon> </div> <div flex layout-fill> <h4 style=text-align:left;padding-left:5%>{{folder.folderName}}</h4> </div> </md-list-item> </md-list> </md-sidenav> </div> <div layout=row id=hierarchyModalControllers layout-align=\"center center\"> <md-button ng-click=$ctrl.abort()>Cancel</md-button> <md-button ng-click=$ctrl.submit()>Ok</md-button> </div> </div>";

/***/ }),

/***/ "./app/hierarchy-modal/hierarchyModal.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/hierarchy-modal/hierarchyModal.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/hierarchy-modal/hierarchyModal.less", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/hierarchy-modal/hierarchyModal.less");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/hierarchy-modal/hierarchyModal.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_service_hierarchy_service__ = __webpack_require__("./app/hierarchy-service/hierarchy.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hierachyModal_component__ = __webpack_require__("./app/hierarchy-modal/hierachyModal.component.ts");



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.hierarchyModal", []).component(__WEBPACK_IMPORTED_MODULE_2__hierachyModal_component__["a" /* HIERARCHY_MODAL_COMPONENT */], __WEBPACK_IMPORTED_MODULE_2__hierachyModal_component__["b" /* hierarchyModalComponent */]).service(__WEBPACK_IMPORTED_MODULE_1__hierarchy_service_hierarchy_service__["a" /* HIERARCHY_SERVICE */], __WEBPACK_IMPORTED_MODULE_1__hierarchy_service_hierarchy_service__["b" /* HierarchyService */]).name);

/***/ }),

/***/ "./app/hierarchy-nav/hierachySidenav.component.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIERARCHY_SIDENAV_COMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hierarchySidenavComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchySidenav_less__ = __webpack_require__("./app/hierarchy-nav/hierarchySidenav.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchySidenav_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__hierarchySidenav_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_service_hierarchy_service__ = __webpack_require__("./app/hierarchy-service/hierarchy.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hierarchy_support_abstractHierarchySidenav__ = __webpack_require__("./app/hierarchy-support/abstractHierarchySidenav.ts");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var HIERARCHY_SIDENAV_COMPONENT = "hierarchySidenavComponent";

var HierarchySidenavController = function (_AbstractHierarchySid) {
    _inherits(HierarchySidenavController, _AbstractHierarchySid);

    function HierarchySidenavController(hierarchyService, $mdToast, $mdDialog) {
        _classCallCheck(this, HierarchySidenavController);

        var _this = _possibleConstructorReturn(this, (HierarchySidenavController.__proto__ || Object.getPrototypeOf(HierarchySidenavController)).call(this, hierarchyService, $mdToast, $mdDialog));

        _this.hierarchyService = hierarchyService;
        _this.$mdToast = $mdToast;
        _this.$mdDialog = $mdDialog;
        _this.exploringData = [];
        return _this;
    }

    _createClass(HierarchySidenavController, [{
        key: "navigateFolder",
        value: function navigateFolder(selectedCapsule) {
            this.rootFolder.isSelected = false;
            this.exploringData.forEach(function (el) {
                return el.isSelected = false;
            });
            selectedCapsule.isSelected = true;
            this.hierarchyService.updateSelectedFolder(selectedCapsule.originCapsule);
            this.expandCollapseFolderCascade(selectedCapsule.originCapsule.relativePath, null);
        }
    }]);

    return HierarchySidenavController;
}(__WEBPACK_IMPORTED_MODULE_2__hierarchy_support_abstractHierarchySidenav__["a" /* AbstractHierarchySidenav */]);

HierarchySidenavController.$inject = [__WEBPACK_IMPORTED_MODULE_1__hierarchy_service_hierarchy_service__["a" /* HIERARCHY_SERVICE */], "$mdToast", "$mdDialog"];
var hierarchySidenavComponent = {
    controller: HierarchySidenavController,
    template: __webpack_require__("./app/hierarchy-nav/hierarchySidenav.html"),
    bindings: {}
};

/***/ }),

/***/ "./app/hierarchy-nav/hierarchySideNav.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_service_hierarchy_service__ = __webpack_require__("./app/hierarchy-service/hierarchy.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hierachySidenav_component__ = __webpack_require__("./app/hierarchy-nav/hierachySidenav.component.ts");



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.hierarchySidenav", []).component(__WEBPACK_IMPORTED_MODULE_2__hierachySidenav_component__["a" /* HIERARCHY_SIDENAV_COMPONENT */], __WEBPACK_IMPORTED_MODULE_2__hierachySidenav_component__["b" /* hierarchySidenavComponent */]).service(__WEBPACK_IMPORTED_MODULE_1__hierarchy_service_hierarchy_service__["a" /* HIERARCHY_SERVICE */], __WEBPACK_IMPORTED_MODULE_1__hierarchy_service_hierarchy_service__["b" /* HierarchyService */]).name);

/***/ }),

/***/ "./app/hierarchy-nav/hierarchySidenav.html":
/***/ (function(module, exports) {

module.exports = " <md-sidenav class=cloudAdmin-sidenav md-is-locked-open=true layout-fill> <md-list> <md-list-item ng-class=\"{ 'folderSelected' : $ctrl.rootFolder.isSelected > 0}\" ng-click=$ctrl.navigateFolder($ctrl.rootFolder)> <div layout-align=\"start center\"> <md-icon style=color:#fff md-svg-src=admin:folder></md-icon> </div> <div flex=70 layout-align=\"end center\"> <h4 style=text-align:left;padding-left:5%>Navigate to root</h4> </div> </md-list-item> <md-list-item class=\"_md-button-wrap ng-scope _md md-clickable\" ng-class=\"{ 'folderSelected' : folder.isSelected > 0}\" ng-click=$ctrl.navigateFolder(folder) ng-repeat=\"folder in $ctrl.exploringData\" ng-if=folder.isVisible> <div layout-align=\"start center\" ng-style=$ctrl.getPadding(folder)> <md-icon style=color:#fff md-svg-src=admin:folder></md-icon> </div> <div flex=70 layout-align=\"end center\"> <h4 style=text-align:left;padding-left:5% layout-align=\"end center\">{{folder.folderName}}</h4> </div> </md-list-item> </md-list> </md-sidenav>";

/***/ }),

/***/ "./app/hierarchy-nav/hierarchySidenav.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/hierarchy-nav/hierarchySidenav.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/hierarchy-nav/hierarchySidenav.less", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/hierarchy-nav/hierarchySidenav.less");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/hierarchy-service/hierarchy.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIERARCHY_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ModalCaller; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HierarchyService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__("./node_modules/rxjs/Rx.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__capsule_capsule_service__ = __webpack_require__("./app/capsule/capsule.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__capsule_capsuleFolder__ = __webpack_require__("./app/capsule/capsuleFolder.ts");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var HIERARCHY_SERVICE = "HierarchyService";
var ModalCaller;
(function (ModalCaller) {
    ModalCaller[ModalCaller["MOVE"] = 0] = "MOVE";
    ModalCaller[ModalCaller["DUPLICATE"] = 1] = "DUPLICATE";
})(ModalCaller || (ModalCaller = {}));
var HierarchyService = function () {
    function HierarchyService(capsuleService, $mdToast) {
        var _this = this;

        _classCallCheck(this, HierarchyService);

        this.capsuleService = capsuleService;
        this.$mdToast = $mdToast;
        this.selectedFolder = new __WEBPACK_IMPORTED_MODULE_0_rxjs__["BehaviorSubject"](null);
        this.rootFolder = new __WEBPACK_IMPORTED_MODULE_0_rxjs__["BehaviorSubject"](null);
        this.selectedKendoData = [];
        this.modalCaller = new __WEBPACK_IMPORTED_MODULE_0_rxjs__["BehaviorSubject"](null);
        this.rowSelected = new __WEBPACK_IMPORTED_MODULE_0_rxjs__["BehaviorSubject"](0);
        var _self_ = this;
        this.capsuleService.$getExistingCapsule().subscribe(function (value) {
            _self_.rootFolder.next(value);
            if (_self_.lastSelectedFolder && _self_.lastSelectedFolder.relativePath) {
                var newSelectedFolder = _self_.capsuleService.lookupCapsuleByPath(_self_.lastSelectedFolder.relativePath, value);
                _self_.selectedFolder.next(newSelectedFolder);
            } else {
                _self_.selectedFolder.next(value);
            }
        });
        this.selectedFolder.subscribe(function (value) {
            _this.lastSelectedFolder = Object.assign({}, value);
        });
    }

    _createClass(HierarchyService, [{
        key: "resetSelectedRows",
        value: function resetSelectedRows() {
            this.rowSelected.next(0);
        }
    }, {
        key: "showToast",
        value: function showToast(message) {
            this.$mdToast.show(this.$mdToast.simple().textContent(message).position("top right"));
        }
    }, {
        key: "buildCapsuleFromKendoData",
        value: function buildCapsuleFromKendoData(selectedRows) {
            var _this2 = this;

            var returningCapsule = new __WEBPACK_IMPORTED_MODULE_2__capsule_capsuleFolder__["b" /* CapsuleFolder */](this.lastSelectedFolder.name, this.lastSelectedFolder.relativePath);
            if (selectedRows) {
                selectedRows.forEach(function (row) {
                    if (!row.isFolder) {
                        returningCapsule.files.push(new __WEBPACK_IMPORTED_MODULE_2__capsule_capsuleFolder__["a" /* CapsuleFile */](row.fileFolderName, row.extension));
                    } else {
                        var rowFolderPath = _this2.lastSelectedFolder.subFolders.find(function (el) {
                            return el.name === row.fileFolderName;
                        }).relativePath;
                        returningCapsule.subFolders.push(new __WEBPACK_IMPORTED_MODULE_2__capsule_capsuleFolder__["b" /* CapsuleFolder */](row.fileFolderName, rowFolderPath));
                    }
                });
            }
            return returningCapsule;
        }
    }, {
        key: "stoppingAsyncOperation",
        value: function stoppingAsyncOperation() {
            this.capsuleService.stoppingAsyncOperation();
        }
    }, {
        key: "updateKendoSelectedData",
        value: function updateKendoSelectedData(kendoSelectedData) {
            this.selectedKendoData = kendoSelectedData;
            this.rowSelected.next(this.selectedKendoData ? this.selectedKendoData.length : this.selectedKendoData.length);
        }
    }, {
        key: "$uploadCapsule",
        value: function $uploadCapsule(file) {
            var override = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            return this.capsuleService.$upload(this.lastSelectedFolder, file, override);
        }
    }, {
        key: "$downloadCapsule",
        value: function $downloadCapsule(filename) {
            this.capsuleService.$download(this.buildCapsuleFromKendoData(this.selectedKendoData), filename);
        }
    }, {
        key: "$rename",
        value: function $rename(filename) {
            return this.capsuleService.$rename(this.buildCapsuleFromKendoData(this.selectedKendoData), filename);
        }
    }, {
        key: "$createFolder",
        value: function $createFolder(destinationPath, folderName) {
            return this.capsuleService.$createFolder(destinationPath, folderName);
        }
    }, {
        key: "$moveCapsule",
        value: function $moveCapsule(destionationPath) {
            var override = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            return this.capsuleService.$move(this.buildCapsuleFromKendoData(this.selectedKendoData), destionationPath, override);
        }
    }, {
        key: "$duplicateCapsule",
        value: function $duplicateCapsule(destionationPath) {
            var override = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            return this.capsuleService.$duplicate(this.buildCapsuleFromKendoData(this.selectedKendoData), destionationPath, override);
        }
    }, {
        key: "$delete",
        value: function $delete() {
            return this.capsuleService.$delete(this.buildCapsuleFromKendoData(this.selectedKendoData));
        }
    }, {
        key: "showHideModal",
        value: function showHideModal() {
            this.capsuleService.showHideModal();
        }
    }, {
        key: "showMoveModal",
        value: function showMoveModal() {
            this.modalCaller.next(ModalCaller.MOVE);
            this.showHideModal();
        }
    }, {
        key: "showDuplicateModal",
        value: function showDuplicateModal() {
            this.modalCaller.next(ModalCaller.DUPLICATE);
            this.showHideModal();
        }
    }, {
        key: "updateSelectedFolder",
        value: function updateSelectedFolder(selectedFolder) {
            this.selectedFolder.next(selectedFolder);
        }
    }, {
        key: "$getSelectedFolder",
        value: function $getSelectedFolder() {
            return this.selectedFolder.asObservable();
        }
    }, {
        key: "$getRootFolder",
        value: function $getRootFolder() {
            return this.rootFolder.asObservable();
        }
    }]);

    return HierarchyService;
}();
HierarchyService.$inject = [__WEBPACK_IMPORTED_MODULE_1__capsule_capsule_service__["a" /* CAPSULE_SERVICE */], "$mdToast"];

/***/ }),

/***/ "./app/hierarchy-support/KendoGridCapsuleFolder.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KendoGridCapsuleFolder; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoGridCapsuleFolder = function KendoGridCapsuleFolder(name, extension, size, lastModifiedDate, isFolder) {
    _classCallCheck(this, KendoGridCapsuleFolder);

    this.filefolderLastModifiedDate = lastModifiedDate;
    this.extension = extension;
    this.fileFolderName = name;
    this.fileFolderSize = size;
    this.isFolder = isFolder;
};

/***/ }),

/***/ "./app/hierarchy-support/abstractHierarchySidenav.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AbstractHierarchySidenav; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchy_service_hierarchy_service__ = __webpack_require__("./app/hierarchy-service/hierarchy.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exploringElement__ = __webpack_require__("./app/hierarchy-support/exploringElement.ts");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var AbstractHierarchySidenav = function () {
    function AbstractHierarchySidenav(hierarchyService, $mdToast, $mdDialog) {
        var _this = this;

        _classCallCheck(this, AbstractHierarchySidenav);

        this.hierarchyService = hierarchyService;
        this.$mdToast = $mdToast;
        this.$mdDialog = $mdDialog;
        this.basicPadding = 16;
        this.expandedFolderPaths = [];
        this.exploringData = [];
        this.hierarchyService.$getRootFolder().subscribe(function (value) {
            if (value != null) {
                _this.rootFolder = new __WEBPACK_IMPORTED_MODULE_1__exploringElement__["a" /* ExploringElement */](0, value.name, false, value, true, value);
                _this.exploringData = [];
                _this.normalizeData(value, true);
                _this.updateExpandingFolders();
            }
        });
    }

    _createClass(AbstractHierarchySidenav, [{
        key: "getPadding",
        value: function getPadding(folder) {
            return { paddingLeft: folder.leftPadding };
        }
    }, {
        key: "normalizeData",
        value: function normalizeData(folder, isVisible) {
            var _this2 = this;

            var givenPadding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

            if (folder) {
                if (folder.subFolders) {
                    folder.subFolders.forEach(function (subFolder) {
                        _this2.exploringData.push(new __WEBPACK_IMPORTED_MODULE_1__exploringElement__["a" /* ExploringElement */](givenPadding, subFolder.name, false, folder, _this2.expandedFolderPaths.indexOf(subFolder.relativePath) >= 0 ? true : isVisible, subFolder));
                        _this2.normalizeData(subFolder, false, _this2.basicPadding + givenPadding);
                    });
                }
            }
        }
    }, {
        key: "updateExpandingFolders",
        value: function updateExpandingFolders() {
            var _this3 = this;

            var _self_ = this;
            this.exploringData.forEach(function (folder) {
                if (!folder.isVisible) {
                    folder.isVisible = _self_.exploringData.find(function (el) {
                        return el.parent.relativePath === folder.parent.relativePath;
                    }).isVisible;
                }
                if (folder.originCapsule.relativePath === _this3.hierarchyService.lastSelectedFolder.relativePath) {
                    folder.isSelected = true;
                }
            });
        }
    }, {
        key: "expandCollapseFolderCascade",
        value: function expandCollapseFolderCascade(collapsingExpandingFolderPath, forceValue) {
            var _this4 = this;

            this.exploringData.forEach(function (folder) {
                if (folder.parent.relativePath === collapsingExpandingFolderPath && folder.originCapsule.relativePath !== collapsingExpandingFolderPath) {
                    folder.isVisible = forceValue != null ? forceValue.valueOf() : !folder.isVisible;
                    if (!folder.isVisible) {
                        /* We just collapse a folder, we have to collapse all the subfolders*/
                        _this4.expandedFolderPaths = _this4.expandedFolderPaths.filter(function (data) {
                            return data === folder.originCapsule.relativePath;
                        });
                        _this4.expandCollapseFolderCascade(folder.originCapsule.relativePath, false);
                    } else {
                        _this4.expandedFolderPaths.push(folder.originCapsule.relativePath);
                    }
                }
            });
        }
    }, {
        key: "isExpandable",
        value: function isExpandable(folder) {
            if (folder) {
                if (folder.originCapsule) {
                    if (folder.originCapsule.files && folder.originCapsule.files.length > 0 || folder.originCapsule.subFolders && folder.originCapsule.subFolders.length > 0) {
                        return true;
                    }
                }
            }
            return false;
        }
    }]);

    return AbstractHierarchySidenav;
}();
AbstractHierarchySidenav.$inject = [__WEBPACK_IMPORTED_MODULE_0__hierarchy_service_hierarchy_service__["a" /* HIERARCHY_SERVICE */], "$mdToast", "$mdDialog"];

/***/ }),

/***/ "./app/hierarchy-support/exploringElement.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExploringElement; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExploringElement = function ExploringElement(leftPadding, folderName, isSelected, parent, isVisible, originCapsule) {
    _classCallCheck(this, ExploringElement);

    this.leftPadding = leftPadding;
    this.folderName = folderName;
    this.isSelected = isSelected;
    this.parent = parent;
    this.isVisible = isVisible;
    this.originCapsule = originCapsule;
};

/***/ }),

/***/ "./app/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_expose_loader_jQuery_jquery__ = __webpack_require__("./node_modules/expose-loader/index.js?jQuery!./node_modules/jquery/dist/jquery.js-exposed");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_expose_loader_jQuery_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_expose_loader_jQuery_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_signalr_jquery_signalR_js__ = __webpack_require__("./node_modules/signalr/jquery.signalR.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_signalr_jquery_signalR_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_signalr_jquery_signalR_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill__ = __webpack_require__("./node_modules/babel-polyfill/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_kendo_ui_css_web_kendo_common_less__ = __webpack_require__("./node_modules/@progress/kendo-ui/css/web/kendo.common.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_kendo_ui_css_web_kendo_common_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__progress_kendo_ui_css_web_kendo_common_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_ui_css_web_kendo_materialblack_less__ = __webpack_require__("./node_modules/@progress/kendo-ui/css/web/kendo.materialblack.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_ui_css_web_kendo_materialblack_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_ui_css_web_kendo_materialblack_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_less__ = __webpack_require__("./app/app.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__app_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__zbootstrap__ = __webpack_require__("./app/zbootstrap.ts");



// HMR for development
if (true) {
    module.hot.accept();
}




$.getScript("signalr/hubs").then(function () {
    Object(__WEBPACK_IMPORTED_MODULE_6__zbootstrap__["e" /* getEndpoints */])().then(function (endpoints) {
        if (false) {
            $.connection.hub.url = 'https://localhost:9000/signalr';
        }
        var userManagers = Object(__WEBPACK_IMPORTED_MODULE_6__zbootstrap__["d" /* buildUserManagers */])(endpoints.adminEndpoint, endpoints.webEndpoint, endpoints.idpEndpoint);
        if (Object(__WEBPACK_IMPORTED_MODULE_6__zbootstrap__["a" /* anonymousBootstrap */])(window.location.href)) {
            Object(__WEBPACK_IMPORTED_MODULE_6__zbootstrap__["b" /* bootstrapAnonymousApplication */])(userManagers.adminUserManager);
        } else {
            userManagers.adminUserManager.getUser().then(function (user) {
                if (user === null) {
                    userManagers.adminUserManager.signinRedirect().then(null, function (reason) {
                        console.error('Error while redirect to login page (' + JSON.stringify(reason) + ')');
                    });
                } else {
                    if (!!endpoints.idpEndpoint) {
                        var webEndpoint = endpoints.webEndpoint.endsWith('/') ? endpoints.webEndpoint : endpoints.webEndpoint + '/';
                        var isAdminKey = ('isAdmin_' + webEndpoint).toLowerCase();
                        var isAdmin = false;
                        for (var key in user.profile) {
                            if (key.toLowerCase() === isAdminKey) {
                                isAdmin = !!user.profile[key] ? user.profile[key].toLowerCase() === 'true' : false;
                                break;
                            }
                        }
                        if (!isAdmin) {
                            // Se non ha i permessi per accedere all'admin tool viene rediretto sull'istanza Board
                            window.location.href = webEndpoint;
                        }
                    }
                    Object(__WEBPACK_IMPORTED_MODULE_6__zbootstrap__["c" /* bootstrapAuthorizedApplication */])(userManagers.adminUserManager, user, userManagers.webUserManager, endpoints.webEndpoint, endpoints.idpEndpoint);
                }
            });
        }
    }, function (reason) {
        console.error("Unable to contact API to get client informations");
        console.error(reason);
    });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./app/instance-settings/instance-settings.component.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INSTANCE_SETTINGS_COMPONENT", function() { return INSTANCE_SETTINGS_COMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "instanceSettingsComponentOptions", function() { return instanceSettingsComponentOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instance_settings_less__ = __webpack_require__("./app/instance-settings/instance-settings.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instance_settings_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__instance_settings_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__instance_settings_service__ = __webpack_require__("./app/instance-settings/instance-settings.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_users_service__ = __webpack_require__("./app/users/users.service.ts");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var INSTANCE_SETTINGS_COMPONENT = "instanceSettings";

var InstanceSettingsComponentController = function () {
    function InstanceSettingsComponentController(usersService, instanceSettings) {
        _classCallCheck(this, InstanceSettingsComponentController);

        this.usersService = usersService;
        this.instanceSettings = instanceSettings;
    }

    _createClass(InstanceSettingsComponentController, [{
        key: "createFirstUser",
        value: function createFirstUser(password, confirm) {
            var _this = this;

            if (password !== confirm) {
                this.errorMessage = "Passwords doesn't match";
                return;
            }
            if (password.length < 6) {
                this.errorMessage = "Password must be at least 6 characters long";
                return;
            }
            this.wait = true;
            this.usersService.createFirstUser(password).then(function () {
                _this.settings.initialized = true;
            }, function (reason) {
                _this.errorMessage = "Administrator already exists or server not running";
            }).finally(function () {
                _this.wait = false;
            });
        }
    }]);

    return InstanceSettingsComponentController;
}();

InstanceSettingsComponentController.$inject = [__WEBPACK_IMPORTED_MODULE_2__users_users_service__["a" /* USERS_SERVICE */], __WEBPACK_IMPORTED_MODULE_1__instance_settings_service__["a" /* INSTANCE_SETTINGS_SERVICE */]];
var instanceSettingsComponentOptions = {
    controller: InstanceSettingsComponentController,
    template: __webpack_require__("./app/instance-settings/instance-settings.html"),
    bindings: {
        settings: "<"
    }
};

/***/ }),

/***/ "./app/instance-settings/instance-settings.html":
/***/ (function(module, exports) {

module.exports = "<div layout=column layout-align=\"center center\"> <h1 style=color:#fff>Board Cloud Administration</h1> </div> ";

/***/ }),

/***/ "./app/instance-settings/instance-settings.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/instance-settings/instance-settings.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/instance-settings/instance-settings.less", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/instance-settings/instance-settings.less");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/instance-settings/instance-settings.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__instance_settings_router__ = __webpack_require__("./app/instance-settings/instance-settings.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instance_settings_service__ = __webpack_require__("./app/instance-settings/instance-settings.service.ts");



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.instanceSettings", []).service(__WEBPACK_IMPORTED_MODULE_2__instance_settings_service__["a" /* INSTANCE_SETTINGS_SERVICE */], __WEBPACK_IMPORTED_MODULE_2__instance_settings_service__["b" /* InstanceSettingsService */]).config(__WEBPACK_IMPORTED_MODULE_1__instance_settings_router__["a" /* configRoute */]).name);

/***/ }),

/***/ "./app/instance-settings/instance-settings.router.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INSTANCE_SETTINGS_STATE */
/* harmony export (immutable) */ __webpack_exports__["a"] = configRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instance_settings_service__ = __webpack_require__("./app/instance-settings/instance-settings.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_header_service__ = __webpack_require__("./app/core/header.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shell_route__ = __webpack_require__("./app/app-shell.route.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_lazy_route_helper__ = __webpack_require__("./app/core/lazy-route.helper.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__instance_settings_component__ = __webpack_require__("./app/instance-settings/instance-settings.component.ts");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





var INSTANCE_SETTINGS_STATE = "instanceSettings";
function configRoute($stateProvider, $urlRouterProvider) {
    var _this = this;

    $stateProvider.state(INSTANCE_SETTINGS_STATE, {
        parent: __WEBPACK_IMPORTED_MODULE_2__app_shell_route__["a" /* APP_SHELL_STATE */],
        url: "/instance-settings",
        views: {
            content: {
                component: "instanceSettings",
                bindings: {
                    settings: "settings"
                }
            }
        },
        lazyLoad: function lazyLoad(transition, state) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var moduleExports;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./app/instance-settings/instance-settings.component.ts"));

                            case 2:
                                moduleExports = _context.sent;

                                Object(__WEBPACK_IMPORTED_MODULE_3__core_lazy_route_helper__["a" /* registerComponentFromTransition */])(transition, __WEBPACK_IMPORTED_MODULE_4__instance_settings_component__["INSTANCE_SETTINGS_COMPONENT"], moduleExports.instanceSettingsComponentOptions);
                                return _context.abrupt('return', moduleExports);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        },
        resolve: {
            settings: [__WEBPACK_IMPORTED_MODULE_0__instance_settings_service__["a" /* INSTANCE_SETTINGS_SERVICE */], function (settingsService) {
                return settingsService.getSettings();
            }]
        },
        onEnter: [__WEBPACK_IMPORTED_MODULE_1__core_header_service__["a" /* HEADER_SERVICE */], function (headerService) {
            headerService.headerTitle = "About";
        }]
    });
}
configRoute.$inject = ["$stateProvider", "$urlRouterProvider"];

/***/ }),

/***/ "./app/instance-settings/instance-settings.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INSTANCE_SETTINGS_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InstanceSettingsService; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var INSTANCE_SETTINGS_SERVICE = "instanceSettingsService";
var InstanceSettingsService = function () {
    function InstanceSettingsService($http) {
        _classCallCheck(this, InstanceSettingsService);

        this.$http = $http;
    }

    _createClass(InstanceSettingsService, [{
        key: "getSettings",
        value: function getSettings() {
            return this.$http.get("api/InstanceSettings/GetSettings").then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "dataDirectPassword",
        value: function dataDirectPassword(username, currentPassword, newPassword) {
            return this.$http.post("https://service.datadirectcloud.com/api/mgmt/users/" + username, {
                password: newPassword,
                currentPassowrd: currentPassword
            });
        }
    }]);

    return InstanceSettingsService;
}();
InstanceSettingsService.$inject = ["$http"];

/***/ }),

/***/ "./app/layout/header/header.component.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return headerComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_less__ = __webpack_require__("./app/layout/header/header.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__header_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_router__ = __webpack_require__("./app/dashboard/dashboard.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sidenav_sidenav_component__ = __webpack_require__("./app/layout/sidenav/sidenav.component.ts");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var HeaderComponentController = function () {
    function HeaderComponentController($mdSidenav, headerService, userManager, $state, USERNAME_CLAIM_TYPE) {
        var _this = this;

        _classCallCheck(this, HeaderComponentController);

        this.$mdSidenav = $mdSidenav;
        this.headerService = headerService;
        this.userManager = userManager;
        this.$state = $state;
        this.USERNAME_CLAIM_TYPE = USERNAME_CLAIM_TYPE;
        userManager.getUser().then(function (user) {
            _this.user = user;
        });
        this.logoImageSrc = __webpack_require__("./Content/boardLogo.svg");
    }
    // labels


    _createClass(HeaderComponentController, [{
        key: "toggleSidenav",
        value: function toggleSidenav() {
            this.$mdSidenav(__WEBPACK_IMPORTED_MODULE_3__sidenav_sidenav_component__["a" /* SIDENAV_ID */]).toggle();
        }
    }, {
        key: "logout",
        value: function logout() {
            this.userManager.signoutRedirect();
        }
    }, {
        key: "goDashboard",
        value: function goDashboard() {
            this.$state.go(__WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_router__["a" /* DASHBOARD_STATE */]);
        }
    }, {
        key: "username",
        get: function get() {
            if (!this.user) {
                return '';
            }
            return this.user.profile[this.USERNAME_CLAIM_TYPE];
        }
        // disabled

    }, {
        key: "showLogout",
        get: function get() {
            return !Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["isUndefined"])(this.user) && this.user !== null;
        }
    }, {
        key: "title",
        get: function get() {
            return this.headerService ? this.headerService.headerTitle : null;
        }
    }]);

    return HeaderComponentController;
}();

HeaderComponentController.$inject = ["$mdSidenav", "headerService", "BoardWebAdminUserManager", "$state", "USERNAME_CLAIM_TYPE"];
var headerComponent = {
    controller: HeaderComponentController,
    template: __webpack_require__("./app/layout/header/header.html"),
    bindings: {
        existingConfigurations: "<"
    }
};


/***/ }),

/***/ "./app/layout/header/header.html":
/***/ (function(module, exports) {

module.exports = "<md-toolbar class=brd-toolbar> <div class=\"md-toolbar-tools brd-toolbar-tools\"> <div class=brd-toolbar-logo-container layout=column layout-align=\"space-around center\"> <md-button ng-click=$ctrl.toggleSidenav() class=\"brd-small-menu-button md-icon-button brd-open-menu-button\" aria-label=\"Open Menu\"> <md-tooltip hide-gt-md md-direction=bottom>Open or close side menu</md-tooltip> <md-icon class=brd-board-icon md-svg-icon=board:board11 alt=Home hide show-gt-sm></md-icon> </md-button> </div> <div class=brd-header-left> ADMINISTRATION PORTAL </div> <span flex></span> <h2> <span class=brd-toolbar-title>{{ $ctrl.title }}</span> </h2> <span flex></span> <md-button ng-if=$ctrl.showLogout class=\"brd-open-menu-button signout\" aria-label=\"Signout Button\" ng-click=$ctrl.logout()> {{ $ctrl.username }} <md-tooltip md-direction=bottom>Signout</md-tooltip> <md-icon md-svg-src=admin:exit></md-icon> </md-button> </div> </md-toolbar>";

/***/ }),

/***/ "./app/layout/header/header.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/layout/header/header.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/layout/header/header.less", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/layout/header/header.less");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/layout/header/header.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_component__ = __webpack_require__("./app/layout/header/header.component.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instance_settings_instance_settings_module__ = __webpack_require__("./app/instance-settings/instance-settings.module.ts");



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.header", [__WEBPACK_IMPORTED_MODULE_2__instance_settings_instance_settings_module__["a" /* default */]]).component("brdHeader", __WEBPACK_IMPORTED_MODULE_1__header_component__["a" /* headerComponent */]).name);

/***/ }),

/***/ "./app/layout/layout.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_header_module__ = __webpack_require__("./app/layout/header/header.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sidenav_sidenav_module__ = __webpack_require__("./app/layout/sidenav/sidenav.module.ts");



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.layout", [__WEBPACK_IMPORTED_MODULE_1__header_header_module__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__sidenav_sidenav_module__["a" /* default */]]).name);

/***/ }),

/***/ "./app/layout/sidenav/sidenav.component.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIDENAV_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sidenavComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sidenav_less__ = __webpack_require__("./app/layout/sidenav/sidenav.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sidenav_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sidenav_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logs_logs_router__ = __webpack_require__("./app/logs/logs.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_router__ = __webpack_require__("./app/dashboard/dashboard.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_storage_shared_storage_router__ = __webpack_require__("./app/shared-storage/shared-storage.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_direct_data_direct_router__ = __webpack_require__("./app/data-direct/data-direct.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scheduler_scheduler_router__ = __webpack_require__("./app/scheduler/scheduler.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__backup_and_restore_backup_and_restore_router__ = __webpack_require__("./app/backup-and-restore/backup-and-restore.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__beng_logs_beng_logs_router__ = __webpack_require__("./app/beng-logs/beng-logs.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_users_router__ = __webpack_require__("./app/users/users.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__capsule_capsule_router__ = __webpack_require__("./app/capsule/capsule.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__instance_settings_instance_settings_service__ = __webpack_require__("./app/instance-settings/instance-settings.service.ts");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }












var SIDENAV_ID = "mainSidenav";

var SidenavComponentController = function () {
    function SidenavComponentController($mdSidenav, $state, instanceSettingService, idpEndpoint) {
        _classCallCheck(this, SidenavComponentController);

        this.$mdSidenav = $mdSidenav;
        this.$state = $state;
        this.instanceSettingService = instanceSettingService;
        this.idpEndpoint = idpEndpoint;
        this.links = [];
    }

    _createClass(SidenavComponentController, [{
        key: 'navigate',
        value: function navigate(state) {
            var _this = this;

            this.$state.go(state).then(function () {
                _this.$mdSidenav(SIDENAV_ID, true);
            });
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.instanceSettingService.getSettings().then(function (settings) {
                if (settings) {
                    _this2.links = [{ title: "Services status", description: "Show CPU and RAM usage", icon: "admin:status", state: __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_router__["a" /* DASHBOARD_STATE */] }, { title: "Scheduler", description: "Tasks scheduler", icon: "admin:reload", state: __WEBPACK_IMPORTED_MODULE_5__scheduler_scheduler_router__["a" /* SCHEDULER_STATE */] }, { title: "Database Backup restore", description: "Backup and restore", icon: "admin:backup", state: __WEBPACK_IMPORTED_MODULE_6__backup_and_restore_backup_and_restore_router__["a" /* BACKUP_AND_RESTORE_STATE */] }, { title: "Capsules organizer", description: "Upload, download and move", icon: "admin:capsule", state: __WEBPACK_IMPORTED_MODULE_9__capsule_capsule_router__["a" /* CAPSULE_STATE */] }, { title: "OS Events", description: "Operating System events log", icon: "admin:events", state: __WEBPACK_IMPORTED_MODULE_1__logs_logs_router__["a" /* OS_EVENTS_LOGS_STATE */] }, { title: "Shared Storage", description: "Files Exchange Service", icon: "admin:storage", state: __WEBPACK_IMPORTED_MODULE_3__shared_storage_shared_storage_router__["a" /* SHARED_STORAGE_STATE */] }, { title: "Logs", description: "Board Logs ", icon: "admin:logs", state: __WEBPACK_IMPORTED_MODULE_7__beng_logs_beng_logs_router__["a" /* BENGLOGS_STATE */] }];
                }
                if (settings.dataDirectEnabled) {
                    _this2.links = [{ title: "Services status", description: "Show CPU and RAM usage", icon: "admin:status", state: __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_router__["a" /* DASHBOARD_STATE */] }, { title: "Scheduler", description: "Schedule a Board procedure", icon: "admin:reload", state: __WEBPACK_IMPORTED_MODULE_5__scheduler_scheduler_router__["a" /* SCHEDULER_STATE */] }, { title: "Database Backup restore", description: "Backup and restore", icon: "admin:backup", state: __WEBPACK_IMPORTED_MODULE_6__backup_and_restore_backup_and_restore_router__["a" /* BACKUP_AND_RESTORE_STATE */] }, { title: "Capsules organizer", description: "Upload, download and move", icon: "admin:capsule", state: __WEBPACK_IMPORTED_MODULE_9__capsule_capsule_router__["a" /* CAPSULE_STATE */] }, { title: "Data Pipeline", description: "Cloud Connectors", icon: "admin:datasources", state: __WEBPACK_IMPORTED_MODULE_4__data_direct_data_direct_router__["a" /* DATA_DIRECT_STATE */] }, { title: "Shared Storage", description: "Files Exchange Service", icon: "admin:storage", state: __WEBPACK_IMPORTED_MODULE_3__shared_storage_shared_storage_router__["a" /* SHARED_STORAGE_STATE */] }, { title: "Logs", description: "Board Logs ", icon: "admin:logs", state: __WEBPACK_IMPORTED_MODULE_7__beng_logs_beng_logs_router__["a" /* BENGLOGS_STATE */] }, { title: "OS Events", description: "Operating System events log", icon: "admin:events", state: __WEBPACK_IMPORTED_MODULE_1__logs_logs_router__["a" /* OS_EVENTS_LOGS_STATE */] }];
                }
                //this.links.push({ title: "Data Pipeline", description: "Cloud Connectors", icon: "admin:datasources", state: DATA_DIRECT_STATE });
                if (!_this2.idpEndpoint) {
                    _this2.links.push({ title: "Users", description: "Manage portal users", icon: "admin:users", state: __WEBPACK_IMPORTED_MODULE_8__users_users_router__["a" /* USERS_STATE */] });
                }
            });
        }
    }]);

    return SidenavComponentController;
}();

SidenavComponentController.$inject = ["$mdSidenav", "$state", __WEBPACK_IMPORTED_MODULE_10__instance_settings_instance_settings_service__["a" /* INSTANCE_SETTINGS_SERVICE */], "IDP_ENDPOINT"];
var sidenavComponent = {
    controller: SidenavComponentController,
    template: __webpack_require__("./app/layout/sidenav/sidenav.html")
};

/***/ }),

/***/ "./app/layout/sidenav/sidenav.html":
/***/ (function(module, exports) {

module.exports = "<md-sidenav md-component-id=mainSidenav class=\"md-sidenav-left cloudAdmin-sidenav\" md-is-locked-open=\"$mdMedia('gt-md')\" layout-fill> <md-list> <md-list-item ng-repeat=\"link in $ctrl.links\" class=md-2-line ng-disabled=link.disabled ng-click=$ctrl.navigate(link.state)> <md-tooltip ng-if=link.disabled>Not implemented yet</md-tooltip> <md-icon md-svg-src={{link.icon}} alt=Start></md-icon> <div class=md-list-item-text> <h3>{{link.title}}</h3> <p>{{link.description}}</p> </div> </md-list-item> </md-list> </md-sidenav>";

/***/ }),

/***/ "./app/layout/sidenav/sidenav.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/layout/sidenav/sidenav.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/layout/sidenav/sidenav.less", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/layout/sidenav/sidenav.less");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/layout/sidenav/sidenav.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sidenav_component__ = __webpack_require__("./app/layout/sidenav/sidenav.component.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_angular__["module"]("board.web.admin.sidenav", []).component("brdSidenav", __WEBPACK_IMPORTED_MODULE_0__sidenav_component__["b" /* sidenavComponent */]).name);

/***/ }),

/***/ "./app/logs/logs.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logs_service__ = __webpack_require__("./app/logs/logs.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logs_router__ = __webpack_require__("./app/logs/logs.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_kendo_ui_js_kendo_angular__ = __webpack_require__("./node_modules/@progress/kendo-ui/js/kendo.angular.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_kendo_ui_js_kendo_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__progress_kendo_ui_js_kendo_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_ui_js_kendo_core__ = __webpack_require__("./node_modules/@progress/kendo-ui/js/kendo.core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_ui_js_kendo_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_ui_js_kendo_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__progress_kendo_ui_js_kendo_data__ = __webpack_require__("./node_modules/@progress/kendo-ui/js/kendo.data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__progress_kendo_ui_js_kendo_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__progress_kendo_ui_js_kendo_data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__progress_kendo_ui_js_kendo_grid__ = __webpack_require__("./node_modules/@progress/kendo-ui/js/kendo.grid.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__progress_kendo_ui_js_kendo_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__progress_kendo_ui_js_kendo_grid__);







/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.logs", ["kendo.directives"]).config(__WEBPACK_IMPORTED_MODULE_2__logs_router__["b" /* configRoute */]).service(__WEBPACK_IMPORTED_MODULE_1__logs_service__["a" /* LOGS_SERVICE */], __WEBPACK_IMPORTED_MODULE_1__logs_service__["b" /* LogsService */]).name);

/***/ }),

/***/ "./app/logs/logs.router.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OS_EVENTS_LOGS_STATE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = configRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_header_service__ = __webpack_require__("./app/core/header.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_lazy_route_helper__ = __webpack_require__("./app/core/lazy-route.helper.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shell_route__ = __webpack_require__("./app/app-shell.route.ts");
// import "@progress/kendo-ui/css/web/kendo.common.less";
// import "@progress/kendo-ui/css/web/kendo.materialblack.less";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



var OS_EVENTS_LOGS_STATE = "osevenlogststate";
function configRoute($stateProvider) {
    var _this = this;

    $stateProvider.state(OS_EVENTS_LOGS_STATE, {
        parent: __WEBPACK_IMPORTED_MODULE_2__app_shell_route__["a" /* APP_SHELL_STATE */],
        url: "/logs",
        views: {
            content: {
                component: "logsComponent"
            }
        },
        lazyLoad: function lazyLoad(transition, state) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var moduleExport;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "./app/logs/logs.component.ts"));

                            case 2:
                                moduleExport = _context.sent;

                                Object(__WEBPACK_IMPORTED_MODULE_1__core_lazy_route_helper__["a" /* registerComponentFromTransition */])(transition, "logsComponent", moduleExport.logsComponentOptions);
                                return _context.abrupt("return", moduleExport);

                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        },
        onEnter: [__WEBPACK_IMPORTED_MODULE_0__core_header_service__["a" /* HEADER_SERVICE */], function (headerService) {
            headerService.headerTitle = "Operating system events";
        }]
    });
}
configRoute.$inject = ["$stateProvider"];

/***/ }),

/***/ "./app/logs/logs.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGS_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LogsService; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LOGS_SERVICE = "logsService";
var LogsService = function () {
    function LogsService($http) {
        _classCallCheck(this, LogsService);

        this.$http = $http;
    }

    _createClass(LogsService, [{
        key: "logs",
        value: function logs(sortOptions) {
            return this.$http.get("api/logs/getlogs", {
                params: {
                    page: sortOptions.page,
                    take: sortOptions.take,
                    pageSize: sortOptions.pageSize,
                    skip: sortOptions.skip
                }
            }).then(function (response) {
                return response.data;
            });
        }
    }]);

    return LogsService;
}();
LogsService.$inject = ["$http"];

/***/ }),

/***/ "./app/manage/manage.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__manage_service__ = __webpack_require__("./app/manage/manage.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__manage_router__ = __webpack_require__("./app/manage/manage.router.ts");



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_angular__["module"]("board.web.admin.manage", []).service(__WEBPACK_IMPORTED_MODULE_0__manage_service__["a" /* MANAGE_SERVICE */], __WEBPACK_IMPORTED_MODULE_0__manage_service__["b" /* ManageService */]).config(__WEBPACK_IMPORTED_MODULE_2__manage_router__["a" /* configRoute */]).name);

/***/ }),

/***/ "./app/manage/manage.router.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_header_service__ = __webpack_require__("./app/core/header.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__monitor_monitor_service__ = __webpack_require__("./app/monitor/monitor.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__manage_service__ = __webpack_require__("./app/manage/manage.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_lazy_route_helper__ = __webpack_require__("./app/core/lazy-route.helper.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shell_route__ = __webpack_require__("./app/app-shell.route.ts");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





function getStatus(manageService) {
    return manageService.servicesToWatch();
}
getStatus.$inject = [__WEBPACK_IMPORTED_MODULE_2__manage_service__["a" /* MANAGE_SERVICE */]];
function configRoute($stateProvider) {
    var _this = this;

    $stateProvider.state("manage", {
        parent: __WEBPACK_IMPORTED_MODULE_4__app_shell_route__["a" /* APP_SHELL_STATE */],
        url: "/manage",
        onExit: [__WEBPACK_IMPORTED_MODULE_1__monitor_monitor_service__["a" /* MONITOR_SERVICE */], function (monitorService) {
            return monitorService.start.then(function () {
                monitorService.hub.server.stopStatusTimer();
            });
        }],
        views: {
            content: {
                component: "manageComponent"
            }
        },
        lazyLoad: function lazyLoad(transition, state) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var moduleExport;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "./app/manage/manage.component.ts"));

                            case 2:
                                moduleExport = _context.sent;

                                Object(__WEBPACK_IMPORTED_MODULE_3__core_lazy_route_helper__["a" /* registerComponentFromTransition */])(transition, "manageComponent", moduleExport.manageComponentOptions);
                                return _context.abrupt('return', moduleExport);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        },
        resolve: {
            "services": getStatus,
            setTitle: [__WEBPACK_IMPORTED_MODULE_0__core_header_service__["a" /* HEADER_SERVICE */], function (headerService) {
                headerService.headerTitle = "Manage Services";
            }],
            startTimer: ["monitorService", function (monitorService) {
                return monitorService.start.then(function () {
                    monitorService.hub.server.startStatusTimer();
                });
            }]
        }
    });
}
configRoute.$inject = ["$stateProvider"];

/***/ }),

/***/ "./app/manage/manage.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MANAGE_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ManageService; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MANAGE_SERVICE = "manageService";
var ManageService = function () {
    function ManageService($http, $q) {
        _classCallCheck(this, ManageService);

        this.$http = $http;
        this.$q = $q;
    }

    _createClass(ManageService, [{
        key: "servicesToWatch",
        value: function servicesToWatch() {
            return this.$http.get("api/manage/ServicesToWatch").then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "status",
        value: function status() {
            var _this = this;

            var service = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "BoardEngine";

            return this.$http.get("api/manage/status?service=" + service).then(function (response) {
                return response.data;
            }, function (reason) {
                return _this.extractError(reason);
            });
        }
    }, {
        key: "statusWeb",
        value: function statusWeb(webSite) {
            var _this2 = this;

            return this.$http.get("api/manage/statusWeb?webSite=" + webSite).then(function (response) {
                return response.data;
            }, function (reason) {
                return _this2.extractError(reason);
            });
        }
    }, {
        key: "start",
        value: function start(service) {
            var _this3 = this;

            return this.$http.get("api/manage/start?service=" + service).then(function (response) {
                return response.data;
            }, function (reason) {
                return _this3.extractError(reason);
            });
        }
    }, {
        key: "stop",
        value: function stop(service) {
            var _this4 = this;

            return this.$http.get("api/manage/stop?service=" + service).then(function (response) {
                return response.data;
            }, function (reason) {
                return _this4.extractError(reason);
            });
        }
    }, {
        key: "restart",
        value: function restart(service) {
            var _this5 = this;

            return this.$http.get("api/manage/restart?service=" + service).then(function (response) {
                return response.data;
            }, function (reason) {
                return _this5.extractError(reason);
            });
        }
    }, {
        key: "kill",
        value: function kill(service) {
            var _this6 = this;

            return this.$http.get("api/manage/kill?service=" + service).then(function (response) {
                return response.data;
            }, function (reason) {
                return _this6.extractError(reason);
            });
        }
    }, {
        key: "executeOperation",
        value: function executeOperation(applicationPoolName, operation) {
            var _this7 = this;

            return this.$http.get("api/manage/executeOperation?applicationPoolName=" + applicationPoolName + "&operation=" + operation).then(function (response) {
                return response.data;
            }, function (reason) {
                return _this7.extractError(reason);
            });
        }
    }, {
        key: "extractError",
        value: function extractError(reason) {
            return this.$q.reject(reason.data.message);
        }
    }]);

    return ManageService;
}();
ManageService.$inject = ["$http", "$q"];

/***/ }),

/***/ "./app/monitor/monitor.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__monitor_service__ = __webpack_require__("./app/monitor/monitor.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_angular__["module"]("board.web.admin.monitor", []).service(__WEBPACK_IMPORTED_MODULE_0__monitor_service__["a" /* MONITOR_SERVICE */], __WEBPACK_IMPORTED_MODULE_0__monitor_service__["b" /* MonitorService */]).name);

/***/ }),

/***/ "./app/monitor/monitor.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MONITOR_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MonitorService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("./node_modules/jquery/dist/jquery.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var MONITOR_SERVICE = "monitorService";
var MonitorService = function () {
    function MonitorService($document, $window, tokenService, userManager) {
        _classCallCheck(this, MonitorService);

        this.$window = $window;
        this.tokenService = tokenService;
        this.userManager = userManager;
        this.userManager.events.addUserLoaded(function (user) {
            if (!user) return;
            __WEBPACK_IMPORTED_MODULE_1_jquery__["connection"].hub.accessToken = user.access_token;
        });
        this.startMonitoring();
    }

    _createClass(MonitorService, [{
        key: "startMonitoring",
        value: function startMonitoring() {
            var _this = this;

            // creates a new hub connection
            var processMonitor = __WEBPACK_IMPORTED_MODULE_1_jquery__["connection"].processMonitorHub;
            this.hub = processMonitor;
            // add a client-side hub method that the server will call
            processMonitor.client.updateServiceStates = function (states) {
                if (__WEBPACK_IMPORTED_MODULE_0_angular__["isDefined"](_this.updateServiceStatesCallback) && __WEBPACK_IMPORTED_MODULE_0_angular__["isFunction"](_this.updateServiceStatesCallback)) _this.updateServiceStatesCallback(states);
            };
            processMonitor.client.updateSamplesValue = function (samples) {
                if (__WEBPACK_IMPORTED_MODULE_0_angular__["isDefined"](_this.updateSamplesValueCallback) && __WEBPACK_IMPORTED_MODULE_0_angular__["isFunction"](_this.updateSamplesValueCallback)) _this.updateSamplesValueCallback(samples);
            };
            __WEBPACK_IMPORTED_MODULE_1_jquery__["connection"].hub.logging = "prod" === "dev";
            this.tokenService.onAdminTokenChange = function () {
                __WEBPACK_IMPORTED_MODULE_1_jquery__["connection"].hub.accessToken = _this.tokenService.boardWebAdminAccessToken;
            };
            __WEBPACK_IMPORTED_MODULE_1_jquery__["connection"].hub.accessToken = this.tokenService.boardWebAdminAccessToken;
            // start the connection
            this.start = __WEBPACK_IMPORTED_MODULE_1_jquery__["connection"].hub.start({
                waitForPageLoad: true,
                jsonp: false,
                withCredentials: false,
                transport: ["webSockets", "serverSentEvents", "foreverFrame", "longPolling"]
            });
        }
    }]);

    return MonitorService;
}();
MonitorService.$inject = ["$document", "$window", "tokenService", "BoardWebAdminUserManager"];

/***/ }),

/***/ "./app/register/register.component.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGISTER_COMPONENT", function() { return REGISTER_COMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerComponentOptions", function() { return registerComponentOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__register_controller__ = __webpack_require__("./app/register/register.controller.ts");

var REGISTER_COMPONENT = "registerComponent";
var registerComponentOptions = {
    controller: __WEBPACK_IMPORTED_MODULE_0__register_controller__["a" /* RegisterController */],
    template: __webpack_require__("./app/register/register.html"),
    bindings: {
        emailAndTicket: "<"
    }
};

/***/ }),

/***/ "./app/register/register.controller.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RegisterController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__register_service__ = __webpack_require__("./app/register/register.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__register_less__ = __webpack_require__("./app/register/register.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__register_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__register_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var RegisterController = function () {
    function RegisterController($mdToast, $state, $window, registerService) {
        _classCallCheck(this, RegisterController);

        this.$mdToast = $mdToast;
        this.$state = $state;
        this.$window = $window;
        this.registerService = registerService;
        this.activationSent = false;
    }
    //Labels


    _createClass(RegisterController, [{
        key: "register",
        value: function register() {
            var _this = this;

            if (this.password !== this.confirmPassword) {
                return this.$mdToast.show(this.$mdToast.simple().textContent("Password and confirm password doesn't match.").position("top right").hideDelay(false));
            }
            this.wait = true;
            this.username = this.emailAndTicket.email.substr(0, this.emailAndTicket.email.indexOf('@'));
            return this.registerService.register(this.emailAndTicket.email, this.emailAndTicket.email, this.password, this.emailAndTicket.ticket).then(function () {
                _this.activationSent = true;
            }, function (reason) {
                _this.wait = false;
                return _this.$mdToast.show(_this.$mdToast.simple().textContent(reason.data.message).position("top right").hideDelay(false));
            }).finally(function () {
                _this.wait = false;
            });
        }
    }, {
        key: "registrationLabel",
        get: function get() {
            return "Account registration";
        }
    }, {
        key: "passwordLabel",
        get: function get() {
            return "Password";
        }
    }, {
        key: "usernameLabel",
        get: function get() {
            return "Username";
        }
    }, {
        key: "confirmedPassword",
        get: function get() {
            return "Confirm password";
        }
    }, {
        key: "submitButtonLabel",
        get: function get() {
            return "Submit";
        }
    }, {
        key: "activationSentLabel",
        get: function get() {
            return "An activation email has been sent!";
        }
    }, {
        key: "activateLabel",
        get: function get() {
            return "Please check your inbox and click the link in the email.";
        }
    }, {
        key: "closeButtonLabel",
        get: function get() {
            return "Close";
        }
        //Form Messages

    }, {
        key: "isRequiredMsg",
        get: function get() {
            return "This is required!";
        }
    }]);

    return RegisterController;
}();
RegisterController.$inject = ["$mdToast", "$state", "$window", __WEBPACK_IMPORTED_MODULE_0__register_service__["a" /* REGISTER_SERVICE */]];

/***/ }),

/***/ "./app/register/register.html":
/***/ (function(module, exports) {

module.exports = " <div layout=column style=height:100%> <brd-header></brd-header> <section layout=column flex layout-align=\"center center\"> <md-content md-whiteframe=2 layout=column layout-align=\"center center\" layout-padding layout-margin class=brd-register-container> <div layout=column layout-align=\"center center\" ng-if=!$ctrl.activationSent> <h2 layout layout-align=\"center center\">{{$ctrl.registrationLabel}}</h2> <md-input-container layout-padding flex> <label>{{$ctrl.usernameLabel}}</label> <input type=email disabled=disabled name=email ng-model=$ctrl.emailAndTicket.email required/> </md-input-container> <md-input-container layout-padding> <label>{{$ctrl.passwordLabel}}</label> <input type=password name=password ng-model=$ctrl.password required autofocus/> <div ng-messages=$ctrl.form.password.$error ng-show=!$ctrl.form.password.$dirty> <div ng-message=required>{{$ctrl.isRequiredMsg}}</div> </div> </md-input-container> <md-input-container layout-padding> <label>{{$ctrl.confirmedPassword}}</label> <input type=password name=confirmPassword ng-model=$ctrl.confirmPassword required/> <div ng-messages=$ctrl.form.confirmPassword.$error ng-show=!$ctrl.form.confirmPassword.$dirty> <div ng-message=required>{{$ctrl.isRequiredMsg}}</div> </div> </md-input-container> <md-button ng-disabled=$ctrl.form.$invalid ng-click=$ctrl.register()>{{$ctrl.submitButtonLabel}}</md-button> <md-progress-linear md-mode=indeterminate class=md-warn ng-if=$ctrl.wait></md-progress-linear> </div> <div layout=column layout-align=\"center center\" ng-if=$ctrl.activationSent> <h3>{{$ctrl.activationSentLabel}}</h3> <h4>{{$ctrl.activateLabel}}</h4> <h4>This window can be closed!</h4> </div> </md-content> </section> </div> ";

/***/ }),

/***/ "./app/register/register.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/register/register.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/register/register.less", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/register/register.less");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/register/register.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__register_service__ = __webpack_require__("./app/register/register.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__register_router__ = __webpack_require__("./app/register/register.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__uirouter_angularjs__ = __webpack_require__("./node_modules/@uirouter/angularjs/release/ui-router-angularjs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__uirouter_angularjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__uirouter_angularjs__);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_angular__["module"]("board.web.admin.register", [__WEBPACK_IMPORTED_MODULE_3__uirouter_angularjs___default.a]).service(__WEBPACK_IMPORTED_MODULE_0__register_service__["a" /* REGISTER_SERVICE */], __WEBPACK_IMPORTED_MODULE_0__register_service__["b" /* RegisterService */]).config(__WEBPACK_IMPORTED_MODULE_2__register_router__["a" /* configRoute */]).name);

/***/ }),

/***/ "./app/register/register.router.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REGISTER_STATE */
/* harmony export (immutable) */ __webpack_exports__["a"] = configRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__register_component__ = __webpack_require__("./app/register/register.component.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_lazy_route_helper__ = __webpack_require__("./app/core/lazy-route.helper.ts");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


var REGISTER_STATE = "registration";
function configRoute($stateProvider, $urlRouterProvider) {
    var _this = this;

    $stateProvider.state(REGISTER_STATE, {
        url: "/register?email&ticket",
        resolve: {
            "emailAndTicket": ["$transition$", function (transition) {
                return transition.params();
            }]
        },
        component: __WEBPACK_IMPORTED_MODULE_0__register_component__["REGISTER_COMPONENT"],
        bindings: {
            emailAndTicket: "emailAndTicket"
        },
        lazyLoad: function lazyLoad(transition, state) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var moduleExports;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./app/register/register.component.ts"));

                            case 2:
                                moduleExports = _context.sent;

                                Object(__WEBPACK_IMPORTED_MODULE_1__core_lazy_route_helper__["a" /* registerComponentFromTransition */])(transition, __WEBPACK_IMPORTED_MODULE_0__register_component__["REGISTER_COMPONENT"], moduleExports.registerComponentOptions);
                                return _context.abrupt("return", moduleExports);

                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        }
    });
}
configRoute.$inject = ["$stateProvider", "$urlRouterProvider"];

/***/ }),

/***/ "./app/register/register.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REGISTER_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RegisterService; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var REGISTER_SERVICE = "registerService";
var RegisterService = function () {
    function RegisterService($http) {
        _classCallCheck(this, RegisterService);

        this.$http = $http;
    }

    _createClass(RegisterService, [{
        key: "register",
        value: function register(email, username, password, ticket) {
            return this.$http.post("api/register/register", {
                email: email,
                username: username,
                password: password,
                ticket: ticket
            }).then(function (response) {
                return response.data;
            });
        }
    }]);

    return RegisterService;
}();
RegisterService.$inject = ["$http"];

/***/ }),

/***/ "./app/require-reset-password/require-reset-password.component.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REQUIRE_RESET_PASSWORD_COMPONENT", function() { return REQUIRE_RESET_PASSWORD_COMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "requireResetComponentOptions", function() { return requireResetComponentOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__require_reset_password_controller__ = __webpack_require__("./app/require-reset-password/require-reset-password.controller.ts");

var REQUIRE_RESET_PASSWORD_COMPONENT = "requireResetComponent";
var requireResetComponentOptions = {
    controller: __WEBPACK_IMPORTED_MODULE_0__require_reset_password_controller__["a" /* RequireResetPasswordController */],
    template: __webpack_require__("./app/require-reset-password/require-reset-password.html")
};

/***/ }),

/***/ "./app/require-reset-password/require-reset-password.controller.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RequireResetPasswordController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__require_reset_password_service__ = __webpack_require__("./app/require-reset-password/require-reset-password.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__require_reset_password_less__ = __webpack_require__("./app/require-reset-password/require-reset-password.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__require_reset_password_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__require_reset_password_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var RequireResetPasswordController = function () {
    function RequireResetPasswordController(resetpassService, userManager) {
        _classCallCheck(this, RequireResetPasswordController);

        this.resetpassService = resetpassService;
        this.userManager = userManager;
        this.passwordResetSubmitted = false;
    }

    _createClass(RequireResetPasswordController, [{
        key: 'submit',
        value: function submit() {
            var _this = this;

            return this.resetpassService.resetPassword(this.email).then(function () {
                _this.passwordResetSubmitted = true;
                //this.userManager.signinRedirect();
            });
        }
    }]);

    return RequireResetPasswordController;
}();
RequireResetPasswordController.$inject = [__WEBPACK_IMPORTED_MODULE_0__require_reset_password_service__["a" /* REQUIRE_RESET_PASSWORD_SERVICE */], "BoardWebAdminUserManager"];

/***/ }),

/***/ "./app/require-reset-password/require-reset-password.html":
/***/ (function(module, exports) {

module.exports = "<div layout=column style=height:100%> <brd-header></brd-header> <section layout=column flex layout-align=\"center center\"> <md-content md-whiteframe=2 layout=column layout-align=\"center center\" layout-padding layout-margin class=brd-require-reset-passw-container> <div layout=column layout-align=\"center center\" ng-if=!$ctrl.passwordResetSubmitted> <brd-form on-submit=$ctrl.submit() form-invalid=$ctrl.form.$invalid ng-form=$ctrl.form> <brd-form-title>Enter your email!</brd-form-title> <brd-form-inputs> <md-input-container flex> <label>Email</label> <input type=email name=email ng-model=$ctrl.email required autofocus/> <div ng-messages=$ctrl.form.email.$error ng-show=\"$ctrl.form.email.$invalid && $ctrl.form.email.$touched\"> <div ng-message=email>Not a valid email</div> <div ng-message=required>This field is required</div> </div> </md-input-container> </brd-form-inputs> </brd-form> </div> <div layout=column layout-align=\"center center\" ng-if=$ctrl.passwordResetSubmitted> <h3>A reset password email has been sent!</h3> <h4>Please check your inbox and click the link in the email.</h4> <h4>This window can be closed!</h4> </div> </md-content></section> </div>";

/***/ }),

/***/ "./app/require-reset-password/require-reset-password.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/require-reset-password/require-reset-password.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/require-reset-password/require-reset-password.less", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/require-reset-password/require-reset-password.less");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/require-reset-password/require-reset-password.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__require_reset_password_service__ = __webpack_require__("./app/require-reset-password/require-reset-password.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__require_reset_password_router__ = __webpack_require__("./app/require-reset-password/require-reset-password.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_brd_form_brd_form_module__ = __webpack_require__("./app/common/brd-form/brd-form.module.ts");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.requireResetPassword", [__WEBPACK_IMPORTED_MODULE_3__common_brd_form_brd_form_module__["a" /* default */]]).service(__WEBPACK_IMPORTED_MODULE_1__require_reset_password_service__["a" /* REQUIRE_RESET_PASSWORD_SERVICE */], __WEBPACK_IMPORTED_MODULE_1__require_reset_password_service__["b" /* RequireResetPasswordService */]).config(__WEBPACK_IMPORTED_MODULE_2__require_reset_password_router__["a" /* configRoute */]).name);

/***/ }),

/***/ "./app/require-reset-password/require-reset-password.router.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_lazy_route_helper__ = __webpack_require__("./app/core/lazy-route.helper.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__require_reset_password_component__ = __webpack_require__("./app/require-reset-password/require-reset-password.component.ts");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


function configRoute($stateProvider, $urlRouterProvider) {
    var _this = this;

    $stateProvider.state("requireResetPassword", {
        url: "/require-reset-password",
        component: __WEBPACK_IMPORTED_MODULE_1__require_reset_password_component__["REQUIRE_RESET_PASSWORD_COMPONENT"],
        lazyLoad: function lazyLoad(transition, state) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var moduleExports;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./app/require-reset-password/require-reset-password.component.ts"));

                            case 2:
                                moduleExports = _context.sent;

                                Object(__WEBPACK_IMPORTED_MODULE_0__core_lazy_route_helper__["a" /* registerComponentFromTransition */])(transition, __WEBPACK_IMPORTED_MODULE_1__require_reset_password_component__["REQUIRE_RESET_PASSWORD_COMPONENT"], moduleExports.requireResetComponentOptions);
                                return _context.abrupt("return", moduleExports);

                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        }
    });
}
configRoute.$inject = ["$stateProvider", "$urlRouterProvider"];

/***/ }),

/***/ "./app/require-reset-password/require-reset-password.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REQUIRE_RESET_PASSWORD_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RequireResetPasswordService; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var REQUIRE_RESET_PASSWORD_SERVICE = 'requireResetPasswordService';
var RequireResetPasswordService = function () {
    function RequireResetPasswordService($http, $q) {
        _classCallCheck(this, RequireResetPasswordService);

        this.$http = $http;
        this.$q = $q;
    }

    _createClass(RequireResetPasswordService, [{
        key: "resetPassword",
        value: function resetPassword(email) {
            var _this = this;

            return this.$http.get("api/requireresetpassword/requireresetpassword", { params: { email: email } }).then(null, function (reason) {
                return _this.$q.reject(reason.data.message);
            });
        }
    }]);

    return RequireResetPasswordService;
}();
RequireResetPasswordService.$inject = ["$http", "$q"];

/***/ }),

/***/ "./app/reset-password/reset-password.component.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_PASSWORD_COMPONENT", function() { return RESET_PASSWORD_COMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetPasswordComponentOptions", function() { return resetPasswordComponentOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reset_password_controller__ = __webpack_require__("./app/reset-password/reset-password.controller.ts");

var RESET_PASSWORD_COMPONENT = "resetPasswordComponent";
var resetPasswordComponentOptions = {
    controller: __WEBPACK_IMPORTED_MODULE_0__reset_password_controller__["a" /* ResetPasswordController */],
    template: __webpack_require__("./app/reset-password/reset-password.html"),
    bindings: {
        userAndTicket: "<"
    }
};

/***/ }),

/***/ "./app/reset-password/reset-password.controller.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResetPasswordController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reset_password_service__ = __webpack_require__("./app/reset-password/reset-password.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reset_password_less__ = __webpack_require__("./app/reset-password/reset-password.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reset_password_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__reset_password_less__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var ResetPasswordController = function () {
    function ResetPasswordController(resetPasswordService, userManager) {
        _classCallCheck(this, ResetPasswordController);

        this.resetPasswordService = resetPasswordService;
        this.userManager = userManager;
        this.passwordSuccessfullyReset = false;
    }

    _createClass(ResetPasswordController, [{
        key: 'submit',
        value: function submit() {
            var _this = this;

            return this.resetPasswordService.resetPassword(this.userAndTicket.id, this.password, this.confirm, this.userAndTicket.ticket).then(function () {
                _this.passwordSuccessfullyReset = true;
            });
        }
    }, {
        key: 'gotoLogin',
        value: function gotoLogin() {
            this.userManager.signinRedirect();
        }
    }, {
        key: 'username',
        get: function get() {
            return this.userAndTicket && this.userAndTicket.username ? this.userAndTicket.username : "";
        }
    }]);

    return ResetPasswordController;
}();
ResetPasswordController.$inject = [__WEBPACK_IMPORTED_MODULE_0__reset_password_service__["a" /* RESET_PASSWORD_SERVICE */], "BoardWebAdminUserManager"];

/***/ }),

/***/ "./app/reset-password/reset-password.html":
/***/ (function(module, exports) {

module.exports = "<div layout=column style=height:100%> <brd-header></brd-header> <section layout=column flex layout-align=\"center center\"> <md-content md-whiteframe=2 layout=column layout-align=\"center center\" layout-padding layout-margin class=brd-reset-passw-container> <div layout=column layout-align=\"center center\" ng-if=!$ctrl.passwordSuccessfullyReset> <brd-form on-submit=$ctrl.submit() form-invalid=$ctrl.form.$invalid ng-form=$ctrl.form> <brd-form-title>Hi {{ ::$ctrl.username }}, reset your password!</brd-form-title> <brd-form-inputs layout=column layout-align=\"center center\"> <md-input-container> <label>Password</label> <input type=password name=password ng-model=$ctrl.password required minlength=6 autofocus/> <div ng-messages=$ctrl.form.password.$error ng-show=\"$ctrl.form.password.$invalid && $ctrl.form.password.$touched\"> <div ng-message=required>This field is required</div> <div ng-message=minlength>Passwords must be at least 8 characters</div> </div> </md-input-container> <md-input-container> <label>Confirm Password</label> <input type=password name=confirmPassword ng-model=$ctrl.confirm minlength=6 required/> <div ng-messages=$ctrl.form.confirmPassword.$error ng-show=\"$ctrl.form.confirmPassword.$invalid && $ctrl.form.confirmPassword.$touched\"> <div ng-message=required>This field is required</div> <div ng-message=minlength>Passwords must be at least 8 characters</div> </div> </md-input-container> </brd-form-inputs> </brd-form> </div> <div layout=column layout-align=\"center center\" ng-if=$ctrl.passwordSuccessfullyReset> <h3>Your password has been successfully reset!</h3> <md-button ng-click=$ctrl.gotoLogin()>Go to login</md-button> </div> </md-content> </section> </div>";

/***/ }),

/***/ "./app/reset-password/reset-password.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/reset-password/reset-password.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/reset-password/reset-password.less", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/reset-password/reset-password.less");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/reset-password/reset-password.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reset_password_service__ = __webpack_require__("./app/reset-password/reset-password.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reset_password_router__ = __webpack_require__("./app/reset-password/reset-password.router.ts");



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.resetPassword", ["board.web.admin.brdForm"]).service(__WEBPACK_IMPORTED_MODULE_1__reset_password_service__["a" /* RESET_PASSWORD_SERVICE */], __WEBPACK_IMPORTED_MODULE_1__reset_password_service__["b" /* ResetPasswordService */]).config(__WEBPACK_IMPORTED_MODULE_2__reset_password_router__["a" /* configRoute */]).name);

/***/ }),

/***/ "./app/reset-password/reset-password.router.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_lazy_route_helper__ = __webpack_require__("./app/core/lazy-route.helper.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reset_password_component__ = __webpack_require__("./app/reset-password/reset-password.component.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reset_password_html__ = __webpack_require__("./app/reset-password/reset-password.html");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reset_password_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__reset_password_html__);
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



function configRoute($stateProvider, $urlRouterProvider) {
    var _this = this;

    $stateProvider.state("resetPassword", {
        url: "/reset-password?username&id&ticket",
        component: __WEBPACK_IMPORTED_MODULE_1__reset_password_component__["RESET_PASSWORD_COMPONENT"],
        resolve: {
            "userAndTicket": ["$transition$", function (transition) {
                return transition.params();
            }]
        },
        bindings: {
            userAndTicket: "userAndTicket"
        },
        lazyLoad: function lazyLoad(transition, state) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var moduleExports;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./app/reset-password/reset-password.component.ts"));

                            case 2:
                                moduleExports = _context.sent;

                                Object(__WEBPACK_IMPORTED_MODULE_0__core_lazy_route_helper__["a" /* registerComponentFromTransition */])(transition, __WEBPACK_IMPORTED_MODULE_1__reset_password_component__["RESET_PASSWORD_COMPONENT"], moduleExports.resetPasswordComponentOptions);
                                return _context.abrupt("return", moduleExports);

                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        }
    });
}
configRoute.$inject = ["$stateProvider", "$urlRouterProvider"];

/***/ }),

/***/ "./app/reset-password/reset-password.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESET_PASSWORD_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ResetPasswordService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var RESET_PASSWORD_SERVICE = "resetPasswordService";
var ResetPasswordService = function () {
    function ResetPasswordService($q, $http) {
        _classCallCheck(this, ResetPasswordService);

        this.$q = $q;
        this.$http = $http;
    }

    _createClass(ResetPasswordService, [{
        key: "resetPassword",
        value: function resetPassword(id, password, confirm, ticket) {
            var _this = this;

            if (confirm != password) {
                return this.$q.reject("Password and confirm password doesn't match.");
            }
            return this.$http.post("api/resetpassword/resetpassword", {
                userId: id,
                password: password,
                ticket: ticket
            }).then(__WEBPACK_IMPORTED_MODULE_0_angular__["noop"], function (reason) {
                return _this.$q.reject(reason.data.message);
            });
        }
    }]);

    return ResetPasswordService;
}();
ResetPasswordService.$inject = ["$q", "$http"];

/***/ }),

/***/ "./app/scheduler/scheduler.filter.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = taskTriggerDescriptionFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typings_board_TaskScheduler__ = __webpack_require__("./typings/board/TaskScheduler.ts");

function taskTriggerDescriptionFilter() {
    return function (input) {
        switch (input) {
            case __WEBPACK_IMPORTED_MODULE_0__typings_board_TaskScheduler__["d" /* TaskTriggerType */].Daily:
                return "Daily";
            case __WEBPACK_IMPORTED_MODULE_0__typings_board_TaskScheduler__["d" /* TaskTriggerType */].Monthly:
                return "Monthly";
            case __WEBPACK_IMPORTED_MODULE_0__typings_board_TaskScheduler__["d" /* TaskTriggerType */].Time:
                return "One Time";
            case __WEBPACK_IMPORTED_MODULE_0__typings_board_TaskScheduler__["d" /* TaskTriggerType */].Weekly:
                return "Weekly";
            case __WEBPACK_IMPORTED_MODULE_0__typings_board_TaskScheduler__["d" /* TaskTriggerType */].MonthlyDOW:
                return "Monthly (Days of the week)";
            default:
                return "N/D";
        }
    };
}

/***/ }),

/***/ "./app/scheduler/scheduler.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scheduler_router__ = __webpack_require__("./app/scheduler/scheduler.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler_service__ = __webpack_require__("./app/scheduler/scheduler.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scheduler_filter__ = __webpack_require__("./app/scheduler/scheduler.filter.ts");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_angular__["module"]("board.web.admin.scheduler", []).service(__WEBPACK_IMPORTED_MODULE_2__scheduler_service__["a" /* SCHEDULER_SERVICE */], __WEBPACK_IMPORTED_MODULE_2__scheduler_service__["b" /* SchedulerService */]).config(__WEBPACK_IMPORTED_MODULE_0__scheduler_router__["b" /* configRoute */]).filter("taskTriggerDescription", __WEBPACK_IMPORTED_MODULE_3__scheduler_filter__["a" /* taskTriggerDescriptionFilter */]).name);

/***/ }),

/***/ "./app/scheduler/scheduler.router.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCHEDULER_STATE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = configRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shell_route__ = __webpack_require__("./app/app-shell.route.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler_service__ = __webpack_require__("./app/scheduler/scheduler.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_header_service__ = __webpack_require__("./app/core/header.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_lazy_route_helper__ = __webpack_require__("./app/core/lazy-route.helper.ts");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




var SCHEDULER_STATE = "schedulerstate";
function configRoute($stateProvider, $urlRouterProvider) {
    var _this = this;

    $stateProvider.state(SCHEDULER_STATE, {
        parent: __WEBPACK_IMPORTED_MODULE_0__app_shell_route__["a" /* APP_SHELL_STATE */],
        views: {
            content: {
                component: "schedulerComponent",
                bindings: {
                    serverTimeInfo: "serverTimeInfo"
                }
            }
        },
        url: "/scheduler",
        lazyLoad: function lazyLoad(transition, state) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var moduleExports;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "./app/scheduler/scheduler.component.ts"));

                            case 2:
                                moduleExports = _context.sent;

                                Object(__WEBPACK_IMPORTED_MODULE_3__core_lazy_route_helper__["a" /* registerComponentFromTransition */])(transition, "schedulerComponent", moduleExports.schedulerComponentOptions);
                                return _context.abrupt('return', moduleExports);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        },
        onEnter: [__WEBPACK_IMPORTED_MODULE_2__core_header_service__["a" /* HEADER_SERVICE */], function (headerService) {
            headerService.headerTitle = "Task Scheduler";
        }],
        resolve: {
            serverTimeInfo: [__WEBPACK_IMPORTED_MODULE_1__scheduler_service__["a" /* SCHEDULER_SERVICE */], function (schedulerService) {
                return schedulerService.getActualServerTime();
            }]
        }
    });
}
configRoute.$inject = ["$stateProvider", "$urlRouterProvider"];

/***/ }),

/***/ "./app/scheduler/scheduler.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCHEDULER_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SchedulerService; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SCHEDULER_SERVICE = "schedulerService";
var SchedulerService = function () {
    function SchedulerService($http, $q) {
        _classCallCheck(this, SchedulerService);

        this.$http = $http;
        this.$q = $q;
    }

    _createClass(SchedulerService, [{
        key: "getActualServerTime",
        value: function getActualServerTime() {
            return this.$http.get("api/scheduler/getActualServerTime").then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "days",
        value: function days() {
            return this.$http.get("api/scheduler/days").then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "months",
        value: function months() {
            return this.$http.get("api/scheduler/months").then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "weeks",
        value: function weeks() {
            return this.$http.get("api/scheduler/weeks").then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "tasks",
        value: function tasks() {
            return this.$http.get("api/scheduler/gettasks").then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "task",
        value: function task(taskName) {
            return this.$http.get("api/scheduler/gettask", { params: { taskName: taskName } }).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "removeTask",
        value: function removeTask(taskName) {
            return this.$http.post("api/scheduler/removetask", "=" + taskName, { headers: { "Content-Type": "application/x-www-form-urlencoded" } });
        }
    }, {
        key: "toggleTriggerEnabled",
        value: function toggleTriggerEnabled(taskName, triggerEnabled) {
            return this.$http.get("api/scheduler/ToggleTriggerEnabled", { params: { taskName: taskName, triggerEnabled: triggerEnabled } }).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "stopTrigger",
        value: function stopTrigger(taskName) {
            return this.$http.get("api/scheduler/stoptrigger", { params: { taskName: taskName } }).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "oneTime",
        value: function oneTime(task, oldName) {
            var _this = this;

            return this.$http.post('api/scheduler/onetime', task, { params: { originalName: oldName } }).then(function (response) {
                return response.data;
            }, function (reason) {
                return _this.$q.reject(reason.data.message);
            });
        }
    }, {
        key: "daily",
        value: function daily(task, oldName) {
            var _this2 = this;

            return this.$http.post('api/scheduler/daily', task, { params: { originalName: oldName } }).then(function (response) {
                return response.data;
            }, function (reason) {
                return _this2.$q.reject(reason.data.message);
            });
        }
    }, {
        key: "weekly",
        value: function weekly(task, oldName) {
            var _this3 = this;

            return this.$http.post('api/scheduler/weekly', task, { params: { originalName: oldName } }).then(function (response) {
                return response.data;
            }, function (reason) {
                return _this3.$q.reject(reason.data.message);
            });
        }
    }, {
        key: "monthly",
        value: function monthly(task, oldName) {
            var _this4 = this;

            return this.$http.post('api/scheduler/monthly', task, { params: { originalName: oldName } }).then(function (response) {
                return response.data;
            }, function (reason) {
                return _this4.$q.reject(reason.data.message);
            });
        }
    }, {
        key: "monthlyDow",
        value: function monthlyDow(task, oldName) {
            var _this5 = this;

            return this.$http.post('api/scheduler/monthlyDow', task, { params: { originalName: oldName } }).then(function (response) {
                return response.data;
            }, function (reason) {
                return _this5.$q.reject(reason.data.message);
            });
        }
    }]);

    return SchedulerService;
}();
SchedulerService.$inject = ["$http", "$q"];

/***/ }),

/***/ "./app/shared-storage/shared-storage.component.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHARED_STORAGE_COMPONENT", function() { return SHARED_STORAGE_COMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sharedStorageComponentOptions", function() { return sharedStorageComponentOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_storage_less__ = __webpack_require__("./app/shared-storage/shared-storage.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_storage_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_storage_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__capsule_manager_guide_capsuleManagerGuide_component__ = __webpack_require__("./app/capsule-manager-guide/capsuleManagerGuide.component.ts");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var SHARED_STORAGE_COMPONENT = "sharedStorageComponent";

var SharedStorageComponentController = function () {
    function SharedStorageComponentController($mdToast) {
        _classCallCheck(this, SharedStorageComponentController);

        this.$mdToast = $mdToast;
        this.descriptions = [];
        // tslint:disable-next-line:max-line-length
        this.descriptions.push(new __WEBPACK_IMPORTED_MODULE_1__capsule_manager_guide_capsuleManagerGuide_component__["b" /* Description */]("Shared storage", "Exchange files across Test or Prod instances in a secure and fast way using AZCOPY command tool or the Storage Explorer GUI from Microsoft. AZCOPY will be displayed as a shared drive on your instances to exchange files."));
    }
    //labels


    _createClass(SharedStorageComponentController, [{
        key: "showCopyMsg",
        value: function showCopyMsg() {
            this.$mdToast.show(this.$mdToast.simple().textContent("Copied to clipboard!").position("top right"));
        }
    }, {
        key: "sasUriLabel",
        get: function get() {
            return "Shared Access Signature (SAS) URI:";
        }
    }, {
        key: "sasUri",
        get: function get() {
            return this.settings.sasKey;
        }
    }]);

    return SharedStorageComponentController;
}();

SharedStorageComponentController.$inject = ["$mdToast"];
var sharedStorageComponentOptions = {
    controller: SharedStorageComponentController,
    template: __webpack_require__("./app/shared-storage/shared-storage.html"),
    bindings: {
        settings: "<"
    }
};

/***/ }),

/***/ "./app/shared-storage/shared-storage.html":
/***/ (function(module, exports) {

module.exports = "<div layout=row layout-align=\"start center\"> <div flex></div> <capsule-manager-guide-component descriptions=$ctrl.descriptions></capsule-manager-guide-component> </div> <md-divider style=border-top-color:#6a6a6a;border-top-width:2px></md-divider> <md-content layout=column layout-align=\"space-around start\" layout-padding class=shared-storage> <h2 class=b-display-4>Shared storage usage information</h2> <div layout=column layout-align=\"center start\" layout-padding class=brd-saskey-input-container> <h3 class=brd-saskey-input-label>{{$ctrl.sasUriLabel}}</h3> <div layout=row layout-align=\"start center\"> <div id=clipsaskey class=brd-saskey-input>{{$ctrl.sasUri}}</div> <md-button ngclipboard data-clipboard-target=#clipsaskey ng-click=$ctrl.showCopyMsg() class=\"b-framed-on-dark copy-key\"> <md-tooltip md-direction=bottom>Copy sas key on the clipboard!</md-tooltip> <md-icon md-svg-src=admin:copy alt=Copy></md-icon>Copy </md-button> </div> <div> <p>Please note that the SAS URI contains security key, please keep it secure and don’t share with unauthorized person.</p> </div> </div> <div layout=column layout-align=\"center start\" layout-padding> <div> <p>The storage will be accessible from Board application like a standard legacy hard drive.</p> <p>We assign a drive letter Z: where Board data reader can load files.</p> <p>We also assign an environment variable called “BSS” (Board Shared Storage)</p> <p>that you can use referring it as %BSS% in the datareader, procedure etc.</p> </div> <div> <p>In order to access it from your local network, you can use AZCOPY (a command line tool) or the Storage Explorer a GUI App provided from Microsoft and a shared access signature (SAS).</p> <p>The SAS is a URI that encompasses in its query parameters all of the information necessary for authenticated access to a storage resource.</p> <p>To access storage resources with the SAS, you only needs to pass the SAS at the command line tool.</p> </div> <div class=brd-sas-examples> <h3>Here some examples of commands:</h3> <h4>Upload an entire directory by using a SAS token:</h4> <p>azcopy cp \"C:\\directory\" \"[SAS-Uri]\" --recursive=true</p> <br/> <h4>Upload single file by using SAS token:</h4> <p>azcopy cp \" C:\\directory\\file.txt\" \"[SAS-Uri]\"</p><br/> <h4>Upload a set of files by using a SAS token and wildcard (*) characters:</h4> <p>azcopy cp \" C:\\directory\\*.csv\" \"[SAS-Uri]\"</p> </div> <div> <p>For the configuration of the Storage Explorer App, after the setup a wizard will ask you to sign in to your Azure account.</p> <p>Please select: “Connect using your Storage Account Information”</p> <p>Next, you will be asked for the connection string: paste the SAS URI provided.</p> </div> </div> <div layout=column layout-align=\"center start\" layout-padding> <h3>Helpful links:</h3> <div layout=column layout-align=\"center start\" class=brd-sas-links> <div> <a href=https://aka.ms/downloadazcopy-v10-windows target=_blank>Here the link to download the command line tool AZCOPY</a> <span class=shared-storage>(Note: always use the latest version available) </span> </div> <a href=https://docs.microsoft.com/en-us/azure/storage/common/storage-use-azcopy-v10 target=_blank>This article describes in depth all options of the tool</a> <a href=https://azure.microsoft.com/en-us/features/storage-explorer/ target=_blank>Here the link to download the Storage Explorer GUI</a> </div> </div> </md-content> ";

/***/ }),

/***/ "./app/shared-storage/shared-storage.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/shared-storage/shared-storage.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/shared-storage/shared-storage.less", function() {
			var newContent = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/shared-storage/shared-storage.less");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/shared-storage/shared-storage.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_storage_router__ = __webpack_require__("./app/shared-storage/shared-storage.router.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_storage_service__ = __webpack_require__("./app/shared-storage/shared-storage.service.ts");



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular__["module"]("board.web.admin.sharedstorage", []).service(__WEBPACK_IMPORTED_MODULE_2__shared_storage_service__["a" /* SHARED_STORAGE_SERVICE */], __WEBPACK_IMPORTED_MODULE_2__shared_storage_service__["b" /* SharedStorageService */]).config(__WEBPACK_IMPORTED_MODULE_1__shared_storage_router__["b" /* configRoute */]).name);

/***/ }),

/***/ "./app/shared-storage/shared-storage.router.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SHARED_STORAGE_STATE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = configRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_storage_service__ = __webpack_require__("./app/shared-storage/shared-storage.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_header_service__ = __webpack_require__("./app/core/header.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shell_route__ = __webpack_require__("./app/app-shell.route.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_lazy_route_helper__ = __webpack_require__("./app/core/lazy-route.helper.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_storage_component__ = __webpack_require__("./app/shared-storage/shared-storage.component.ts");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





var SHARED_STORAGE_STATE = "sharedStorageState";
function configRoute($stateProvider, $urlRouterProvider) {
    var _this = this;

    $stateProvider.state(SHARED_STORAGE_STATE, {
        parent: __WEBPACK_IMPORTED_MODULE_2__app_shell_route__["a" /* APP_SHELL_STATE */],
        url: "/sharedstorage",
        views: {
            content: {
                component: __WEBPACK_IMPORTED_MODULE_4__shared_storage_component__["SHARED_STORAGE_COMPONENT"],
                bindings: {
                    settings: "settings"
                }
            }
        },
        lazyLoad: function lazyLoad(transition, state) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var moduleExports;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./app/shared-storage/shared-storage.component.ts"));

                            case 2:
                                moduleExports = _context.sent;

                                Object(__WEBPACK_IMPORTED_MODULE_3__core_lazy_route_helper__["a" /* registerComponentFromTransition */])(transition, __WEBPACK_IMPORTED_MODULE_4__shared_storage_component__["SHARED_STORAGE_COMPONENT"], moduleExports.sharedStorageComponentOptions);
                                return _context.abrupt('return', moduleExports);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        },
        resolve: {
            settings: [__WEBPACK_IMPORTED_MODULE_0__shared_storage_service__["a" /* SHARED_STORAGE_SERVICE */], function (sharedStorageService) {
                return sharedStorageService.getSettings();
            }]
        },
        onEnter: [__WEBPACK_IMPORTED_MODULE_1__core_header_service__["a" /* HEADER_SERVICE */], function (headerService) {
            headerService.headerTitle = "Shared Storage";
        }]
    });
}
configRoute.$inject = ["$stateProvider", "$urlRouterProvider"];

/***/ }),

/***/ "./app/shared-storage/shared-storage.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SHARED_STORAGE_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SharedStorageService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instance_settings_instance_settings_service__ = __webpack_require__("./app/instance-settings/instance-settings.service.ts");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var SHARED_STORAGE_SERVICE = "sharedStorageService";
var SharedStorageService = function () {
    function SharedStorageService($http, instanceSettingService) {
        _classCallCheck(this, SharedStorageService);

        this.$http = $http;
        this.instanceSettingService = instanceSettingService;
    }

    _createClass(SharedStorageService, [{
        key: "getSettings",
        value: function getSettings() {
            return this.instanceSettingService.getSettings().then(function (response) {
                return response;
            });
        }
    }, {
        key: "dataDirectPassword",
        value: function dataDirectPassword(username, currentPassword, newPassword) {
            return this.instanceSettingService.dataDirectPassword(username, currentPassword, newPassword).then(function (response) {
                return response;
            });
        }
    }]);

    return SharedStorageService;
}();
SharedStorageService.$inject = ["$http", __WEBPACK_IMPORTED_MODULE_0__instance_settings_instance_settings_service__["a" /* INSTANCE_SETTINGS_SERVICE */]];

/***/ }),

/***/ "./app/users/users.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__users_service__ = __webpack_require__("./app/users/users.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_router__ = __webpack_require__("./app/users/users.router.ts");



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_angular__["module"]("board.web.admin.users", []).service(__WEBPACK_IMPORTED_MODULE_0__users_service__["a" /* USERS_SERVICE */], __WEBPACK_IMPORTED_MODULE_0__users_service__["b" /* UsersService */]).config(__WEBPACK_IMPORTED_MODULE_2__users_router__["b" /* configRoute */]).name);

/***/ }),

/***/ "./app/users/users.router.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return USERS_STATE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = configRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shell_route__ = __webpack_require__("./app/app-shell.route.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_header_service__ = __webpack_require__("./app/core/header.service.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_lazy_route_helper__ = __webpack_require__("./app/core/lazy-route.helper.ts");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



var USERS_STATE = "usersState";
function configRoute($stateProvider, idpEndpoint) {
    var _this = this;

    if (!!idpEndpoint) {
        return;
    }
    $stateProvider.state(USERS_STATE, {
        parent: __WEBPACK_IMPORTED_MODULE_0__app_shell_route__["a" /* APP_SHELL_STATE */],
        url: "/users",
        views: {
            content: {
                component: "usersComponent"
            }
        },
        lazyLoad: function lazyLoad(transition, state) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var moduleExports;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./app/users/users.component.ts"));

                            case 2:
                                moduleExports = _context.sent;

                                Object(__WEBPACK_IMPORTED_MODULE_2__core_lazy_route_helper__["a" /* registerComponentFromTransition */])(transition, "usersComponent", moduleExports.usersComponentOptions);
                                return _context.abrupt('return', moduleExports);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        },
        onEnter: [__WEBPACK_IMPORTED_MODULE_1__core_header_service__["a" /* HEADER_SERVICE */], function (headerService) {
            headerService.headerTitle = "Accounts";
        }]
    });
}
configRoute.$inject = ["$stateProvider", "IDP_ENDPOINT"];

/***/ }),

/***/ "./app/users/users.service.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return USERS_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UsersService; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var USERS_SERVICE = "usersService";
var UsersService = function () {
    function UsersService($http, $q) {
        _classCallCheck(this, UsersService);

        this.$http = $http;
        this.$q = $q;
    }

    _createClass(UsersService, [{
        key: "users",
        value: function users() {
            return this.$http.get("api/users/getusers").then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "delete",
        value: function _delete(userId) {
            return this.$http({
                method: "POST",
                url: "api/users/delete",
                headers: {
                    "Content-Type": undefined
                },
                data: { userId: userId },
                transformRequest: function transformRequest(data) {
                    var formData = new FormData();
                    formData.append("userId", data.userId);
                    return formData;
                }
            });
        }
    }, {
        key: "enableEmail",
        value: function enableEmail(email) {
            return this.$http({
                method: "POST",
                url: "api/users/EnableUserRegistrationAsync",
                headers: {
                    "Content-Type": undefined
                },
                data: { email: email },
                transformRequest: function transformRequest(data) {
                    var formData = new FormData();
                    formData.append("email", data.email);
                    return formData;
                }
            }).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "createFirstUser",
        value: function createFirstUser(password) {
            return this.$http({
                method: "POST",
                url: "api/users/createfirstuser",
                headers: {
                    "Content-Type": undefined
                },
                data: { password: password },
                transformRequest: function transformRequest(data) {
                    var formData = new FormData();
                    formData.append("password", data.password);
                    return formData;
                }
            }).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: "resendActivationMail",
        value: function resendActivationMail(userId) {
            return this.$http({
                method: "POST",
                url: "api/users/ResendActivationMailAsync",
                headers: {
                    "Content-Type": undefined
                },
                data: { userId: userId },
                transformRequest: function transformRequest(data) {
                    var formData = new FormData();
                    formData.append("userId", data.userId);
                    return formData;
                }
            }).then(function (response) {
                return response.data;
            });
        }
    }]);

    return UsersService;
}();
UsersService.$inject = ["$http", "$q"];

/***/ }),

/***/ "./app/zbootstrap.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getEndpoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return buildUserManagers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bootstrapAuthorizedApplication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bootstrapAnonymousApplication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return anonymousBootstrap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("./node_modules/angular/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_oidc_client__ = __webpack_require__("./node_modules/oidc-client/lib/oidc-client.min.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_oidc_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_oidc_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("./node_modules/lodash/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authorized_app_module__ = __webpack_require__("./app/authorized-app.module.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__anonymous_app_module__ = __webpack_require__("./app/anonymous-app.module.ts");





/**
 * Get API Endpoints
 */
var getEndpoints = function getEndpoints() {
    var bootstrapInjector = __WEBPACK_IMPORTED_MODULE_0_angular__["injector"](["ng"], true);
    var $http = bootstrapInjector.get("$http");
    var $q = bootstrapInjector.get("$q");
    return $q.all([$http.get("api/ClientSettings/GetBoardWebAdminEndpoint"), $http.get("api/ClientSettings/GetBoardWebEndpoint"), $http.get("api/ClientSettings/GetIdpEndpoint")]).then(function (endPoints) {
        return {
            adminEndpoint: endPoints[0].data,
            webEndpoint: endPoints[1].data,
            idpEndpoint: endPoints[2].data
        };
    });
};
var buildUserManagers = function buildUserManagers(adminEndpoint, boardWebEndpoint, idpEndpoint) {
    var hostEndpoint =  false ? "https://localhost:9000" : adminEndpoint;
    var boardWebAdminUserManagerSettings = {
        authority: !idpEndpoint ? adminEndpoint + "/identity/" : idpEndpoint,
        client_id: "acspa",
        redirect_uri: hostEndpoint + "/redirect.html",
        // Add the slient renew redirect URL
        silent_redirect_uri: hostEndpoint + "/silent-renew.html",
        post_logout_redirect_uri: !idpEndpoint ? hostEndpoint : hostEndpoint + "/",
        response_type: "id_token token",
        scope: !idpEndpoint ? "openid" : "openid profile email admin-tool-api",
        loadUserInfo: true,
        // Add expiration nofitication time
        accessTokenExpiringNotificationTime: 4,
        // Setup to renew token access automatically
        automaticSilentRenew: true,
        filterProtocolClaims: !idpEndpoint
    };
    var boardWebUserManagerSettings = {
        authority: !idpEndpoint ? boardWebEndpoint + "/identity/" : idpEndpoint,
        client_id: "boardwebapplication",
        loadUserInfo: !!idpEndpoint,
        // Add expiration nofitication time
        accessTokenExpiringNotificationTime: 60,
        // Setup to renew token access automatically
        automaticSilentRenew: true,
        silent_redirect_uri: hostEndpoint + "/silent-renew.html",
        response_type: "id_token token",
        scope: !idpEndpoint ? "openid" : "openid profile board-api",
        popup_redirect_uri: hostEndpoint + "/signin-popup-redirect.html",
        popup_post_logout_redirect_uri: hostEndpoint + "/signout-popup-redirect.html"
    };
    return {
        adminUserManager: new __WEBPACK_IMPORTED_MODULE_1_oidc_client__["UserManager"](boardWebAdminUserManagerSettings),
        webUserManager: new __WEBPACK_IMPORTED_MODULE_1_oidc_client__["UserManager"](boardWebUserManagerSettings)
    };
};
// const getUsers = (adminUserManager: Oidc.UserManager, webUserManager: Oidc.UserManager) => {
//     return adminUserManager.getUser().then(webAdminUser => {
//         return webUserManager.getUser().then(webUser => {
//             return {
//                 adminUser: webAdminUser,
//                 webUser: webUser
//             };
//         });
//     });
// };
var bootstrapAuthorizedApplication = function bootstrapAuthorizedApplication(adminUserManager, adminUser, webUserManager, boardWebEndpoint, idpEndpoint) {
    webUserManager.getUser().then(function (user) {
        __WEBPACK_IMPORTED_MODULE_0_angular__["bootstrap"]("body", [Object(__WEBPACK_IMPORTED_MODULE_3__authorized_app_module__["a" /* buildAuthorizedAppModule */])(adminUserManager, adminUser, webUserManager, boardWebEndpoint, user, idpEndpoint)], { strictDi: true });
    });
};
var bootstrapAnonymousApplication = function bootstrapAnonymousApplication(adminUserManager) {
    __WEBPACK_IMPORTED_MODULE_0_angular__["bootstrap"]("body", [Object(__WEBPACK_IMPORTED_MODULE_4__anonymous_app_module__["a" /* buildAnonymousAppModule */])(adminUserManager)], { strictDi: true });
};
/**
 * Check if the requested path is part of valid anonymous paths
 * @param requestPath
 */
var anonymousBootstrap = function anonymousBootstrap(requestPath) {
    var anonymousPaths = ["require-reset-password", "reset-password", "change-password", "complete-profile", "register", "emailconfirmed"];
    return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["some"])(anonymousPaths, function (path) {
        return requestPath.indexOf(path) !== -1;
    });
};

/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/app.less":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "body{font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:14px;font-weight:400;background-color:#454545}md-content,md-content.md-default-theme{background-color:transparent}md-checkbox .md-icon{top:2px;left:2px;width:16px;height:16px}md-checkbox.md-checked .md-icon:after{top:-2px;left:3px;border-color:#fff}md-radio-button .md-icon{top:2px;left:2px;width:16px;height:16px}.b-padding0{padding:0}.b-padding8{padding:8px}.b-padding16{padding:16px}.b-margin0{margin:0}.b-margin8{margin:8px}.b-margin16{margin:16px}.b-marginN{margin:16px 0}.b-display-4{font-size:30px;font-weight:100;line-height:30px}.b-display-3,.k-window-title{font-size:18px;line-height:20px;padding:8px 0}.b-display-2{font-size:14px;font-weight:300;line-height:16px;padding:8px 0;text-transform:uppercase}.b-display-2.actions{color:#3292d3;display:block;white-space:nowrap}.b-display-1{font-size:12px;line-height:13px;padding:8px 0;text-transform:uppercase}.b-headline{font-size:16px;line-height:18px;padding:8px 0;font-weight:600}.b-caption{font-size:11px;line-height:13px;padding:8px 0}.b-label{color:rgba(0,0,0,.5)}.b-body-1,.b-body-2,.b-label{font-size:14px;line-height:16px;padding:8px 0}.b-body-2{font-weight:600}.b-body-3{font-size:14px;line-height:16px;padding:8px 0;color:#3292d3}.b-breadcrumbs{font-size:18px;line-height:20px;padding:8px 0;font-weight:100}.b-breadcrumbs-selected{color:#3292d3}.b-chip{border:1px solid #999;border-radius:25px;font-size:11px;color:#000;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:2px 20px;margin:0 4px;text-align:center;box-sizing:border-box}.b-framed{border:1px solid #dfdfdf;color:#3292d3!important;box-shadow:none!important;background-color:hsla(0,0%,100%,.5)}.b-framed[disabled]{border:1px solid #dfdfdf;color:#ccc!important}.b-framed:not([disabled]):hover{color:#fff!important;background-color:rgba(0,0,0,.5)!important}.b-framed-on-dark{border:1px solid rgba(0,0,0,.5)!important;color:#fff!important;box-shadow:none!important;background-color:hsla(0,0%,100%,.5)}.b-framed-on-dark[disabled]{border:1px solid #dfdfdf;color:#dfdfdf!important}.b-framed-on-dark:not([disabled]):hover{color:#fff!important;background-color:rgba(0,0,0,.5)!important}.b-primary{color:#fff!important;background-color:#3292d3!important}.b-primary[disabled]{color:#ccc!important;background-color:#dfdfdf!important}.b-primary:not([disabled]):hover{color:#fff!important;background-color:rgba(0,0,0,.5)!important}.b-warn{color:#e84c3d!important}.b-warn[disabled]{color:#ccc!important}.b-warn:not([disabled]):hover{color:#000!important}button.b-button,input.b-button{border:1px solid #dfdfdf;line-height:36px;text-align:center;text-transform:uppercase;font-weight:500;font-size:inherit;font-style:inherit;font-variant:inherit;font-family:inherit;padding:3px 6px;border-radius:3px;outline:0;display:inline-block;-ms-flex-align:center;align-items:center;min-height:36px;background:inherit 0 0;white-space:nowrap;min-width:88px;text-decoration:none;overflow:hidden}.b-noback{background-color:transparent!important;box-shadow:none!important;border:0}.b-noback[disabled] md-icon{color:#000!important}.b-icon-on:not([disabled]):hover md-icon,.b-noback:not([disabled]):hover md-icon{color:#3292d3!important;fill:#3292d3!important}", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/beng-logs/beng-logs.less":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".beng-logs .settings{margin-bottom:16px}.beng-logs .settings md-divider{margin-top:10px}.k-animation-container .k-button{border:0}.brd-log-dialog-container{min-width:500px}.brd-log-dialog-container .change-password{margin-right:24px}.brd-log-password-container .title{padding-left:16px;padding-right:128px}.brd-log-dialog-container .log-mode,.brd-log-password-container .form{margin:16px;margin-left:24px}.brd-log-dialog-container .actions,.brd-log-password-container .actions{margin:16px}", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/capsule-manager-guide/capsuleManagerGuide.less":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "div#guideModalContainer{width:100%;height:100%;z-index:500;position:fixed;left:0;top:0;background-color:hsla(0,0%,72%,.5)}div#guideModal{width:20%;height:70%;position:absolute;left:45%;top:20%}button#questionBtn{background-color:#373737;color:hsla(0,0%,100%,.87)}button#questionBtn:hover{background-color:#6b6969;color:hsla(0,0%,100%,.87)}", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/capsule/capsule.less":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".configuration-table{border:1px solid #5a5a5a;background-color:#363636;color:#d5d5d5}#capsuleToolbar{background-color:#616263;color:hsla(0,0%,100%,.87)}#hierarchyGrid{width:98%;padding-left:1%}#progressLinear{z-index:50;position:fixed;top:0;left:0}#progressContainer{position:fixed;left:45%;z-index:50;top:45%}div#hierarchyOverlay{width:100%;height:100%;z-index:10;position:fixed;left:0;top:0;background-color:hsla(0,0%,72%,.5)}#hierarchySidenav{height:100%;width:25%;overflow-y:auto}", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/common/brd-form/brd-form.less":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/complete-profile/complete-profile.less":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".brd-complete-profile-container{background-color:#fff}", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/data-direct/data-direct.less":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".brd-dd-container{color:#fff}.brd-dd-input-passw{margin-left:5px;border:none;color:#fff;background-color:transparent}.brd-new-configuaration-input input{border-color:#fff;color:#fff}.brd-new-configuaration-input label{color:#fff}.brd-blue-text{color:#3292d3}.md-divider{border-top-color:hsla(0,0%,100%,.3);margin-top:10px}.configuration-table-header{background-color:#5a5a5a}.configuration-table{border:1px solid #5a5a5a;background-color:#363636;color:#d5d5d5}.configuration-note{font-style:italic}.configuration-note,.user-container{border:1px solid #5a5a5a;font-size:12px;border-radius:3px}.user-container{padding-left:10px;padding-top:5px}.uname-container{padding-left:5px}.brd-ita{font-style:italic}", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/email-confirmed/email-confirmed.less":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".brd-emailconfirmed-container{background-color:#fff}", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/hierarchy-controllers/hierarchyControllers.less":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".hierarchyBtn{background-color:#868686!important;border-radius:20px;width:80%}.hierarchyBtn:hover{background-color:#b3aeae!important}.toastClass{z-index:13;position:fixed;top:10px;right:5px}button#questionBtn{background-color:#373737;color:hsla(0,0%,100%,.87)}button#questionBtn:hover{background-color:#6b6969;color:hsla(0,0%,100%,.87)}", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/hierarchy-grid/hierarchyGrid.less":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".k-grid-footer,.k-grid-footer td,.k-grid-header,.k-grid-header .k-header,.k-grid .k-alt,.k-pager-numbers .k-state-selected,.k-pager-wrap,.k-scheduler-header,.km-pane-wrapper .k-grid-header .k-header,.sysAdminGridK{background-color:transparent}.k-gantt .k-treelist .k-alt.k-state-selected,.k-gantt .k-treelist .k-alt.k-state-selected>td,.k-gantt .k-treelist .k-state-selected,.k-gantt .k-treelist .k-state-selected td,.k-grid td.k-state-selected,.k-grid td.k-state-selected.k-state-focused,.k-grid td.k-state-selected:hover,.k-grid tr.k-state-selected,.k-grid tr.k-state-selected:hover td,.k-listview>.k-state-selected,.k-marquee-color,.k-scheduler-layout .k-state-selected,.k-scheduler .k-today.k-state-selected,.k-state-selected.k-line{background-color:#ecebe9;color:#454545}.k-grid td.k-state-selected,.k-grid tr.k-state-selected>td{border:0}.k-checkbox:checked+.k-checkbox-label:before,.k-checkbox:checked+.k-checkbox-label:hover:before,.k-checkbox:checked:hover+.k-checkbox-label:before{border-color:#4094d4}.k-checkbox:checked+.k-checkbox-label:before{background-color:transparent;border-color:#4094d4;color:#4094d4;font-weight:700;border-width:2px;border-radius:20%}md-icon.hierachyGridIcon{color:inherit!important}", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/hierarchy-modal/hierarchyModal.less":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "div#hierarchyModal{z-index:9;width:30%;height:60%;left:37%;position:fixed;background-color:#252525a6 a6;top:20%}div#hierarchyModalParent{z-index:9;OVERFLOW-Y:auto;height:80%;background-color:#373737}div#hierarchyModalControllers{position:absolute;bottom:1%;width:100%;background-color:#616263;color:#fff}#modalBtns{background-color:#868686;width:100%}.folderSelected{background-color:#ecebe9;color:#454545}", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/hierarchy-nav/hierarchySidenav.less":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".folderSelected{background-color:#ecebe9;color:#454545}", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/instance-settings/instance-settings.less":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "instance-settings .users-creation-form-container{border:1px solid #a9a9a9;padding:5px}instance-settings .data-direct-login-link{color:#fff}", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/layout/header/header.less":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("./node_modules/css-loader/lib/url/escape.js");
exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".brd-toolbar,.brd-toolbar md-toolbar{background-image:url(" + escape(__webpack_require__("./Content/background.svg")) + ");background-repeat:no-repeat;background-position:100%;background-color:#004288!important;font-family:Open Sans,Arial,Helvetica,sans-serif}.brd-toolbar-tools{padding-left:0!important}.brd-toolbar-title{font-size:24pt;color:#fff;font-weight:100}@media screen and (max-width:959px){.brd-toolbar-title{display:none}}.brd-toolbar-logo-container{background-color:#000;height:100%!important;width:63px!important}.brd-board-icon{fill:#fff!important}.brd-toolbar .brd-logo{width:307px;height:48px;margin:4px 0 0 16px}.brd-toolbar .brd-open-menu-button{background-color:#00428800 0;padding:0 8px;color:#fff;cursor:pointer}@media screen and (min-width:959px){.brd-open-menu-button.brd-small-menu-button{cursor:default}}.brd-toolbar .md-button.signout md-icon{width:16px;height:16px;min-height:16px;min-width:16px;color:#fff!important;fill:#fff!important;margin:4px 0 8px 8px}.brd-header-left{padding-left:10px;font-size:14px;color:#fff;font-family:Open Sans,Arial,Helvetica,sans-serif}", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/layout/sidenav/sidenav.less":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".cloudAdmin-sidenav{background-color:#373737;color:#fff;padding:8px}.cloudAdmin-sidenav md-list md-list-item.md-2-line .md-list-item-text h3{color:#fff;font-size:16px;text-transform:uppercase}.cloudAdmin-sidenav md-list md-list-item.md-2-line .md-list-item-text p{color:#8a8a8a;font-size:14px}.cloudAdmin-sidenav md-icon,.cloudAdmin-sidenav md-icon.md-default-theme{color:#fff}.cloudAdmin-sidenav md-list md-list-item.md-2-line{border-left:2px solid transparent}.cloudAdmin-sidenav md-list md-list-item.md-2-line:hover{border-left:2px solid #3292d3;color:#3292d3}.cloudAdmin-sidenav md-list md-list-item.md-2-line.active-state h3{color:#3292d3}.cloudAdmin-sidenav md-list md-list-item.md-2-line.active-state p{color:#fff}.cloudAdmin-sidenav md-list md-list-item.md-2-line.active-state md-icon{color:#3292d3}.cloudAdmin-sidenav md-list md-list-item.md-2-line.active-state{border-left:2px solid #3292d3}", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/register/register.less":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".brd-register-container{background-color:#fff}", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/require-reset-password/require-reset-password.less":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".brd-require-reset-passw-container{background-color:#fff}", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/reset-password/reset-password.less":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".brd-reset-passw-container{background-color:#fff}", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/shared-storage/shared-storage.less":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".shared-storage{color:#fff;font-family:Open Sans,Arial,Helvetica,sans-serif;font-weight:100}.brd-saskey-input-container{cursor:pointer}.brd-saskey-input{color:#3292d3}.brd-saskey-input-label{color:#fff}.brd-sas-examples{margin:0}.brd-sas-links,a:link,a:visited{color:#3292d3}a:hover{color:aqua}a:active{color:#3292d3}.brd-sas-p{margin:0;padding:0}.copy-key md-icon{margin-right:8px;color:#fff}", ""]);

// exports


/***/ }),

/***/ "./typings/board/Diagnostics.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventLogEntryType; });
var EventLogEntryType;
(function (EventLogEntryType) {
    EventLogEntryType[EventLogEntryType["Error"] = 1] = "Error";
    EventLogEntryType[EventLogEntryType["Warning"] = 2] = "Warning";
    EventLogEntryType[EventLogEntryType["Information"] = 4] = "Information";
    EventLogEntryType[EventLogEntryType["SuccessAudit"] = 8] = "SuccessAudit";
    EventLogEntryType[EventLogEntryType["FailureAudit"] = 16] = "FailureAudit";
})(EventLogEntryType || (EventLogEntryType = {}));

/***/ }),

/***/ "./typings/board/ServiceProcess.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServiceControllerStatus; });
var ServiceControllerStatus;
(function (ServiceControllerStatus) {
    ServiceControllerStatus[ServiceControllerStatus["ContinuePending"] = 5] = "ContinuePending";
    ServiceControllerStatus[ServiceControllerStatus["Paused"] = 7] = "Paused";
    ServiceControllerStatus[ServiceControllerStatus["PausePending"] = 6] = "PausePending";
    ServiceControllerStatus[ServiceControllerStatus["Running"] = 4] = "Running";
    ServiceControllerStatus[ServiceControllerStatus["StartPending"] = 2] = "StartPending";
    ServiceControllerStatus[ServiceControllerStatus["Stopped"] = 1] = "Stopped";
    ServiceControllerStatus[ServiceControllerStatus["StopPending"] = 3] = "StopPending";
})(ServiceControllerStatus || (ServiceControllerStatus = {}));

/***/ }),

/***/ "./typings/board/TaskScheduler.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DaysOfTheWeek; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MonthsOfTheYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TaskState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TaskTriggerType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return WhichWeek; });
var DaysOfTheWeek;
(function (DaysOfTheWeek) {
    DaysOfTheWeek[DaysOfTheWeek["Sunday"] = 1] = "Sunday";
    DaysOfTheWeek[DaysOfTheWeek["Monday"] = 2] = "Monday";
    DaysOfTheWeek[DaysOfTheWeek["Tuesday"] = 4] = "Tuesday";
    DaysOfTheWeek[DaysOfTheWeek["Wednesday"] = 8] = "Wednesday";
    DaysOfTheWeek[DaysOfTheWeek["Thursday"] = 16] = "Thursday";
    DaysOfTheWeek[DaysOfTheWeek["Friday"] = 32] = "Friday";
    DaysOfTheWeek[DaysOfTheWeek["Saturday"] = 64] = "Saturday";
    DaysOfTheWeek[DaysOfTheWeek["AllDays"] = 127] = "AllDays";
})(DaysOfTheWeek || (DaysOfTheWeek = {}));
var MonthsOfTheYear;
(function (MonthsOfTheYear) {
    MonthsOfTheYear[MonthsOfTheYear["January"] = 1] = "January";
    MonthsOfTheYear[MonthsOfTheYear["February"] = 2] = "February";
    MonthsOfTheYear[MonthsOfTheYear["March"] = 4] = "March";
    MonthsOfTheYear[MonthsOfTheYear["April"] = 8] = "April";
    MonthsOfTheYear[MonthsOfTheYear["May"] = 16] = "May";
    MonthsOfTheYear[MonthsOfTheYear["June"] = 32] = "June";
    MonthsOfTheYear[MonthsOfTheYear["July"] = 64] = "July";
    MonthsOfTheYear[MonthsOfTheYear["August"] = 128] = "August";
    MonthsOfTheYear[MonthsOfTheYear["September"] = 256] = "September";
    MonthsOfTheYear[MonthsOfTheYear["October"] = 512] = "October";
    MonthsOfTheYear[MonthsOfTheYear["November"] = 1024] = "November";
    MonthsOfTheYear[MonthsOfTheYear["December"] = 2048] = "December";
    MonthsOfTheYear[MonthsOfTheYear["AllMonths"] = 4095] = "AllMonths";
})(MonthsOfTheYear || (MonthsOfTheYear = {}));
var TaskState;
(function (TaskState) {
    TaskState[TaskState["Unknown"] = 0] = "Unknown";
    TaskState[TaskState["Disabled"] = 1] = "Disabled";
    TaskState[TaskState["Queued"] = 2] = "Queued";
    TaskState[TaskState["Ready"] = 3] = "Ready";
    TaskState[TaskState["Running"] = 4] = "Running";
})(TaskState || (TaskState = {}));
var TaskTriggerType;
(function (TaskTriggerType) {
    TaskTriggerType[TaskTriggerType["Event"] = 0] = "Event";
    TaskTriggerType[TaskTriggerType["Time"] = 1] = "Time";
    TaskTriggerType[TaskTriggerType["Daily"] = 2] = "Daily";
    TaskTriggerType[TaskTriggerType["Weekly"] = 3] = "Weekly";
    TaskTriggerType[TaskTriggerType["Monthly"] = 4] = "Monthly";
    TaskTriggerType[TaskTriggerType["MonthlyDOW"] = 5] = "MonthlyDOW";
    TaskTriggerType[TaskTriggerType["Idle"] = 6] = "Idle";
    TaskTriggerType[TaskTriggerType["Registration"] = 7] = "Registration";
    TaskTriggerType[TaskTriggerType["Boot"] = 8] = "Boot";
    TaskTriggerType[TaskTriggerType["Logon"] = 9] = "Logon";
    TaskTriggerType[TaskTriggerType["SessionStateChange"] = 11] = "SessionStateChange";
    TaskTriggerType[TaskTriggerType["Custom"] = 12] = "Custom";
})(TaskTriggerType || (TaskTriggerType = {}));
var WhichWeek;
(function (WhichWeek) {
    WhichWeek[WhichWeek["FirstWeek"] = 1] = "FirstWeek";
    WhichWeek[WhichWeek["SecondWeek"] = 2] = "SecondWeek";
    WhichWeek[WhichWeek["ThirdWeek"] = 4] = "ThirdWeek";
    WhichWeek[WhichWeek["FourthWeek"] = 8] = "FourthWeek";
    WhichWeek[WhichWeek["LastWeek"] = 16] = "LastWeek";
    WhichWeek[WhichWeek["AllWeeks"] = 31] = "AllWeeks";
})(WhichWeek || (WhichWeek = {}));

/***/ })

},["./app/index.ts"]);


// WEBPACK FOOTER //
// app.e7df1ceb7f8c8bd29a4a.js